/* WARNING: This file is auto-generated . Do not edit manually. */

import { DedicatedCloudOrderableIpBlockRangeEnum } from '../models/DedicatedCloudOrderableIpBlockRangeEnum';
import { OrderCartDomainPacksCreation } from '../models/OrderCartDomainPacksCreation';
import { DedicatedServerTrafficOrderEnum } from '../models/DedicatedServerTrafficOrderEnum';
import { TelephonySpecialNumberCountryEnum } from '../models/TelephonySpecialNumberCountryEnum';
import { DedicatedServerBackupStorageCapacityEnum } from '../models/DedicatedServerBackupStorageCapacityEnum';
import { OrderCartGenericProductCreation } from '../models/OrderCartGenericProductCreation';
import { TelephonyPortabilitySpecialNumberCategoryEnum } from '../models/TelephonyPortabilitySpecialNumberCategoryEnum';
import { TelephonyLineTypeEnum } from '../models/TelephonyLineTypeEnum';
import { EmailExchangeOvhLicenceEnum } from '../models/EmailExchangeOvhLicenceEnum';
import { OrderCartItem } from '../models/OrderCartItem';
import { OverTheBoxShippingMethodEnum } from '../models/OverTheBoxShippingMethodEnum';
import { OrderOrder } from '../models/OrderOrder';
import { TelephonySecurityDepositAmountsEnum } from '../models/TelephonySecurityDepositAmountsEnum';
import { HostingWebOrderMxPlanEnum } from '../models/HostingWebOrderMxPlanEnum';
import { HostingWebDatabaseSqlPersoOfferEnum } from '../models/HostingWebDatabaseSqlPersoOfferEnum';
import { DedicatedServerUsbKeyCapacityEnum } from '../models/DedicatedServerUsbKeyCapacityEnum';
import { OrderCatalogDedicatedCatalog } from '../models/OrderCatalogDedicatedCatalog';
import { DedicatedServerBandwidthOrderEnum } from '../models/DedicatedServerBandwidthOrderEnum';
import { OrderCartGenericOptionDefinition } from '../models/OrderCartGenericOptionDefinition';
import { VpsAdditionalDiskAdditionalDiskSizeEnum } from '../models/VpsAdditionalDiskAdditionalDiskSizeEnum';
import { LicenseWindowsOsVersionEnum } from '../models/LicenseWindowsOsVersionEnum';
import { LicenseLicenseTypeEnum } from '../models/LicenseLicenseTypeEnum';
import { TelephonyPortabilitySocialReason } from '../models/TelephonyPortabilitySocialReason';
import { TelephonyPortabilityCountriesAvailable } from '../models/TelephonyPortabilityCountriesAvailable';
import { OrderCartCreation } from '../models/OrderCartCreation';
import { HostingWebBandwidthOfferEnum } from '../models/HostingWebBandwidthOfferEnum';
import { TelephonyNumberSpecialTypologyEnum } from '../models/TelephonyNumberSpecialTypologyEnum';
import { LicenseWindowsSqlVersionEnum } from '../models/LicenseWindowsSqlVersionEnum';
import { LicenseOrderableAntivirusEnum } from '../models/LicenseOrderableAntivirusEnum';
import { OrderCatalogPublicCatalog } from '../models/OrderCatalogPublicCatalog';
import { OrderCartGenericDomainOptionsCreation } from '../models/OrderCartGenericDomainOptionsCreation';
import { TelephonyNumberOffer } from '../models/TelephonyNumberOffer';
import { LicenseOrderableCpanelVersionEnum } from '../models/LicenseOrderableCpanelVersionEnum';
import { OrderCartGenericDomainCreation } from '../models/OrderCartGenericDomainCreation';
import { OrderCartGenericOptionCreation } from '../models/OrderCartGenericOptionCreation';
import { HostingWebCdnOfferEnum } from '../models/HostingWebCdnOfferEnum';
import { OrderCartUpdate } from '../models/OrderCartUpdate';
import { OrderCartCart } from '../models/OrderCartCart';
import { HostingWebModuleOrderableNameEnum } from '../models/HostingWebModuleOrderableNameEnum';
import { LicenseOrderableAntispamEnum } from '../models/LicenseOrderableAntispamEnum';
import { HostingPrivateDatabaseOfferEnum } from '../models/HostingPrivateDatabaseOfferEnum';
import { DedicatedCloudRessourcesUpgradeTypeEnum } from '../models/DedicatedCloudRessourcesUpgradeTypeEnum';
import { TelephonyNumberPoolEnum } from '../models/TelephonyNumberPoolEnum';
import { VpsPleskLicenseDomainNumberEnum } from '../models/VpsPleskLicenseDomainNumberEnum';
import { HostingWebDnsZoneEnum } from '../models/HostingWebDnsZoneEnum';
import { LicensePleskVersionEnum } from '../models/LicensePleskVersionEnum';
import { OrderCartGenericDedicatedOptionsCreation } from '../models/OrderCartGenericDedicatedOptionsCreation';
import { LicenseOrderablePleskLanguagePackEnum } from '../models/LicenseOrderablePleskLanguagePackEnum';
import { OrderCartCheckout } from '../models/OrderCartCheckout';
import { HostingPrivateDatabaseAvailableRamSizeEnum } from '../models/HostingPrivateDatabaseAvailableRamSizeEnum';
import { OrderCartGenericDedicatedCreation } from '../models/OrderCartGenericDedicatedCreation';
import { LicenseCloudLinuxVersionEnum } from '../models/LicenseCloudLinuxVersionEnum';
import { DedicatedServerFirewallModelEnum } from '../models/DedicatedServerFirewallModelEnum';
import { OrderCartCouponCreation } from '../models/OrderCartCouponCreation';
import { LicenseOrderableVirtuozzoVersionEnum } from '../models/LicenseOrderableVirtuozzoVersionEnum';
import { CdnanycastOrderCacheRuleEnum } from '../models/CdnanycastOrderCacheRuleEnum';
import { OrderCartDomainPacksProductInformation } from '../models/OrderCartDomainPacksProductInformation';
import { EmailExchangeAccountQuotaEnum } from '../models/EmailExchangeAccountQuotaEnum';
import { OrderCartConfigurationItem } from '../models/OrderCartConfigurationItem';
import { TelephonyNumberCountryEnum } from '../models/TelephonyNumberCountryEnum';
import { NichandleOvhSubsidiaryEnum } from '../models/NichandleOvhSubsidiaryEnum';
import { DedicatedServerOrderableSysFeatureEnum } from '../models/DedicatedServerOrderableSysFeatureEnum';
import { OrderCatalogPublicDedicatedServerCatalog } from '../models/OrderCatalogPublicDedicatedServerCatalog';
import { LicenseOrderableVirtuozzoContainerNumberEnum } from '../models/LicenseOrderableVirtuozzoContainerNumberEnum';
import { LicenseOrderablePleskDomainNumberEnum } from '../models/LicenseOrderablePleskDomainNumberEnum';
import { DedicatedServerBandwidthvRackOrderEnum } from '../models/DedicatedServerBandwidthvRackOrderEnum';
import { TelephonyPortabilityNumberType } from '../models/TelephonyPortabilityNumberType';
import { EmailDomainOfferEnum } from '../models/EmailDomainOfferEnum';
import { DedicatedCloudRessourcesUpgradeRessourceTypeEnum } from '../models/DedicatedCloudRessourcesUpgradeRessourceTypeEnum';
import { OrderCartConfigurationRequirements } from '../models/OrderCartConfigurationRequirements';
import { TelephonyPortabilityOfferType } from '../models/TelephonyPortabilityOfferType';
import { OrderCartItemUpdate } from '../models/OrderCartItemUpdate';
import { LicensePleskApplicationSetEnum } from '../models/LicensePleskApplicationSetEnum';
import { DedicatedCloudIpCountriesEnum } from '../models/DedicatedCloudIpCountriesEnum';
import { OrderCartItemConfigurationCreation } from '../models/OrderCartItemConfigurationCreation';
import { EmailExchangeOutlookVersionEnum } from '../models/EmailExchangeOutlookVersionEnum';
import { FreefaxQuantityEnum } from '../models/FreefaxQuantityEnum';
import { LicenseSqlServerVersionEnum } from '../models/LicenseSqlServerVersionEnum';
import { HostingPrivateDatabaseOrderableVersionEnum } from '../models/HostingPrivateDatabaseOrderableVersionEnum';
import { VeeamCloudConnectOffer } from '../models/VeeamCloudConnectOffer';
import { DedicatedCloudAdditionalBandwidthEnum } from '../models/DedicatedCloudAdditionalBandwidthEnum';
import { OrderCartGenericProductDefinition } from '../models/OrderCartGenericProductDefinition';
import { LicenseWorkLightVersionEnum } from '../models/LicenseWorkLightVersionEnum';
import { DedicatedServerBandwidthOrderTypeEnum } from '../models/DedicatedServerBandwidthOrderTypeEnum';
import { HostingPrivateDatabaseDatacenterEnum } from '../models/HostingPrivateDatabaseDatacenterEnum';
import { LicenseOrderableDirectAdminVersionEnum } from '../models/LicenseOrderableDirectAdminVersionEnum';
import { NichandleLegalFormEnum } from '../models/NichandleLegalFormEnum';
import { HostingWebOfferEnum } from '../models/HostingWebOfferEnum';
import { OrderCartProductInformation } from '../models/OrderCartProductInformation';
import { OrderCatalogPrivateCloudCatalog } from '../models/OrderCatalogPrivateCloudCatalog';
import { OrderUpgradeOperationAndOrder } from '../models/OrderUpgradeOperationAndOrder';
import { OrderCatalogCatalog } from '../models/OrderCatalogCatalog';
import { OrderCatalogPccCatalog } from '../models/OrderCatalogPccCatalog';
import { SmsChannelEnum } from '../models/SmsChannelEnum';
import { CdnanycastOrderQuotaEnum } from '../models/CdnanycastOrderQuotaEnum';
import OVHBase from '../ovh';

class OrderHandler {
  ovh: OVHBase;

  constructor(ovh: OVHBase) {
    this.ovh = ovh;
  }

  /** List of your OVH order carts */
  listCart = (): Promise<string[]> => {
    return this.ovh.request('GET', '/order/cart');
  };

  /** Create a new OVH order cart */
  createCart = (body: OrderCartCreation): Promise<OrderCartCart> => {
    return this.ovh.request('POST', '/order/cart', body);
  };

  /** Delete a cart */
  deleteCartByCartId = (cartId: string): Promise<void> => {
    return this.ovh.request('DELETE', `/order/cart/${cartId}`);
  };

  /** Retrieve information about a specific cart */
  getCartByCartId = (cartId: string): Promise<OrderCartCart> => {
    return this.ovh.request('GET', `/order/cart/${cartId}`);
  };

  /** Modify information about a specific cart */
  putCartByCartId = (cartId: string, body: OrderCartUpdate): Promise<OrderCartCart> => {
    return this.ovh.request('PUT', `/order/cart/${cartId}`, body);
  };

  /** Get informations about analytics offers */
  getCartAnalyticsByCartId = (cartId: string): Promise<OrderCartGenericProductDefinition[]> => {
    return this.ovh.request('GET', `/order/cart/${cartId}/analytics`);
  };

  /** Post a new analytics item in your cart */
  postCartAnalyticsByCartId = (
    cartId: string,
    body: OrderCartGenericProductCreation
  ): Promise<OrderCartItem> => {
    return this.ovh.request('POST', `/order/cart/${cartId}/analytics`, body);
  };

  /** Get informations about analytics options */
  getCartAnalyticsOptionsByCartId = (
    cartId: string
  ): Promise<OrderCartGenericOptionDefinition[]> => {
    return this.ovh.request('GET', `/order/cart/${cartId}/analytics/options`);
  };

  /** Post a new analytics addon in your cart */
  postCartAnalyticsOptionsByCartId = (
    cartId: string,
    body: OrderCartGenericOptionCreation
  ): Promise<OrderCartItem> => {
    return this.ovh.request('POST', `/order/cart/${cartId}/analytics/options`, body);
  };

  /** Get informations about Anthos offers */
  getCartAnthosByCartId = (cartId: string): Promise<OrderCartGenericProductDefinition[]> => {
    return this.ovh.request('GET', `/order/cart/${cartId}/anthos`);
  };

  /** Post a new Anthos item in your cart */
  postCartAnthosByCartId = (
    cartId: string,
    body: OrderCartGenericProductCreation
  ): Promise<OrderCartItem> => {
    return this.ovh.request('POST', `/order/cart/${cartId}/anthos`, body);
  };

  /** Get informations about Anthos options */
  getCartAnthosOptionsByCartId = (cartId: string): Promise<OrderCartGenericOptionDefinition[]> => {
    return this.ovh.request('GET', `/order/cart/${cartId}/anthos/options`);
  };

  /** Post a new Anthos option in your cart */
  postCartAnthosOptionsByCartId = (
    cartId: string,
    body: OrderCartGenericOptionCreation
  ): Promise<OrderCartItem> => {
    return this.ovh.request('POST', `/order/cart/${cartId}/anthos/options`, body);
  };

  /** Assign a shopping cart to an loggedin client */
  postCartAssignByCartId = (cartId: string): Promise<void> => {
    return this.ovh.request('POST', `/order/cart/${cartId}/assign`);
  };

  /** Get informations about a baremetal server */
  getCartBaremetalServersByCartId = (
    cartId: string
  ): Promise<OrderCartGenericProductDefinition[]> => {
    return this.ovh.request('GET', `/order/cart/${cartId}/baremetalServers`);
  };

  /** Post a new baremetal server item in your cart */
  postCartBaremetalServersByCartId = (
    cartId: string,
    body: OrderCartGenericProductCreation
  ): Promise<OrderCartItem> => {
    return this.ovh.request('POST', `/order/cart/${cartId}/baremetalServers`, body);
  };

  /** Get informations about baremetal server options */
  getCartBaremetalServersOptionsByCartId = (
    cartId: string
  ): Promise<OrderCartGenericOptionDefinition[]> => {
    return this.ovh.request('GET', `/order/cart/${cartId}/baremetalServers/options`);
  };

  /** Post a new baremetal server option in your cart */
  postCartBaremetalServersOptionsByCartId = (
    cartId: string,
    body: OrderCartGenericOptionCreation
  ): Promise<OrderCartItem> => {
    return this.ovh.request('POST', `/order/cart/${cartId}/baremetalServers/options`, body);
  };

  /** Get information about bring your own IP addresses offers */
  getCartBringYourOwnIpByCartId = (
    cartId: string
  ): Promise<OrderCartGenericProductDefinition[]> => {
    return this.ovh.request('GET', `/order/cart/${cartId}/bringYourOwnIp`);
  };

  /** Post a new bring your own IP addresses item in your cart */
  postCartBringYourOwnIpByCartId = (
    cartId: string,
    body: OrderCartGenericProductCreation
  ): Promise<OrderCartItem> => {
    return this.ovh.request('POST', `/order/cart/${cartId}/bringYourOwnIp`, body);
  };

  /** Get informations about CDN offers */
  getCartCdnByCartId = (cartId: string): Promise<OrderCartGenericProductDefinition[]> => {
    return this.ovh.request('GET', `/order/cart/${cartId}/cdn`);
  };

  /** Post a new CDN item in your cart */
  postCartCdnByCartId = (
    cartId: string,
    body: OrderCartGenericProductCreation
  ): Promise<OrderCartItem> => {
    return this.ovh.request('POST', `/order/cart/${cartId}/cdn`, body);
  };

  /** Get informations about CDN options */
  getCartCdnOptionsByCartId = (cartId: string): Promise<OrderCartGenericOptionDefinition[]> => {
    return this.ovh.request('GET', `/order/cart/${cartId}/cdn/options`);
  };

  /** Post a new CDN option in your cart */
  postCartCdnOptionsByCartId = (
    cartId: string,
    body: OrderCartGenericOptionCreation
  ): Promise<OrderCartItem> => {
    return this.ovh.request('POST', `/order/cart/${cartId}/cdn/options`, body);
  };

  /** Get informations about Ceph as a Service offers */
  getCartCephaasByCartId = (cartId: string): Promise<OrderCartGenericProductDefinition[]> => {
    return this.ovh.request('GET', `/order/cart/${cartId}/cephaas`);
  };

  /** Post a new Ceph as a Service item in your cart */
  postCartCephaasByCartId = (
    cartId: string,
    body: OrderCartGenericProductCreation
  ): Promise<OrderCartItem> => {
    return this.ovh.request('POST', `/order/cart/${cartId}/cephaas`, body);
  };

  /** Get informations about Ceph as a Service options */
  getCartCephaasOptionsByCartId = (cartId: string): Promise<OrderCartGenericOptionDefinition[]> => {
    return this.ovh.request('GET', `/order/cart/${cartId}/cephaas/options`);
  };

  /** Post a new Ceph as a Service option in your cart */
  postCartCephaasOptionsByCartId = (
    cartId: string,
    body: OrderCartGenericOptionCreation
  ): Promise<OrderCartItem> => {
    return this.ovh.request('POST', `/order/cart/${cartId}/cephaas/options`, body);
  };

  /** Get prices and contracts information for your cart */
  getCartCheckoutByCartId = (cartId: string): Promise<OrderOrder> => {
    return this.ovh.request('GET', `/order/cart/${cartId}/checkout`);
  };

  /** Validate your shopping and create order */
  validateCartCheckoutByCartId = (cartId: string, body: OrderCartCheckout): Promise<OrderOrder> => {
    return this.ovh.request('POST', `/order/cart/${cartId}/checkout`, body);
  };

  /** Get informations about Public Cloud offers */
  getCartCloudByCartId = (cartId: string): Promise<OrderCartGenericProductDefinition[]> => {
    return this.ovh.request('GET', `/order/cart/${cartId}/cloud`);
  };

  /** Post a new Public Cloud item in your cart */
  postCartCloudByCartId = (
    cartId: string,
    body: OrderCartGenericProductCreation
  ): Promise<OrderCartItem> => {
    return this.ovh.request('POST', `/order/cart/${cartId}/cloud`, body);
  };

  /** Get informations about Public Cloud options */
  getCartCloudOptionsByCartId = (cartId: string): Promise<OrderCartGenericOptionDefinition[]> => {
    return this.ovh.request('GET', `/order/cart/${cartId}/cloud/options`);
  };

  /** Post a new Public Cloud option in your cart */
  postCartCloudOptionsByCartId = (
    cartId: string,
    body: OrderCartGenericOptionCreation
  ): Promise<OrderCartItem> => {
    return this.ovh.request('POST', `/order/cart/${cartId}/cloud/options`, body);
  };

  /** Get all cloud db offers available */
  getCartCloudDBByCartId = (cartId: string): Promise<OrderCartGenericProductDefinition[]> => {
    return this.ovh.request('GET', `/order/cart/${cartId}/cloudDB`);
  };

  /** Add a cloudDB in your cart */
  addCartCloudDBByCartId = (
    cartId: string,
    body: OrderCartGenericProductCreation
  ): Promise<OrderCartItem> => {
    return this.ovh.request('POST', `/order/cart/${cartId}/cloudDB`, body);
  };

  /** Get informations about Cloud Web offers */
  getCartCloudwebByCartId = (cartId: string): Promise<OrderCartGenericProductDefinition[]> => {
    return this.ovh.request('GET', `/order/cart/${cartId}/cloudweb`);
  };

  /** Post a new Cloud Web item in your cart */
  postCartCloudwebByCartId = (
    cartId: string,
    body: OrderCartGenericProductCreation
  ): Promise<OrderCartItem> => {
    return this.ovh.request('POST', `/order/cart/${cartId}/cloudweb`, body);
  };

  /** Get informations about Cloud Web options */
  getCartCloudwebOptionsByCartId = (
    cartId: string
  ): Promise<OrderCartGenericOptionDefinition[]> => {
    return this.ovh.request('GET', `/order/cart/${cartId}/cloudweb/options`);
  };

  /** Post a new Cloud Web option in your cart */
  postCartCloudwebOptionsByCartId = (
    cartId: string,
    body: OrderCartGenericOptionCreation
  ): Promise<OrderCartItem> => {
    return this.ovh.request('POST', `/order/cart/${cartId}/cloudweb/options`, body);
  };

  /** Delete a coupon from cart */
  deleteCartCouponByCartId = (cartId: string): Promise<void> => {
    return this.ovh.request('DELETE', `/order/cart/${cartId}/coupon`);
  };

  /** Retrieve coupons associated to cart */
  getCartCouponByCartId = (cartId: string): Promise<string[]> => {
    return this.ovh.request('GET', `/order/cart/${cartId}/coupon`);
  };

  /** Add a new coupon to cart */
  addCartCouponByCartId = (cartId: string, body: OrderCartCouponCreation): Promise<string[]> => {
    return this.ovh.request('POST', `/order/cart/${cartId}/coupon`, body);
  };

  /** Get informations about SaaS CSP2 offers */
  getCartCsp2ByCartId = (cartId: string): Promise<OrderCartGenericProductDefinition[]> => {
    return this.ovh.request('GET', `/order/cart/${cartId}/csp2`);
  };

  /** Post a new SaaS CSP2 offer item in your cart */
  postCartCsp2ByCartId = (
    cartId: string,
    body: OrderCartGenericProductCreation
  ): Promise<OrderCartItem> => {
    return this.ovh.request('POST', `/order/cart/${cartId}/csp2`, body);
  };

  /** Get informations about SaaS CSP2 options */
  getCartCsp2OptionsByCartId = (cartId: string): Promise<OrderCartGenericOptionDefinition[]> => {
    return this.ovh.request('GET', `/order/cart/${cartId}/csp2/options`);
  };

  /** Post a new SaaS CSP2 option in your cart */
  postCartCsp2OptionsByCartId = (
    cartId: string,
    body: OrderCartGenericOptionCreation
  ): Promise<OrderCartItem> => {
    return this.ovh.request('POST', `/order/cart/${cartId}/csp2/options`, body);
  };

  /** Get informations about a timeseries offer */
  getCartDbaasTimeseriesByCartId = (
    cartId: string
  ): Promise<OrderCartGenericProductDefinition[]> => {
    return this.ovh.request('GET', `/order/cart/${cartId}/dbaasTimeseries`);
  };

  /** Post a new timeseries offer item in your cart */
  postCartDbaasTimeseriesByCartId = (
    cartId: string,
    body: OrderCartGenericProductCreation
  ): Promise<OrderCartItem> => {
    return this.ovh.request('POST', `/order/cart/${cartId}/dbaasTimeseries`, body);
  };

  /** Get informations about a dedicated server */
  getCartDedicatedByCartId = (cartId: string): Promise<OrderCartGenericProductDefinition[]> => {
    return this.ovh.request('GET', `/order/cart/${cartId}/dedicated`);
  };

  /** Post a new dedicated server item in your cart */
  postCartDedicatedByCartId = (
    cartId: string,
    body: OrderCartGenericDedicatedCreation
  ): Promise<OrderCartItem> => {
    return this.ovh.request('POST', `/order/cart/${cartId}/dedicated`, body);
  };

  /** Get informations about dedicated server options */
  getCartDedicatedOptionsByCartId = (
    cartId: string
  ): Promise<OrderCartGenericOptionDefinition[]> => {
    return this.ovh.request('GET', `/order/cart/${cartId}/dedicated/options`);
  };

  /** Post a new dedicated server option in your cart */
  postCartDedicatedOptionsByCartId = (
    cartId: string,
    body: OrderCartGenericDedicatedOptionsCreation
  ): Promise<OrderCartItem> => {
    return this.ovh.request('POST', `/order/cart/${cartId}/dedicated/options`, body);
  };

  /** Get informations about a dedicated server */
  getCartDedicatedCloudByCartId = (
    cartId: string
  ): Promise<OrderCartGenericProductDefinition[]> => {
    return this.ovh.request('GET', `/order/cart/${cartId}/dedicatedCloud`);
  };

  /** Post a new dedicated server item in your cart */
  postCartDedicatedCloudByCartId = (
    cartId: string,
    body: OrderCartGenericDedicatedCreation
  ): Promise<OrderCartItem> => {
    return this.ovh.request('POST', `/order/cart/${cartId}/dedicatedCloud`, body);
  };

  /** Get informations about dedicated server options */
  getCartDedicatedCloudOptionsByCartId = (
    cartId: string
  ): Promise<OrderCartGenericOptionDefinition[]> => {
    return this.ovh.request('GET', `/order/cart/${cartId}/dedicatedCloud/options`);
  };

  /** Post a new dedicated server option in your cart */
  postCartDedicatedCloudOptionsByCartId = (
    cartId: string,
    body: OrderCartGenericDedicatedOptionsCreation
  ): Promise<OrderCartItem> => {
    return this.ovh.request('POST', `/order/cart/${cartId}/dedicatedCloud/options`, body);
  };

  /** Get informations about a dedicated Direct Sales server */
  getCartDedicatedDirectSalesByCartId = (
    cartId: string
  ): Promise<OrderCartGenericProductDefinition[]> => {
    return this.ovh.request('GET', `/order/cart/${cartId}/dedicatedDirectSales`);
  };

  /** Post a new dedicated Direct Sales server item in your cart */
  postCartDedicatedDirectSalesByCartId = (
    cartId: string,
    body: { duration: string; planCode: string; pricingMode: string; quantity: number }
  ): Promise<OrderCartItem> => {
    return this.ovh.request('POST', `/order/cart/${cartId}/dedicatedDirectSales`, body);
  };

  /** Get informations about dedicated Direct Sales server options */
  getCartDedicatedDirectSalesOptionsByCartId = (
    cartId: string
  ): Promise<OrderCartGenericOptionDefinition[]> => {
    return this.ovh.request('GET', `/order/cart/${cartId}/dedicatedDirectSales/options`);
  };

  /** Post a new dedicated Direct Sales server option in your cart */
  postCartDedicatedDirectSalesOptionsByCartId = (
    cartId: string,
    body: {
      duration: string;
      itemId: number;
      planCode: string;
      pricingMode: string;
      quantity: number;
    }
  ): Promise<OrderCartItem> => {
    return this.ovh.request('POST', `/order/cart/${cartId}/dedicatedDirectSales/options`, body);
  };

  /** Get informations about a dedicated labs server */
  getCartDedicatedLabsByCartId = (cartId: string): Promise<OrderCartGenericProductDefinition[]> => {
    return this.ovh.request('GET', `/order/cart/${cartId}/dedicatedLabs`);
  };

  /** Post a new dedicated labs server item in your cart */
  postCartDedicatedLabsByCartId = (
    cartId: string,
    body: OrderCartGenericProductCreation
  ): Promise<OrderCartItem> => {
    return this.ovh.request('POST', `/order/cart/${cartId}/dedicatedLabs`, body);
  };

  /** Get informations about dedicated labs server options */
  getCartDedicatedLabsOptionsByCartId = (
    cartId: string
  ): Promise<OrderCartGenericOptionDefinition[]> => {
    return this.ovh.request('GET', `/order/cart/${cartId}/dedicatedLabs/options`);
  };

  /** Post a new dedicated labs server option in your cart */
  postCartDedicatedLabsOptionsByCartId = (
    cartId: string,
    body: OrderCartGenericOptionCreation
  ): Promise<OrderCartItem> => {
    return this.ovh.request('POST', `/order/cart/${cartId}/dedicatedLabs/options`, body);
  };

  /** Get information about dedicatedLegacy */
  getCartDedicatedLegacyByCartId = (
    cartId: string
  ): Promise<OrderCartGenericProductDefinition[]> => {
    return this.ovh.request('GET', `/order/cart/${cartId}/dedicatedLegacy`);
  };

  /** Post a new dedicatedLegacy item in your cart */
  postCartDedicatedLegacyByCartId = (
    cartId: string,
    body: OrderCartGenericProductCreation
  ): Promise<OrderCartItem> => {
    return this.ovh.request('POST', `/order/cart/${cartId}/dedicatedLegacy`, body);
  };

  /** Get information about the options of Ovh offers */
  getCartDedicatedLegacyOptionsByCartId = (
    cartId: string
  ): Promise<OrderCartGenericOptionDefinition[]> => {
    return this.ovh.request('GET', `/order/cart/${cartId}/dedicatedLegacy/options`);
  };

  /** Post a new Ovh option in your cart */
  postCartDedicatedLegacyOptionsByCartId = (
    cartId: string,
    body: OrderCartGenericOptionCreation
  ): Promise<OrderCartItem> => {
    return this.ovh.request('POST', `/order/cart/${cartId}/dedicatedLegacy/options`, body);
  };

  /** Get informations about a dedicated server */
  getCartDedicatedPciVpsByCartId = (
    cartId: string
  ): Promise<OrderCartGenericProductDefinition[]> => {
    return this.ovh.request('GET', `/order/cart/${cartId}/dedicatedPciVps`);
  };

  /** Post a new dedicated server item in your cart */
  postCartDedicatedPciVpsByCartId = (
    cartId: string,
    body: OrderCartGenericDedicatedCreation
  ): Promise<OrderCartItem> => {
    return this.ovh.request('POST', `/order/cart/${cartId}/dedicatedPciVps`, body);
  };

  /** Get informations about dedicated server options */
  getCartDedicatedPciVpsOptionsByCartId = (
    cartId: string
  ): Promise<OrderCartGenericOptionDefinition[]> => {
    return this.ovh.request('GET', `/order/cart/${cartId}/dedicatedPciVps/options`);
  };

  /** Post a new dedicated server option in your cart */
  postCartDedicatedPciVpsOptionsByCartId = (
    cartId: string,
    body: OrderCartGenericDedicatedOptionsCreation
  ): Promise<OrderCartItem> => {
    return this.ovh.request('POST', `/order/cart/${cartId}/dedicatedPciVps/options`, body);
  };

  /** Get informations about a dedicated server for US Reseller */
  getCartDedicatedResellerByCartId = (
    cartId: string
  ): Promise<OrderCartGenericProductDefinition[]> => {
    return this.ovh.request('GET', `/order/cart/${cartId}/dedicatedReseller`);
  };

  /** Post a new dedicated server item in your cart */
  postCartDedicatedResellerByCartId = (
    cartId: string,
    body: { duration: string; planCode: string; pricingMode: string; quantity: number }
  ): Promise<OrderCartItem> => {
    return this.ovh.request('POST', `/order/cart/${cartId}/dedicatedReseller`, body);
  };

  /** Get informations about dedicated server options */
  getCartDedicatedResellerOptionsByCartId = (
    cartId: string
  ): Promise<OrderCartGenericOptionDefinition[]> => {
    return this.ovh.request('GET', `/order/cart/${cartId}/dedicatedReseller/options`);
  };

  /** Post a new dedicated server option in your cart */
  postCartDedicatedResellerOptionsByCartId = (
    cartId: string,
    body: {
      duration: string;
      itemId: number;
      planCode: string;
      pricingMode: string;
      quantity: number;
    }
  ): Promise<OrderCartItem> => {
    return this.ovh.request('POST', `/order/cart/${cartId}/dedicatedReseller/options`, body);
  };

  /** Get informations about Desk As A Service offers */
  getCartDeskaasByCartId = (cartId: string): Promise<OrderCartGenericProductDefinition[]> => {
    return this.ovh.request('GET', `/order/cart/${cartId}/deskaas`);
  };

  /** Post a new Desk as a service item in your cart */
  postCartDeskaasByCartId = (
    cartId: string,
    body: OrderCartGenericProductCreation
  ): Promise<OrderCartItem> => {
    return this.ovh.request('POST', `/order/cart/${cartId}/deskaas`, body);
  };

  /** Get informations about Dedicated Discover server offers */
  getCartDiscoverByCartId = (cartId: string): Promise<OrderCartGenericProductDefinition[]> => {
    return this.ovh.request('GET', `/order/cart/${cartId}/discover`);
  };

  /** Post a new Dedicated Discover server item in your cart */
  postCartDiscoverByCartId = (
    cartId: string,
    body: OrderCartGenericProductCreation
  ): Promise<OrderCartItem> => {
    return this.ovh.request('POST', `/order/cart/${cartId}/discover`, body);
  };

  /** Get informations about Dedicated Discover server options */
  getCartDiscoverOptionsByCartId = (
    cartId: string
  ): Promise<OrderCartGenericOptionDefinition[]> => {
    return this.ovh.request('GET', `/order/cart/${cartId}/discover/options`);
  };

  /** Post a new Dedicated Discover server option in your cart */
  postCartDiscoverOptionsByCartId = (
    cartId: string,
    body: OrderCartGenericOptionCreation
  ): Promise<OrderCartItem> => {
    return this.ovh.request('POST', `/order/cart/${cartId}/discover/options`, body);
  };

  /** Get informations about DNS zone offer */
  getCartDnsByCartId = (cartId: string): Promise<OrderCartGenericProductDefinition[]> => {
    return this.ovh.request('GET', `/order/cart/${cartId}/dns`);
  };

  /** Post a new DNS zone item in your cart */
  postCartDnsByCartId = (
    cartId: string,
    body: OrderCartGenericProductCreation
  ): Promise<OrderCartItem> => {
    return this.ovh.request('POST', `/order/cart/${cartId}/dns`, body);
  };

  /** Get informations about DNS options */
  getCartDnsOptionsByCartId = (cartId: string): Promise<OrderCartGenericOptionDefinition[]> => {
    return this.ovh.request('GET', `/order/cart/${cartId}/dns/options`);
  };

  /** Post a new DNS option in your cart */
  postCartDnsOptionsByCartId = (
    cartId: string,
    body: OrderCartGenericOptionCreation
  ): Promise<OrderCartItem> => {
    return this.ovh.request('POST', `/order/cart/${cartId}/dns/options`, body);
  };

  /** Get informations about a domain name */
  getCartDomainByCartId = (cartId: string): Promise<OrderCartProductInformation[]> => {
    return this.ovh.request('GET', `/order/cart/${cartId}/domain`);
  };

  /** Post a new domain in your cart */
  postCartDomainByCartId = (
    cartId: string,
    body: OrderCartGenericDomainCreation
  ): Promise<OrderCartItem> => {
    return this.ovh.request('POST', `/order/cart/${cartId}/domain`, body);
  };

  /** Get informations about domain names options */
  getCartDomainOptionsByCartId = (cartId: string): Promise<OrderCartGenericOptionDefinition[]> => {
    return this.ovh.request('GET', `/order/cart/${cartId}/domain/options`);
  };

  /** Post a new domain name option in your cart */
  postCartDomainOptionsByCartId = (
    cartId: string,
    body: OrderCartGenericDomainOptionsCreation
  ): Promise<OrderCartItem> => {
    return this.ovh.request('POST', `/order/cart/${cartId}/domain/options`, body);
  };

  /** Get informations about Domain packs offers (AllDom) */
  getCartDomainPacksByCartId = (
    cartId: string
  ): Promise<OrderCartDomainPacksProductInformation[]> => {
    return this.ovh.request('GET', `/order/cart/${cartId}/domainPacks`);
  };

  /** Post a new Domain Packs item (AllDom) in your cart */
  postCartDomainPacksByCartId = (
    cartId: string,
    body: OrderCartDomainPacksCreation
  ): Promise<OrderCartItem> => {
    return this.ovh.request('POST', `/order/cart/${cartId}/domainPacks`, body);
  };

  /** Get informations about Domain Restore */
  getCartDomainRestoreByCartId = (cartId: string): Promise<OrderCartGenericProductDefinition[]> => {
    return this.ovh.request('GET', `/order/cart/${cartId}/domainRestore`);
  };

  /** Get informations about a domain name transfer */
  getCartDomainTransferByCartId = (cartId: string): Promise<OrderCartProductInformation[]> => {
    return this.ovh.request('GET', `/order/cart/${cartId}/domainTransfer`);
  };

  /** Post a new domain tranfer in your cart */
  postCartDomainTransferByCartId = (
    cartId: string,
    body: OrderCartGenericDomainCreation
  ): Promise<OrderCartItem> => {
    return this.ovh.request('POST', `/order/cart/${cartId}/domainTransfer`, body);
  };

  /** Get informations about domain names transfer options */
  getCartDomainTransferOptionsByCartId = (
    cartId: string
  ): Promise<OrderCartGenericOptionDefinition[]> => {
    return this.ovh.request('GET', `/order/cart/${cartId}/domainTransfer/options`);
  };

  /** Post a new domain name transfer option in your cart */
  postCartDomainTransferOptionsByCartId = (
    cartId: string,
    body: OrderCartGenericDomainOptionsCreation
  ): Promise<OrderCartItem> => {
    return this.ovh.request('POST', `/order/cart/${cartId}/domainTransfer/options`, body);
  };

  /** Get information about a eco */
  getCartEcoByCartId = (cartId: string): Promise<OrderCartGenericProductDefinition[]> => {
    return this.ovh.request('GET', `/order/cart/${cartId}/eco`);
  };

  /** Post a new eco item in your cart */
  postCartEcoByCartId = (
    cartId: string,
    body: OrderCartGenericProductCreation
  ): Promise<OrderCartItem> => {
    return this.ovh.request('POST', `/order/cart/${cartId}/eco`, body);
  };

  /** Get information about the options of a Eco */
  getCartEcoOptionsByCartId = (cartId: string): Promise<OrderCartGenericOptionDefinition[]> => {
    return this.ovh.request('GET', `/order/cart/${cartId}/eco/options`);
  };

  /** Post a new Eco option in your cart */
  postCartEcoOptionsByCartId = (
    cartId: string,
    body: OrderCartGenericOptionCreation
  ): Promise<OrderCartItem> => {
    return this.ovh.request('POST', `/order/cart/${cartId}/eco/options`, body);
  };

  /** Get all available packs available with emails packs */
  getCartEmailDomainByCartId = (cartId: string): Promise<OrderCartGenericProductDefinition[]> => {
    return this.ovh.request('GET', `/order/cart/${cartId}/emailDomain`);
  };

  /** Add a 1-domain emails pack in your cart */
  addCartEmailDomainByCartId = (
    cartId: string,
    body: OrderCartGenericProductCreation
  ): Promise<OrderCartItem> => {
    return this.ovh.request('POST', `/order/cart/${cartId}/emailDomain`, body);
  };

  /** Get informations about EmailPro offers */
  getCartEmailproByCartId = (cartId: string): Promise<OrderCartGenericProductDefinition[]> => {
    return this.ovh.request('GET', `/order/cart/${cartId}/emailpro`);
  };

  /** Post a new EmailPro item in your cart */
  postCartEmailproByCartId = (
    cartId: string,
    body: OrderCartGenericProductCreation
  ): Promise<OrderCartItem> => {
    return this.ovh.request('POST', `/order/cart/${cartId}/emailpro`, body);
  };

  /** Get informations about EmailPro options */
  getCartEmailproOptionsByCartId = (
    cartId: string
  ): Promise<OrderCartGenericOptionDefinition[]> => {
    return this.ovh.request('GET', `/order/cart/${cartId}/emailpro/options`);
  };

  /** Post a new EmailPro option in your cart */
  postCartEmailproOptionsByCartId = (
    cartId: string,
    body: OrderCartGenericOptionCreation
  ): Promise<OrderCartItem> => {
    return this.ovh.request('POST', `/order/cart/${cartId}/emailpro/options`, body);
  };

  /** Get informations about Exchange offers */
  getCartExchangeByCartId = (cartId: string): Promise<OrderCartGenericProductDefinition[]> => {
    return this.ovh.request('GET', `/order/cart/${cartId}/exchange`);
  };

  /** Post a new Exchange item in your cart */
  postCartExchangeByCartId = (
    cartId: string,
    body: OrderCartGenericProductCreation
  ): Promise<OrderCartItem> => {
    return this.ovh.request('POST', `/order/cart/${cartId}/exchange`, body);
  };

  /** Get informations about Exchange options */
  getCartExchangeOptionsByCartId = (
    cartId: string
  ): Promise<OrderCartGenericOptionDefinition[]> => {
    return this.ovh.request('GET', `/order/cart/${cartId}/exchange/options`);
  };

  /** Post a new Exchange option in your cart */
  postCartExchangeOptionsByCartId = (
    cartId: string,
    body: OrderCartGenericOptionCreation
  ): Promise<OrderCartItem> => {
    return this.ovh.request('POST', `/order/cart/${cartId}/exchange/options`, body);
  };

  /** Get informations about Exchange Enterprise offers */
  getCartExchangeEnterpriseByCartId = (
    cartId: string
  ): Promise<OrderCartGenericProductDefinition[]> => {
    return this.ovh.request('GET', `/order/cart/${cartId}/exchangeEnterprise`);
  };

  /** Post a new Exchange Enterprise item in your cart */
  postCartExchangeEnterpriseByCartId = (
    cartId: string,
    body: OrderCartGenericProductCreation
  ): Promise<OrderCartItem> => {
    return this.ovh.request('POST', `/order/cart/${cartId}/exchangeEnterprise`, body);
  };

  /** Get informations about Exchange Enterprise options */
  getCartExchangeEnterpriseOptionsByCartId = (
    cartId: string
  ): Promise<OrderCartGenericOptionDefinition[]> => {
    return this.ovh.request('GET', `/order/cart/${cartId}/exchangeEnterprise/options`);
  };

  /** Post a new Exchange Enterprise option in your cart */
  postCartExchangeEnterpriseOptionsByCartId = (
    cartId: string,
    body: OrderCartGenericOptionCreation
  ): Promise<OrderCartItem> => {
    return this.ovh.request('POST', `/order/cart/${cartId}/exchangeEnterprise/options`, body);
  };

  /** Get informations about IP addresses offers */
  getCartIpByCartId = (cartId: string): Promise<OrderCartGenericProductDefinition[]> => {
    return this.ovh.request('GET', `/order/cart/${cartId}/ip`);
  };

  /** Post a new IP addresses item in your cart */
  postCartIpByCartId = (
    cartId: string,
    body: OrderCartGenericProductCreation
  ): Promise<OrderCartItem> => {
    return this.ovh.request('POST', `/order/cart/${cartId}/ip`, body);
  };

  /** Get informations about IP addresses options */
  getCartIpOptionsByCartId = (cartId: string): Promise<OrderCartGenericOptionDefinition[]> => {
    return this.ovh.request('GET', `/order/cart/${cartId}/ip/options`);
  };

  /** Post a new IP addresses option in your cart */
  postCartIpOptionsByCartId = (
    cartId: string,
    body: OrderCartGenericOptionCreation
  ): Promise<OrderCartItem> => {
    return this.ovh.request('POST', `/order/cart/${cartId}/ip/options`, body);
  };

  /** Get informations about IP Load-Balancing offers */
  getCartIpLoadbalancingByCartId = (
    cartId: string
  ): Promise<OrderCartGenericProductDefinition[]> => {
    return this.ovh.request('GET', `/order/cart/${cartId}/ipLoadbalancing`);
  };

  /** Post a new IP Load-Balancing item in your cart */
  postCartIpLoadbalancingByCartId = (
    cartId: string,
    body: OrderCartGenericProductCreation
  ): Promise<OrderCartItem> => {
    return this.ovh.request('POST', `/order/cart/${cartId}/ipLoadbalancing`, body);
  };

  /** Get informations about IP Load-Balancing options */
  getCartIpLoadbalancingOptionsByCartId = (
    cartId: string
  ): Promise<OrderCartGenericOptionDefinition[]> => {
    return this.ovh.request('GET', `/order/cart/${cartId}/ipLoadbalancing/options`);
  };

  /** Post a new IP Load-Balancing option in your cart */
  postCartIpLoadbalancingOptionsByCartId = (
    cartId: string,
    body: OrderCartGenericOptionCreation
  ): Promise<OrderCartItem> => {
    return this.ovh.request('POST', `/order/cart/${cartId}/ipLoadbalancing/options`, body);
  };

  /** Get information about IP addresses reseller offers */
  getCartIpResellerByCartId = (cartId: string): Promise<OrderCartGenericProductDefinition[]> => {
    return this.ovh.request('GET', `/order/cart/${cartId}/ipReseller`);
  };

  /** Post a new IP address reseller item in your cart */
  postCartIpResellerByCartId = (
    cartId: string,
    body: { duration: string; planCode: string; pricingMode: string; quantity: number }
  ): Promise<OrderCartItem> => {
    return this.ovh.request('POST', `/order/cart/${cartId}/ipReseller`, body);
  };

  /** Get informations about offers */
  getCartIspPublicByCartId = (cartId: string): Promise<OrderCartGenericProductDefinition[]> => {
    return this.ovh.request('GET', `/order/cart/${cartId}/ispPublic`);
  };

  /** Post a new item in your cart */
  postCartIspPublicByCartId = (
    cartId: string,
    body: { duration: string; planCode: string; pricingMode: string; quantity: number }
  ): Promise<OrderCartItem> => {
    return this.ovh.request('POST', `/order/cart/${cartId}/ispPublic`, body);
  };

  /** Get informations about options */
  getCartIspPublicOptionsByCartId = (
    cartId: string
  ): Promise<OrderCartGenericOptionDefinition[]> => {
    return this.ovh.request('GET', `/order/cart/${cartId}/ispPublic/options`);
  };

  /** Post a new option in your cart */
  postCartIspPublicOptionsByCartId = (
    cartId: string,
    body: {
      duration: string;
      itemId: number;
      planCode: string;
      pricingMode: string;
      quantity: number;
    }
  ): Promise<OrderCartItem> => {
    return this.ovh.request('POST', `/order/cart/${cartId}/ispPublic/options`, body);
  };

  /** Get informations about offers */
  getCartIspResellerByCartId = (cartId: string): Promise<OrderCartGenericProductDefinition[]> => {
    return this.ovh.request('GET', `/order/cart/${cartId}/ispReseller`);
  };

  /** Post a new item in your cart */
  postCartIspResellerByCartId = (
    cartId: string,
    body: { duration: string; planCode: string; pricingMode: string; quantity: number }
  ): Promise<OrderCartItem> => {
    return this.ovh.request('POST', `/order/cart/${cartId}/ispReseller`, body);
  };

  /** Get informations about options */
  getCartIspResellerOptionsByCartId = (
    cartId: string
  ): Promise<OrderCartGenericOptionDefinition[]> => {
    return this.ovh.request('GET', `/order/cart/${cartId}/ispReseller/options`);
  };

  /** Post a new option in your cart */
  postCartIspResellerOptionsByCartId = (
    cartId: string,
    body: {
      duration: string;
      itemId: number;
      planCode: string;
      pricingMode: string;
      quantity: number;
    }
  ): Promise<OrderCartItem> => {
    return this.ovh.request('POST', `/order/cart/${cartId}/ispReseller/options`, body);
  };

  /** List all the items of a cart */
  listCartItemByCartId = (cartId: string): Promise<number[]> => {
    return this.ovh.request('GET', `/order/cart/${cartId}/item`);
  };

  /** Delete an item from a cart */
  deleteCartItemByCartIdAndItemId = (cartId: string, itemId: number): Promise<void> => {
    return this.ovh.request('DELETE', `/order/cart/${cartId}/item/${itemId}`);
  };

  /** Retrieve information about a specific item of a cart */
  getCartItemByCartIdAndItemId = (cartId: string, itemId: number): Promise<OrderCartItem> => {
    return this.ovh.request('GET', `/order/cart/${cartId}/item/${itemId}`);
  };

  /** Update some values on a cart item */
  updateCartItemByCartIdAndItemId = (
    cartId: string,
    itemId: number,
    body: OrderCartItemUpdate
  ): Promise<OrderCartItem> => {
    return this.ovh.request('PUT', `/order/cart/${cartId}/item/${itemId}`, body);
  };

  /** Retrieve all configuration item of the cart item */
  getCartItemConfigurationByCartIdAndItemId = (
    cartId: string,
    itemId: number
  ): Promise<number[]> => {
    return this.ovh.request('GET', `/order/cart/${cartId}/item/${itemId}/configuration`);
  };

  /** Setup configuration item for the product */
  postCartItemConfigurationByCartIdAndItemId = (
    cartId: string,
    itemId: number,
    body: OrderCartItemConfigurationCreation
  ): Promise<OrderCartConfigurationItem> => {
    return this.ovh.request('POST', `/order/cart/${cartId}/item/${itemId}/configuration`, body);
  };

  /** Delete configuration item */
  deleteCartItemConfigurationByCartIdAndItemIdAndConfigurationId = (
    cartId: string,
    configurationId: number,
    itemId: number
  ): Promise<void> => {
    return this.ovh.request(
      'DELETE',
      `/order/cart/${cartId}/item/${itemId}/configuration/${configurationId}`
    );
  };

  /** Retrieve configuration item */
  getCartItemConfigurationByCartIdAndItemIdAndConfigurationId = (
    cartId: string,
    configurationId: number,
    itemId: number
  ): Promise<OrderCartConfigurationItem> => {
    return this.ovh.request(
      'GET',
      `/order/cart/${cartId}/item/${itemId}/configuration/${configurationId}`
    );
  };

  /** Retrieve all required configuration item of the cart item */
  getCartItemRequiredConfigurationByCartIdAndItemId = (
    cartId: string,
    itemId: number
  ): Promise<OrderCartConfigurationRequirements[]> => {
    return this.ovh.request('GET', `/order/cart/${cartId}/item/${itemId}/requiredConfiguration`);
  };

  /** Get informations about Kubernetes offers */
  getCartKubernetesByCartId = (cartId: string): Promise<OrderCartGenericProductDefinition[]> => {
    return this.ovh.request('GET', `/order/cart/${cartId}/kubernetes`);
  };

  /** Post a new Kubernetes item in your cart */
  postCartKubernetesByCartId = (
    cartId: string,
    body: OrderCartGenericProductCreation
  ): Promise<OrderCartItem> => {
    return this.ovh.request('POST', `/order/cart/${cartId}/kubernetes`, body);
  };

  /** Get informations about Kubernetes options */
  getCartKubernetesOptionsByCartId = (
    cartId: string
  ): Promise<OrderCartGenericOptionDefinition[]> => {
    return this.ovh.request('GET', `/order/cart/${cartId}/kubernetes/options`);
  };

  /** Post a new Kubernetes option in your cart */
  postCartKubernetesOptionsByCartId = (
    cartId: string,
    body: OrderCartGenericOptionCreation
  ): Promise<OrderCartItem> => {
    return this.ovh.request('POST', `/order/cart/${cartId}/kubernetes/options`, body);
  };

  /** Get informations about CloudLinux licenses offers */
  getCartLicenseCloudLinuxByCartId = (
    cartId: string
  ): Promise<OrderCartGenericProductDefinition[]> => {
    return this.ovh.request('GET', `/order/cart/${cartId}/licenseCloudLinux`);
  };

  /** Post a new CloudLinux license item in your cart */
  postCartLicenseCloudLinuxByCartId = (
    cartId: string,
    body: OrderCartGenericProductCreation
  ): Promise<OrderCartItem> => {
    return this.ovh.request('POST', `/order/cart/${cartId}/licenseCloudLinux`, body);
  };

  /** Get informations about Directadmin licenses offers */
  getCartLicenseDirectadminByCartId = (
    cartId: string
  ): Promise<OrderCartGenericProductDefinition[]> => {
    return this.ovh.request('GET', `/order/cart/${cartId}/licenseDirectadmin`);
  };

  /** Post a new Directadmin license item in your cart */
  postCartLicenseDirectadminByCartId = (
    cartId: string,
    body: OrderCartGenericProductCreation
  ): Promise<OrderCartItem> => {
    return this.ovh.request('POST', `/order/cart/${cartId}/licenseDirectadmin`, body);
  };

  /** Get informations about Plesk licenses offers */
  getCartLicensePleskByCartId = (cartId: string): Promise<OrderCartGenericProductDefinition[]> => {
    return this.ovh.request('GET', `/order/cart/${cartId}/licensePlesk`);
  };

  /** Post a new Plesk license item in your cart */
  postCartLicensePleskByCartId = (
    cartId: string,
    body: OrderCartGenericProductCreation
  ): Promise<OrderCartItem> => {
    return this.ovh.request('POST', `/order/cart/${cartId}/licensePlesk`, body);
  };

  /** Get informations about Plesk license options */
  getCartLicensePleskOptionsByCartId = (
    cartId: string
  ): Promise<OrderCartGenericOptionDefinition[]> => {
    return this.ovh.request('GET', `/order/cart/${cartId}/licensePlesk/options`);
  };

  /** Post a new Plesk license option in your cart */
  postCartLicensePleskOptionsByCartId = (
    cartId: string,
    body: OrderCartGenericOptionCreation
  ): Promise<OrderCartItem> => {
    return this.ovh.request('POST', `/order/cart/${cartId}/licensePlesk/options`, body);
  };

  /** Get informations about SqlServer licenses offers */
  getCartLicenseSqlServerByCartId = (
    cartId: string
  ): Promise<OrderCartGenericProductDefinition[]> => {
    return this.ovh.request('GET', `/order/cart/${cartId}/licenseSqlServer`);
  };

  /** Post a new SqlServer license item in your cart */
  postCartLicenseSqlServerByCartId = (
    cartId: string,
    body: OrderCartGenericProductCreation
  ): Promise<OrderCartItem> => {
    return this.ovh.request('POST', `/order/cart/${cartId}/licenseSqlServer`, body);
  };

  /** Get informations about Virtuozzo licenses offers */
  getCartLicenseVirtuozzoByCartId = (
    cartId: string
  ): Promise<OrderCartGenericProductDefinition[]> => {
    return this.ovh.request('GET', `/order/cart/${cartId}/licenseVirtuozzo`);
  };

  /** Post a new Virtuozzo license item in your cart */
  postCartLicenseVirtuozzoByCartId = (
    cartId: string,
    body: OrderCartGenericProductCreation
  ): Promise<OrderCartItem> => {
    return this.ovh.request('POST', `/order/cart/${cartId}/licenseVirtuozzo`, body);
  };

  /** Get informations about Windows licenses offers */
  getCartLicenseWindowsByCartId = (
    cartId: string
  ): Promise<OrderCartGenericProductDefinition[]> => {
    return this.ovh.request('GET', `/order/cart/${cartId}/licenseWindows`);
  };

  /** Post a new Windows license item in your cart */
  postCartLicenseWindowsByCartId = (
    cartId: string,
    body: OrderCartGenericProductCreation
  ): Promise<OrderCartItem> => {
    return this.ovh.request('POST', `/order/cart/${cartId}/licenseWindows`, body);
  };

  /** Get informations about Worklight licenses offers */
  getCartLicenseWorklightByCartId = (
    cartId: string
  ): Promise<OrderCartGenericProductDefinition[]> => {
    return this.ovh.request('GET', `/order/cart/${cartId}/licenseWorklight`);
  };

  /** Post a new Worklight license item in your cart */
  postCartLicenseWorklightByCartId = (
    cartId: string,
    body: OrderCartGenericProductCreation
  ): Promise<OrderCartItem> => {
    return this.ovh.request('POST', `/order/cart/${cartId}/licenseWorklight`, body);
  };

  /** Get informations about cPanel licenses offers */
  getCartLicensecPanelByCartId = (cartId: string): Promise<OrderCartGenericProductDefinition[]> => {
    return this.ovh.request('GET', `/order/cart/${cartId}/licensecPanel`);
  };

  /** Post a new cPanel license item in your cart */
  postCartLicensecPanelByCartId = (
    cartId: string,
    body: OrderCartGenericProductCreation
  ): Promise<OrderCartItem> => {
    return this.ovh.request('POST', `/order/cart/${cartId}/licensecPanel`, body);
  };

  /** Get informations about Logs offers */
  getCartLogsByCartId = (cartId: string): Promise<OrderCartGenericProductDefinition[]> => {
    return this.ovh.request('GET', `/order/cart/${cartId}/logs`);
  };

  /** Post a new Logs item in your cart */
  postCartLogsByCartId = (
    cartId: string,
    body: OrderCartGenericProductCreation
  ): Promise<OrderCartItem> => {
    return this.ovh.request('POST', `/order/cart/${cartId}/logs`, body);
  };

  /** Get informations about Logs options */
  getCartLogsOptionsByCartId = (cartId: string): Promise<OrderCartGenericOptionDefinition[]> => {
    return this.ovh.request('GET', `/order/cart/${cartId}/logs/options`);
  };

  /** Post a new Logs option in your cart */
  postCartLogsOptionsByCartId = (
    cartId: string,
    body: OrderCartGenericOptionCreation
  ): Promise<OrderCartItem> => {
    return this.ovh.request('POST', `/order/cart/${cartId}/logs/options`, body);
  };

  /** Get informations about Managed Services offers */
  getCartManagedServicesByCartId = (
    cartId: string
  ): Promise<OrderCartGenericProductDefinition[]> => {
    return this.ovh.request('GET', `/order/cart/${cartId}/managedServices`);
  };

  /** Post a new Managed Services item in your cart */
  postCartManagedServicesByCartId = (
    cartId: string,
    body: OrderCartGenericProductCreation
  ): Promise<OrderCartItem> => {
    return this.ovh.request('POST', `/order/cart/${cartId}/managedServices`, body);
  };

  /** Get informations about Managed Services options */
  getCartManagedServicesOptionsByCartId = (
    cartId: string
  ): Promise<OrderCartGenericOptionDefinition[]> => {
    return this.ovh.request('GET', `/order/cart/${cartId}/managedServices/options`);
  };

  /** Post a new Managed Services option in your cart */
  postCartManagedServicesOptionsByCartId = (
    cartId: string,
    body: OrderCartGenericOptionCreation
  ): Promise<OrderCartItem> => {
    return this.ovh.request('POST', `/order/cart/${cartId}/managedServices/options`, body);
  };

  /** Get informations about Metrics offers */
  getCartMetricsByCartId = (cartId: string): Promise<OrderCartGenericProductDefinition[]> => {
    return this.ovh.request('GET', `/order/cart/${cartId}/metrics`);
  };

  /** Post a new Metrics item in your cart */
  postCartMetricsByCartId = (
    cartId: string,
    body: OrderCartGenericProductCreation
  ): Promise<OrderCartItem> => {
    return this.ovh.request('POST', `/order/cart/${cartId}/metrics`, body);
  };

  /** Get informations about Metrics options */
  getCartMetricsOptionsByCartId = (cartId: string): Promise<OrderCartGenericOptionDefinition[]> => {
    return this.ovh.request('GET', `/order/cart/${cartId}/metrics/options`);
  };

  /** Post a new Metrics option in your cart */
  postCartMetricsOptionsByCartId = (
    cartId: string,
    body: OrderCartGenericOptionCreation
  ): Promise<OrderCartItem> => {
    return this.ovh.request('POST', `/order/cart/${cartId}/metrics/options`, body);
  };

  /** Get informations about Microsoft offers */
  getCartMicrosoftByCartId = (cartId: string): Promise<OrderCartGenericProductDefinition[]> => {
    return this.ovh.request('GET', `/order/cart/${cartId}/microsoft`);
  };

  /** Post a new Microsoft offer item in your cart */
  postCartMicrosoftByCartId = (
    cartId: string,
    body: OrderCartGenericProductCreation
  ): Promise<OrderCartItem> => {
    return this.ovh.request('POST', `/order/cart/${cartId}/microsoft`, body);
  };

  /** Get informations about Microsoft options */
  getCartMicrosoftOptionsByCartId = (
    cartId: string
  ): Promise<OrderCartGenericOptionDefinition[]> => {
    return this.ovh.request('GET', `/order/cart/${cartId}/microsoft/options`);
  };

  /** Post a new Microsoft option in your cart */
  postCartMicrosoftOptionsByCartId = (
    cartId: string,
    body: OrderCartGenericOptionCreation
  ): Promise<OrderCartItem> => {
    return this.ovh.request('POST', `/order/cart/${cartId}/microsoft/options`, body);
  };

  /** Get informations about NAS HA offers */
  getCartNashaByCartId = (cartId: string): Promise<OrderCartGenericProductDefinition[]> => {
    return this.ovh.request('GET', `/order/cart/${cartId}/nasha`);
  };

  /** Post a new NAS HA item in your cart */
  postCartNashaByCartId = (
    cartId: string,
    body: OrderCartGenericProductCreation
  ): Promise<OrderCartItem> => {
    return this.ovh.request('POST', `/order/cart/${cartId}/nasha`, body);
  };

  /** Get informations about NAS HA options */
  getCartNashaOptionsByCartId = (cartId: string): Promise<OrderCartGenericOptionDefinition[]> => {
    return this.ovh.request('GET', `/order/cart/${cartId}/nasha/options`);
  };

  /** Post a new NAS HA option in your cart */
  postCartNashaOptionsByCartId = (
    cartId: string,
    body: OrderCartGenericOptionCreation
  ): Promise<OrderCartItem> => {
    return this.ovh.request('POST', `/order/cart/${cartId}/nasha/options`, body);
  };

  /** Get informations about NetApp offers */
  getCartNetappByCartId = (cartId: string): Promise<OrderCartGenericProductDefinition[]> => {
    return this.ovh.request('GET', `/order/cart/${cartId}/netapp`);
  };

  /** Post a new NetApp offer item in your cart */
  postCartNetappByCartId = (
    cartId: string,
    body: OrderCartGenericProductCreation
  ): Promise<OrderCartItem> => {
    return this.ovh.request('POST', `/order/cart/${cartId}/netapp`, body);
  };

  /** Get informations about NetApp options */
  getCartNetappOptionsByCartId = (cartId: string): Promise<OrderCartGenericOptionDefinition[]> => {
    return this.ovh.request('GET', `/order/cart/${cartId}/netapp/options`);
  };

  /** Post a new NetApp option in your cart */
  postCartNetappOptionsByCartId = (
    cartId: string,
    body: OrderCartGenericOptionCreation
  ): Promise<OrderCartItem> => {
    return this.ovh.request('POST', `/order/cart/${cartId}/netapp/options`, body);
  };

  /** Get information about a Nutanix */
  getCartNutanixByCartId = (cartId: string): Promise<OrderCartGenericProductDefinition[]> => {
    return this.ovh.request('GET', `/order/cart/${cartId}/nutanix`);
  };

  /** Post a new Nutanix item in your cart */
  postCartNutanixByCartId = (
    cartId: string,
    body: OrderCartGenericProductCreation
  ): Promise<OrderCartItem> => {
    return this.ovh.request('POST', `/order/cart/${cartId}/nutanix`, body);
  };

  /** Get information about the options of a Nutanix */
  getCartNutanixOptionsByCartId = (cartId: string): Promise<OrderCartGenericOptionDefinition[]> => {
    return this.ovh.request('GET', `/order/cart/${cartId}/nutanix/options`);
  };

  /** Post a new Nutanix option in your cart */
  postCartNutanixOptionsByCartId = (
    cartId: string,
    body: OrderCartGenericOptionCreation
  ): Promise<OrderCartItem> => {
    return this.ovh.request('POST', `/order/cart/${cartId}/nutanix/options`, body);
  };

  /** Get informations about Office 365 licenses */
  getCartOffice365ByCartId = (cartId: string): Promise<OrderCartGenericProductDefinition[]> => {
    return this.ovh.request('GET', `/order/cart/${cartId}/office365`);
  };

  /** Post a new Office 365 item in your cart */
  postCartOffice365ByCartId = (
    cartId: string,
    body: OrderCartGenericProductCreation
  ): Promise<OrderCartItem> => {
    return this.ovh.request('POST', `/order/cart/${cartId}/office365`, body);
  };

  /** Get informations about Office 365 options */
  getCartOffice365OptionsByCartId = (
    cartId: string
  ): Promise<OrderCartGenericOptionDefinition[]> => {
    return this.ovh.request('GET', `/order/cart/${cartId}/office365/options`);
  };

  /** Post a new Office 365 option in your cart */
  postCartOffice365OptionsByCartId = (
    cartId: string,
    body: OrderCartGenericOptionCreation
  ): Promise<OrderCartItem> => {
    return this.ovh.request('POST', `/order/cart/${cartId}/office365/options`, body);
  };

  /** Get informations about Office 365 Prepaid licenses */
  getCartOffice365PrepaidByCartId = (
    cartId: string
  ): Promise<OrderCartGenericProductDefinition[]> => {
    return this.ovh.request('GET', `/order/cart/${cartId}/office365Prepaid`);
  };

  /** Post a new Office 365 Prepaid item in your cart */
  postCartOffice365PrepaidByCartId = (
    cartId: string,
    body: OrderCartGenericProductCreation
  ): Promise<OrderCartItem> => {
    return this.ovh.request('POST', `/order/cart/${cartId}/office365Prepaid`, body);
  };

  /** Get informations about Office 365 Prepaid options */
  getCartOffice365PrepaidOptionsByCartId = (
    cartId: string
  ): Promise<OrderCartGenericOptionDefinition[]> => {
    return this.ovh.request('GET', `/order/cart/${cartId}/office365Prepaid/options`);
  };

  /** Post a new Office 365 Prepaid option in your cart */
  postCartOffice365PrepaidOptionsByCartId = (
    cartId: string,
    body: OrderCartGenericOptionCreation
  ): Promise<OrderCartItem> => {
    return this.ovh.request('POST', `/order/cart/${cartId}/office365Prepaid/options`, body);
  };

  /** Get informations about a officePrepaid */
  getCartOfficePrepaidByCartId = (cartId: string): Promise<OrderCartGenericProductDefinition[]> => {
    return this.ovh.request('GET', `/order/cart/${cartId}/officePrepaid`);
  };

  /** Post a new officePrepaid item in your cart */
  postCartOfficePrepaidByCartId = (
    cartId: string,
    body: OrderCartGenericProductCreation
  ): Promise<OrderCartItem> => {
    return this.ovh.request('POST', `/order/cart/${cartId}/officePrepaid`, body);
  };

  /** Get informations about officePrepaid options */
  getCartOfficePrepaidOptionsByCartId = (
    cartId: string
  ): Promise<OrderCartGenericOptionDefinition[]> => {
    return this.ovh.request('GET', `/order/cart/${cartId}/officePrepaid/options`);
  };

  /** Post a new officePrepaid option in your cart */
  postCartOfficePrepaidOptionsByCartId = (
    cartId: string,
    body: OrderCartGenericOptionCreation
  ): Promise<OrderCartItem> => {
    return this.ovh.request('POST', `/order/cart/${cartId}/officePrepaid/options`, body);
  };

  /** Get informations about Over The Box offers */
  getCartOtbByCartId = (cartId: string): Promise<OrderCartGenericProductDefinition[]> => {
    return this.ovh.request('GET', `/order/cart/${cartId}/otb`);
  };

  /** Post a new Over The Box item in your cart */
  postCartOtbByCartId = (
    cartId: string,
    body: OrderCartGenericProductCreation
  ): Promise<OrderCartItem> => {
    return this.ovh.request('POST', `/order/cart/${cartId}/otb`, body);
  };

  /** Get informations about Over The Box options */
  getCartOtbOptionsByCartId = (cartId: string): Promise<OrderCartGenericOptionDefinition[]> => {
    return this.ovh.request('GET', `/order/cart/${cartId}/otb/options`);
  };

  /** Post a new Over The Box option in your cart */
  postCartOtbOptionsByCartId = (
    cartId: string,
    body: OrderCartGenericOptionCreation
  ): Promise<OrderCartItem> => {
    return this.ovh.request('POST', `/order/cart/${cartId}/otb/options`, body);
  };

  /** Get informations about OVHcloud Connect offers */
  getCartOvhCloudConnectByCartId = (
    cartId: string
  ): Promise<OrderCartGenericProductDefinition[]> => {
    return this.ovh.request('GET', `/order/cart/${cartId}/ovhCloudConnect`);
  };

  /** Post a new OVHcloud Connect item in your cart */
  postCartOvhCloudConnectByCartId = (
    cartId: string,
    body: OrderCartGenericProductCreation
  ): Promise<OrderCartItem> => {
    return this.ovh.request('POST', `/order/cart/${cartId}/ovhCloudConnect`, body);
  };

  /** Get informations about PaaS Monitoring offers */
  getCartPaasmonByCartId = (cartId: string): Promise<OrderCartGenericProductDefinition[]> => {
    return this.ovh.request('GET', `/order/cart/${cartId}/paasmon`);
  };

  /** Post a new PaaS Monitoring item in your cart */
  postCartPaasmonByCartId = (
    cartId: string,
    body: OrderCartGenericProductCreation
  ): Promise<OrderCartItem> => {
    return this.ovh.request('POST', `/order/cart/${cartId}/paasmon`, body);
  };

  /** Get informations about a packs professional services */
  getCartPacksProfessionalServicesByCartId = (
    cartId: string
  ): Promise<OrderCartGenericProductDefinition[]> => {
    return this.ovh.request('GET', `/order/cart/${cartId}/packsProfessionalServices`);
  };

  /** Post a new packs professional services item in your cart */
  postCartPacksProfessionalServicesByCartId = (
    cartId: string,
    body: OrderCartGenericProductCreation
  ): Promise<OrderCartItem> => {
    return this.ovh.request('POST', `/order/cart/${cartId}/packsProfessionalServices`, body);
  };

  /** Get informations about packs professional services options */
  getCartPacksProfessionalServicesOptionsByCartId = (
    cartId: string
  ): Promise<OrderCartGenericOptionDefinition[]> => {
    return this.ovh.request('GET', `/order/cart/${cartId}/packsProfessionalServices/options`);
  };

  /** Post a new packs professional services option in your cart */
  postCartPacksProfessionalServicesOptionsByCartId = (
    cartId: string,
    body: OrderCartGenericOptionCreation
  ): Promise<OrderCartItem> => {
    return this.ovh.request(
      'POST',
      `/order/cart/${cartId}/packsProfessionalServices/options`,
      body
    );
  };

  /** Get informations about power hosting offer */
  getCartPowerHostingByCartId = (cartId: string): Promise<OrderCartGenericProductDefinition[]> => {
    return this.ovh.request('GET', `/order/cart/${cartId}/powerHosting`);
  };

  /** Post a new power hosting item in your cart */
  postCartPowerHostingByCartId = (
    cartId: string,
    body: OrderCartGenericProductCreation
  ): Promise<OrderCartItem> => {
    return this.ovh.request('POST', `/order/cart/${cartId}/powerHosting`, body);
  };

  /** Get informations about Hosted Private Cloud offers */
  getCartPrivateCloudByCartId = (cartId: string): Promise<OrderCartGenericProductDefinition[]> => {
    return this.ovh.request('GET', `/order/cart/${cartId}/privateCloud`);
  };

  /** Post a new Hosted Private Cloud item in your cart */
  postCartPrivateCloudByCartId = (
    cartId: string,
    body: OrderCartGenericProductCreation
  ): Promise<OrderCartItem> => {
    return this.ovh.request('POST', `/order/cart/${cartId}/privateCloud`, body);
  };

  /** Get informations about Hosted Private Cloud options */
  getCartPrivateCloudOptionsByCartId = (
    cartId: string
  ): Promise<OrderCartGenericOptionDefinition[]> => {
    return this.ovh.request('GET', `/order/cart/${cartId}/privateCloud/options`);
  };

  /** Post a new Hosted Private Cloud option in your cart */
  postCartPrivateCloudOptionsByCartId = (
    cartId: string,
    body: OrderCartGenericOptionCreation
  ): Promise<OrderCartItem> => {
    return this.ovh.request('POST', `/order/cart/${cartId}/privateCloud/options`, body);
  };

  /** Get informations about Private Cloud CDI offers */
  getCartPrivateCloudCDIByCartId = (
    cartId: string
  ): Promise<OrderCartGenericProductDefinition[]> => {
    return this.ovh.request('GET', `/order/cart/${cartId}/privateCloudCDI`);
  };

  /** Post a new Private Cloud CDI item in your cart */
  postCartPrivateCloudCDIByCartId = (
    cartId: string,
    body: OrderCartGenericProductCreation
  ): Promise<OrderCartItem> => {
    return this.ovh.request('POST', `/order/cart/${cartId}/privateCloudCDI`, body);
  };

  /** Get informations about Private Cloud CDI options */
  getCartPrivateCloudCDIOptionsByCartId = (
    cartId: string
  ): Promise<OrderCartGenericOptionDefinition[]> => {
    return this.ovh.request('GET', `/order/cart/${cartId}/privateCloudCDI/options`);
  };

  /** Post a new Private Cloud CDI option in your cart */
  postCartPrivateCloudCDIOptionsByCartId = (
    cartId: string,
    body: OrderCartGenericOptionCreation
  ): Promise<OrderCartItem> => {
    return this.ovh.request('POST', `/order/cart/${cartId}/privateCloudCDI/options`, body);
  };

  /** Get informations about Private Cloud Dedicated Cloud offers */
  getCartPrivateCloudDCByCartId = (
    cartId: string
  ): Promise<OrderCartGenericProductDefinition[]> => {
    return this.ovh.request('GET', `/order/cart/${cartId}/privateCloudDC`);
  };

  /** Post a new Private Cloud Dedicated Cloud item in your cart */
  postCartPrivateCloudDCByCartId = (
    cartId: string,
    body: OrderCartGenericProductCreation
  ): Promise<OrderCartItem> => {
    return this.ovh.request('POST', `/order/cart/${cartId}/privateCloudDC`, body);
  };

  /** Get informations about Private Cloud Dedicated Cloud options */
  getCartPrivateCloudDCOptionsByCartId = (
    cartId: string
  ): Promise<OrderCartGenericOptionDefinition[]> => {
    return this.ovh.request('GET', `/order/cart/${cartId}/privateCloudDC/options`);
  };

  /** Post a new Private Cloud Dedicated Cloud option in your cart */
  postCartPrivateCloudDCOptionsByCartId = (
    cartId: string,
    body: OrderCartGenericOptionCreation
  ): Promise<OrderCartItem> => {
    return this.ovh.request('POST', `/order/cart/${cartId}/privateCloudDC/options`, body);
  };

  /** Get informations about Hosted Private Cloud offers */
  getCartPrivateCloudEnterpriseByCartId = (
    cartId: string
  ): Promise<OrderCartGenericProductDefinition[]> => {
    return this.ovh.request('GET', `/order/cart/${cartId}/privateCloudEnterprise`);
  };

  /** Post a new Hosted Private Cloud item in your cart */
  postCartPrivateCloudEnterpriseByCartId = (
    cartId: string,
    body: OrderCartGenericProductCreation
  ): Promise<OrderCartItem> => {
    return this.ovh.request('POST', `/order/cart/${cartId}/privateCloudEnterprise`, body);
  };

  /** Get informations about Hosted Private Cloud options */
  getCartPrivateCloudEnterpriseOptionsByCartId = (
    cartId: string
  ): Promise<OrderCartGenericOptionDefinition[]> => {
    return this.ovh.request('GET', `/order/cart/${cartId}/privateCloudEnterprise/options`);
  };

  /** Post a new Hosted Private Cloud option in your cart */
  postCartPrivateCloudEnterpriseOptionsByCartId = (
    cartId: string,
    body: OrderCartGenericOptionCreation
  ): Promise<OrderCartItem> => {
    return this.ovh.request('POST', `/order/cart/${cartId}/privateCloudEnterprise/options`, body);
  };

  /** Get informations about Dedicated Cloud Reseller offers */
  getCartPrivateCloudResellerByCartId = (
    cartId: string
  ): Promise<OrderCartGenericProductDefinition[]> => {
    return this.ovh.request('GET', `/order/cart/${cartId}/privateCloudReseller`);
  };

  /** Post a new Dedicated Cloud Reseller item in your cart */
  postCartPrivateCloudResellerByCartId = (
    cartId: string,
    body: { duration: string; planCode: string; pricingMode: string; quantity: number }
  ): Promise<OrderCartItem> => {
    return this.ovh.request('POST', `/order/cart/${cartId}/privateCloudReseller`, body);
  };

  /** Get informations about Dedicated Cloud Reseller options */
  getCartPrivateCloudResellerOptionsByCartId = (
    cartId: string
  ): Promise<OrderCartGenericOptionDefinition[]> => {
    return this.ovh.request('GET', `/order/cart/${cartId}/privateCloudReseller/options`);
  };

  /** Post a new Dedicated Cloud Reseller option in your cart */
  postCartPrivateCloudResellerOptionsByCartId = (
    cartId: string,
    body: {
      duration: string;
      itemId: number;
      planCode: string;
      pricingMode: string;
      quantity: number;
    }
  ): Promise<OrderCartItem> => {
    return this.ovh.request('POST', `/order/cart/${cartId}/privateCloudReseller/options`, body);
  };

  /** Get informations about Dedicated Cloud Reseller Enterprise offers */
  getCartPrivateCloudResellerEnterpriseByCartId = (
    cartId: string
  ): Promise<OrderCartGenericProductDefinition[]> => {
    return this.ovh.request('GET', `/order/cart/${cartId}/privateCloudResellerEnterprise`);
  };

  /** Post a new Dedicated Cloud Reseller Enterprise item in your cart */
  postCartPrivateCloudResellerEnterpriseByCartId = (
    cartId: string,
    body: { duration: string; planCode: string; pricingMode: string; quantity: number }
  ): Promise<OrderCartItem> => {
    return this.ovh.request('POST', `/order/cart/${cartId}/privateCloudResellerEnterprise`, body);
  };

  /** Get informations about Dedicated Cloud Reseller Enterprise options */
  getCartPrivateCloudResellerEnterpriseOptionsByCartId = (
    cartId: string
  ): Promise<OrderCartGenericOptionDefinition[]> => {
    return this.ovh.request('GET', `/order/cart/${cartId}/privateCloudResellerEnterprise/options`);
  };

  /** Post a new Dedicated Cloud Reseller Enterprise option in your cart */
  postCartPrivateCloudResellerEnterpriseOptionsByCartId = (
    cartId: string,
    body: {
      duration: string;
      itemId: number;
      planCode: string;
      pricingMode: string;
      quantity: number;
    }
  ): Promise<OrderCartItem> => {
    return this.ovh.request(
      'POST',
      `/order/cart/${cartId}/privateCloudResellerEnterprise/options`,
      body
    );
  };

  /** Get informations about Private Cloud SDDC offers */
  getCartPrivateCloudSDDCByCartId = (
    cartId: string
  ): Promise<OrderCartGenericProductDefinition[]> => {
    return this.ovh.request('GET', `/order/cart/${cartId}/privateCloudSDDC`);
  };

  /** Post a new Private Cloud SDDC item in your cart */
  postCartPrivateCloudSDDCByCartId = (
    cartId: string,
    body: OrderCartGenericProductCreation
  ): Promise<OrderCartItem> => {
    return this.ovh.request('POST', `/order/cart/${cartId}/privateCloudSDDC`, body);
  };

  /** Get informations about Private Cloud SDDC options */
  getCartPrivateCloudSDDCOptionsByCartId = (
    cartId: string
  ): Promise<OrderCartGenericOptionDefinition[]> => {
    return this.ovh.request('GET', `/order/cart/${cartId}/privateCloudSDDC/options`);
  };

  /** Post a new Private Cloud SDDC option in your cart */
  postCartPrivateCloudSDDCOptionsByCartId = (
    cartId: string,
    body: OrderCartGenericOptionCreation
  ): Promise<OrderCartItem> => {
    return this.ovh.request('POST', `/order/cart/${cartId}/privateCloudSDDC/options`, body);
  };

  /** Get all privateSQL offers available */
  getCartPrivateSQLByCartId = (cartId: string): Promise<OrderCartGenericProductDefinition[]> => {
    return this.ovh.request('GET', `/order/cart/${cartId}/privateSQL`);
  };

  /** Add a privateSQL in your cart */
  addCartPrivateSQLByCartId = (
    cartId: string,
    body: OrderCartGenericProductCreation
  ): Promise<OrderCartItem> => {
    return this.ovh.request('POST', `/order/cart/${cartId}/privateSQL`, body);
  };

  /** Get informations about Reseller offers */
  getCartResellerByCartId = (cartId: string): Promise<OrderCartGenericProductDefinition[]> => {
    return this.ovh.request('GET', `/order/cart/${cartId}/reseller`);
  };

  /** Post a new Reseller offer item in your cart */
  postCartResellerByCartId = (
    cartId: string,
    body: OrderCartGenericProductCreation
  ): Promise<OrderCartItem> => {
    return this.ovh.request('POST', `/order/cart/${cartId}/reseller`, body);
  };

  /** Get informations about Sharepoint offers */
  getCartSharepointByCartId = (cartId: string): Promise<OrderCartGenericProductDefinition[]> => {
    return this.ovh.request('GET', `/order/cart/${cartId}/sharepoint`);
  };

  /** Post a new Sharepoint offer item in your cart */
  postCartSharepointByCartId = (
    cartId: string,
    body: OrderCartGenericProductCreation
  ): Promise<OrderCartItem> => {
    return this.ovh.request('POST', `/order/cart/${cartId}/sharepoint`, body);
  };

  /** Get informations about Sharepoint options */
  getCartSharepointOptionsByCartId = (
    cartId: string
  ): Promise<OrderCartGenericOptionDefinition[]> => {
    return this.ovh.request('GET', `/order/cart/${cartId}/sharepoint/options`);
  };

  /** Post a new Sharepoint option in your cart */
  postCartSharepointOptionsByCartId = (
    cartId: string,
    body: OrderCartGenericOptionCreation
  ): Promise<OrderCartItem> => {
    return this.ovh.request('POST', `/order/cart/${cartId}/sharepoint/options`, body);
  };

  /** Get informations about SMS offers */
  getCartSmsByCartId = (cartId: string): Promise<OrderCartGenericProductDefinition[]> => {
    return this.ovh.request('GET', `/order/cart/${cartId}/sms`);
  };

  /** Post a new SMS item in your cart */
  postCartSmsByCartId = (
    cartId: string,
    body: OrderCartGenericProductCreation
  ): Promise<OrderCartItem> => {
    return this.ovh.request('POST', `/order/cart/${cartId}/sms`, body);
  };

  /** Get informations about SSL Comodo offers */
  getCartSslComodoByCartId = (cartId: string): Promise<OrderCartGenericProductDefinition[]> => {
    return this.ovh.request('GET', `/order/cart/${cartId}/sslComodo`);
  };

  /** Post a new SSL Comodo item in your cart */
  postCartSslComodoByCartId = (
    cartId: string,
    body: OrderCartGenericProductCreation
  ): Promise<OrderCartItem> => {
    return this.ovh.request('POST', `/order/cart/${cartId}/sslComodo`, body);
  };

  /** Get informations about SSL Comodo options */
  getCartSslComodoOptionsByCartId = (
    cartId: string
  ): Promise<OrderCartGenericOptionDefinition[]> => {
    return this.ovh.request('GET', `/order/cart/${cartId}/sslComodo/options`);
  };

  /** Post a new SSL Comodo option in your cart */
  postCartSslComodoOptionsByCartId = (
    cartId: string,
    body: OrderCartGenericOptionCreation
  ): Promise<OrderCartItem> => {
    return this.ovh.request('POST', `/order/cart/${cartId}/sslComodo/options`, body);
  };

  /** Get informations about SSL Gateway offers */
  getCartSslGatewayByCartId = (cartId: string): Promise<OrderCartGenericProductDefinition[]> => {
    return this.ovh.request('GET', `/order/cart/${cartId}/sslGateway`);
  };

  /** Post a new SSL Gateway item in your cart */
  postCartSslGatewayByCartId = (
    cartId: string,
    body: OrderCartGenericProductCreation
  ): Promise<OrderCartItem> => {
    return this.ovh.request('POST', `/order/cart/${cartId}/sslGateway`, body);
  };

  /** Get informations about SSL Gateway options */
  getCartSslGatewayOptionsByCartId = (
    cartId: string
  ): Promise<OrderCartGenericOptionDefinition[]> => {
    return this.ovh.request('GET', `/order/cart/${cartId}/sslGateway/options`);
  };

  /** Post a new SSL Gateway option in your cart */
  postCartSslGatewayOptionsByCartId = (
    cartId: string,
    body: OrderCartGenericOptionCreation
  ): Promise<OrderCartItem> => {
    return this.ovh.request('POST', `/order/cart/${cartId}/sslGateway/options`, body);
  };

  /** Get a summary of your current order */
  getCartSummaryByCartId = (cartId: string): Promise<OrderOrder> => {
    return this.ovh.request('GET', `/order/cart/${cartId}/summary`);
  };

  /** Get all support offers available */
  getCartSupportByCartId = (cartId: string): Promise<OrderCartGenericProductDefinition[]> => {
    return this.ovh.request('GET', `/order/cart/${cartId}/support`);
  };

  /** Add a support offer in your cart */
  addCartSupportByCartId = (
    cartId: string,
    body: OrderCartGenericProductCreation
  ): Promise<OrderCartItem> => {
    return this.ovh.request('POST', `/order/cart/${cartId}/support`, body);
  };

  /** Get informations about VoIP offers */
  getCartTelephonyByCartId = (cartId: string): Promise<OrderCartGenericProductDefinition[]> => {
    return this.ovh.request('GET', `/order/cart/${cartId}/telephony`);
  };

  /** Post a new VoIP item in your cart */
  postCartTelephonyByCartId = (
    cartId: string,
    body: OrderCartGenericProductCreation
  ): Promise<OrderCartItem> => {
    return this.ovh.request('POST', `/order/cart/${cartId}/telephony`, body);
  };

  /** Get informations about VoIP options */
  getCartTelephonyOptionsByCartId = (
    cartId: string
  ): Promise<OrderCartGenericOptionDefinition[]> => {
    return this.ovh.request('GET', `/order/cart/${cartId}/telephony/options`);
  };

  /** Post a new VoIP option in your cart */
  postCartTelephonyOptionsByCartId = (
    cartId: string,
    body: OrderCartGenericOptionCreation
  ): Promise<OrderCartItem> => {
    return this.ovh.request('POST', `/order/cart/${cartId}/telephony/options`, body);
  };

  /** Get informations about OVHcloud Connect offers */
  getCartVcoByCartId = (cartId: string): Promise<OrderCartGenericProductDefinition[]> => {
    return this.ovh.request('GET', `/order/cart/${cartId}/vco`);
  };

  /** Post a new OVHcloud Connect item in your cart */
  postCartVcoByCartId = (
    cartId: string,
    body: { duration: string; planCode: string; pricingMode: string; quantity: number }
  ): Promise<OrderCartItem> => {
    return this.ovh.request('POST', `/order/cart/${cartId}/vco`, body);
  };

  /** Get informations about Horizon View offers */
  getCartVdiByCartId = (cartId: string): Promise<OrderCartGenericProductDefinition[]> => {
    return this.ovh.request('GET', `/order/cart/${cartId}/vdi`);
  };

  /** Post a new Horizon View item in your cart */
  postCartVdiByCartId = (
    cartId: string,
    body: OrderCartGenericProductCreation
  ): Promise<OrderCartItem> => {
    return this.ovh.request('POST', `/order/cart/${cartId}/vdi`, body);
  };

  /** Get informations about Horizon View options */
  getCartVdiOptionsByCartId = (cartId: string): Promise<OrderCartGenericOptionDefinition[]> => {
    return this.ovh.request('GET', `/order/cart/${cartId}/vdi/options`);
  };

  /** Post a new Horizon View option in your cart */
  postCartVdiOptionsByCartId = (
    cartId: string,
    body: OrderCartGenericOptionCreation
  ): Promise<OrderCartItem> => {
    return this.ovh.request('POST', `/order/cart/${cartId}/vdi/options`, body);
  };

  /** Get informations about Veeam Enterprise offers */
  getCartVeeamEnterpriseByCartId = (
    cartId: string
  ): Promise<OrderCartGenericProductDefinition[]> => {
    return this.ovh.request('GET', `/order/cart/${cartId}/veeamEnterprise`);
  };

  /** Post a new Veeam Enterprise item in your cart */
  postCartVeeamEnterpriseByCartId = (
    cartId: string,
    body: OrderCartGenericProductCreation
  ): Promise<OrderCartItem> => {
    return this.ovh.request('POST', `/order/cart/${cartId}/veeamEnterprise`, body);
  };

  /** Get informations about Veeam Enterprise options */
  getCartVeeamEnterpriseOptionsByCartId = (
    cartId: string
  ): Promise<OrderCartGenericOptionDefinition[]> => {
    return this.ovh.request('GET', `/order/cart/${cartId}/veeamEnterprise/options`);
  };

  /** Post a new Veeam Enterprise option in your cart */
  postCartVeeamEnterpriseOptionsByCartId = (
    cartId: string,
    body: OrderCartGenericOptionCreation
  ): Promise<OrderCartItem> => {
    return this.ovh.request('POST', `/order/cart/${cartId}/veeamEnterprise/options`, body);
  };

  /** Get informations about Veeam Cloud Connect offers */
  getCartVeeamccByCartId = (cartId: string): Promise<OrderCartGenericProductDefinition[]> => {
    return this.ovh.request('GET', `/order/cart/${cartId}/veeamcc`);
  };

  /** Post a new Veeam Cloud Connect item in your cart */
  postCartVeeamccByCartId = (
    cartId: string,
    body: OrderCartGenericProductCreation
  ): Promise<OrderCartItem> => {
    return this.ovh.request('POST', `/order/cart/${cartId}/veeamcc`, body);
  };

  /** Get informations about Veeam Cloud Connect options */
  getCartVeeamccOptionsByCartId = (cartId: string): Promise<OrderCartGenericOptionDefinition[]> => {
    return this.ovh.request('GET', `/order/cart/${cartId}/veeamcc/options`);
  };

  /** Post a new Veeam Cloud Connect option in your cart */
  postCartVeeamccOptionsByCartId = (
    cartId: string,
    body: OrderCartGenericOptionCreation
  ): Promise<OrderCartItem> => {
    return this.ovh.request('POST', `/order/cart/${cartId}/veeamcc/options`, body);
  };

  /** Get informations about VPS offers */
  getCartVpsByCartId = (cartId: string): Promise<OrderCartGenericProductDefinition[]> => {
    return this.ovh.request('GET', `/order/cart/${cartId}/vps`);
  };

  /** Post a new VPS item in your cart */
  postCartVpsByCartId = (
    cartId: string,
    body: OrderCartGenericProductCreation
  ): Promise<OrderCartItem> => {
    return this.ovh.request('POST', `/order/cart/${cartId}/vps`, body);
  };

  /** Get informations about VPS options */
  getCartVpsOptionsByCartId = (cartId: string): Promise<OrderCartGenericOptionDefinition[]> => {
    return this.ovh.request('GET', `/order/cart/${cartId}/vps/options`);
  };

  /** Post a new VPS option in your cart */
  postCartVpsOptionsByCartId = (
    cartId: string,
    body: OrderCartGenericOptionCreation
  ): Promise<OrderCartItem> => {
    return this.ovh.request('POST', `/order/cart/${cartId}/vps/options`, body);
  };

  /** Get informations about vRack offers */
  getCartVrackByCartId = (cartId: string): Promise<OrderCartGenericProductDefinition[]> => {
    return this.ovh.request('GET', `/order/cart/${cartId}/vrack`);
  };

  /** Post a new vRack item in your cart */
  postCartVrackByCartId = (
    cartId: string,
    body: OrderCartGenericProductCreation
  ): Promise<OrderCartItem> => {
    return this.ovh.request('POST', `/order/cart/${cartId}/vrack`, body);
  };

  /** Get informations about vRack offers */
  getCartVrackResellerByCartId = (cartId: string): Promise<OrderCartGenericProductDefinition[]> => {
    return this.ovh.request('GET', `/order/cart/${cartId}/vrackReseller`);
  };

  /** Post a new vRack item in your cart */
  postCartVrackResellerByCartId = (
    cartId: string,
    body: { duration: string; planCode: string; pricingMode: string; quantity: number }
  ): Promise<OrderCartItem> => {
    return this.ovh.request('POST', `/order/cart/${cartId}/vrackReseller`, body);
  };

  /** Get informations about webHosting offers */
  getCartWebHostingByCartId = (cartId: string): Promise<OrderCartGenericProductDefinition[]> => {
    return this.ovh.request('GET', `/order/cart/${cartId}/webHosting`);
  };

  /** Post a new webHosting item in your cart */
  postCartWebHostingByCartId = (
    cartId: string,
    body: OrderCartGenericProductCreation
  ): Promise<OrderCartItem> => {
    return this.ovh.request('POST', `/order/cart/${cartId}/webHosting`, body);
  };

  /** Get informations about webHosting options */
  getCartWebHostingOptionsByCartId = (
    cartId: string
  ): Promise<OrderCartGenericOptionDefinition[]> => {
    return this.ovh.request('GET', `/order/cart/${cartId}/webHosting/options`);
  };

  /** Post a new webHosting option in your cart */
  postCartWebHostingOptionsByCartId = (
    cartId: string,
    body: OrderCartGenericOptionCreation
  ): Promise<OrderCartItem> => {
    return this.ovh.request('POST', `/order/cart/${cartId}/webHosting/options`, body);
  };

  /** Get all web PaaS offers available */
  getCartWebPaaSByCartId = (cartId: string): Promise<OrderCartGenericProductDefinition[]> => {
    return this.ovh.request('GET', `/order/cart/${cartId}/webPaaS`);
  };

  /** Add a web PaaS offer in your cart */
  addCartWebPaaSByCartId = (
    cartId: string,
    body: OrderCartGenericProductCreation
  ): Promise<OrderCartItem> => {
    return this.ovh.request('POST', `/order/cart/${cartId}/webPaaS`, body);
  };

  /** Get information about webPaaS options */
  getCartWebPaaSOptionsByCartId = (cartId: string): Promise<OrderCartGenericOptionDefinition[]> => {
    return this.ovh.request('GET', `/order/cart/${cartId}/webPaaS/options`);
  };

  /** Post a new webPaaS option in your cart */
  postCartWebPaaSOptionsByCartId = (
    cartId: string,
    body: OrderCartGenericOptionCreation
  ): Promise<OrderCartItem> => {
    return this.ovh.request('POST', `/order/cart/${cartId}/webPaaS/options`, body);
  };

  /** Get informations about xdsl offers */
  getCartXdslByCartId = (cartId: string): Promise<OrderCartGenericProductDefinition[]> => {
    return this.ovh.request('GET', `/order/cart/${cartId}/xdsl`);
  };

  /** Post a new xdsl item in your cart */
  postCartXdslByCartId = (
    cartId: string,
    body: OrderCartGenericProductCreation
  ): Promise<OrderCartItem> => {
    return this.ovh.request('POST', `/order/cart/${cartId}/xdsl`, body);
  };

  /** Get informations about xdsl options */
  getCartXdslOptionsByCartId = (cartId: string): Promise<OrderCartGenericOptionDefinition[]> => {
    return this.ovh.request('GET', `/order/cart/${cartId}/xdsl/options`);
  };

  /** Post a new xdsl option in your cart */
  postCartXdslOptionsByCartId = (
    cartId: string,
    body: OrderCartGenericOptionCreation
  ): Promise<OrderCartItem> => {
    return this.ovh.request('POST', `/order/cart/${cartId}/xdsl/options`, body);
  };

  /** List available services */
  listCartServiceOptionAnthos = (): Promise<string[]> => {
    return this.ovh.request('GET', '/order/cartServiceOption/anthos');
  };

  /** Get informations about additional anthos offer for your service */
  getCartServiceOptionAnthosByServiceName = (
    serviceName: string
  ): Promise<OrderCartGenericOptionDefinition[]> => {
    return this.ovh.request('GET', `/order/cartServiceOption/anthos/${serviceName}`);
  };

  /** Post an additional anthos option in your cart */
  postCartServiceOptionAnthosByServiceName = (
    serviceName: string,
    body: {
      cartId: string;
      duration: string;
      planCode: string;
      pricingMode: string;
      quantity: number;
    }
  ): Promise<OrderCartItem> => {
    return this.ovh.request('POST', `/order/cartServiceOption/anthos/${serviceName}`, body);
  };

  /** List available services */
  listCartServiceOptionBaremetalServers = (): Promise<string[]> => {
    return this.ovh.request('GET', '/order/cartServiceOption/baremetalServers');
  };

  /** Get informations about additional baremetal servers offer for your service */
  getCartServiceOptionBaremetalServersByServiceName = (
    serviceName: string
  ): Promise<OrderCartGenericOptionDefinition[]> => {
    return this.ovh.request('GET', `/order/cartServiceOption/baremetalServers/${serviceName}`);
  };

  /** Post an additional baremetal servers option in your cart */
  postCartServiceOptionBaremetalServersByServiceName = (
    serviceName: string,
    body: {
      cartId: string;
      duration: string;
      planCode: string;
      pricingMode: string;
      quantity: number;
    }
  ): Promise<OrderCartItem> => {
    return this.ovh.request(
      'POST',
      `/order/cartServiceOption/baremetalServers/${serviceName}`,
      body
    );
  };

  /** List available services */
  listCartServiceOptionCloud = (): Promise<string[]> => {
    return this.ovh.request('GET', '/order/cartServiceOption/cloud');
  };

  /** Get informations about additional Cloud offer for your service */
  getCartServiceOptionCloudByServiceName = (
    serviceName: string
  ): Promise<OrderCartGenericOptionDefinition[]> => {
    return this.ovh.request('GET', `/order/cartServiceOption/cloud/${serviceName}`);
  };

  /** Post an additional Cloud option in your cart */
  postCartServiceOptionCloudByServiceName = (
    serviceName: string,
    body: {
      cartId: string;
      duration: string;
      planCode: string;
      pricingMode: string;
      quantity: number;
    }
  ): Promise<OrderCartItem> => {
    return this.ovh.request('POST', `/order/cartServiceOption/cloud/${serviceName}`, body);
  };

  /** List available services */
  listCartServiceOptionDedicated = (): Promise<string[]> => {
    return this.ovh.request('GET', '/order/cartServiceOption/dedicated');
  };

  /** Get informations about additional dedicated offer for your service */
  getCartServiceOptionDedicatedByServiceName = (
    serviceName: string
  ): Promise<OrderCartGenericOptionDefinition[]> => {
    return this.ovh.request('GET', `/order/cartServiceOption/dedicated/${serviceName}`);
  };

  /** Post an additional dedicated option in your cart */
  postCartServiceOptionDedicatedByServiceName = (
    serviceName: string,
    body: {
      cartId: string;
      duration: string;
      planCode: string;
      pricingMode: string;
      quantity: number;
    }
  ): Promise<OrderCartItem> => {
    return this.ovh.request('POST', `/order/cartServiceOption/dedicated/${serviceName}`, body);
  };

  /** List available services */
  listCartServiceOptionDns = (): Promise<string[]> => {
    return this.ovh.request('GET', '/order/cartServiceOption/dns');
  };

  /** Get informations about additional Domain offer for your service */
  getCartServiceOptionDnsByServiceName = (
    serviceName: string
  ): Promise<OrderCartGenericOptionDefinition[]> => {
    return this.ovh.request('GET', `/order/cartServiceOption/dns/${serviceName}`);
  };

  /** Post an additional Domain option in your cart */
  postCartServiceOptionDnsByServiceName = (
    serviceName: string,
    body: {
      cartId: string;
      duration: string;
      planCode: string;
      pricingMode: string;
      quantity: number;
    }
  ): Promise<OrderCartItem> => {
    return this.ovh.request('POST', `/order/cartServiceOption/dns/${serviceName}`, body);
  };

  /** List available services */
  listCartServiceOptionDomain = (): Promise<string[]> => {
    return this.ovh.request('GET', '/order/cartServiceOption/domain');
  };

  /** Get informations about additional Domain offer for your service */
  getCartServiceOptionDomainByServiceName = (
    serviceName: string
  ): Promise<OrderCartGenericOptionDefinition[]> => {
    return this.ovh.request('GET', `/order/cartServiceOption/domain/${serviceName}`);
  };

  /** Post an additional Domain option in your cart */
  postCartServiceOptionDomainByServiceName = (
    serviceName: string,
    body: {
      cartId: string;
      duration: string;
      planCode: string;
      pricingMode: string;
      quantity: number;
    }
  ): Promise<OrderCartItem> => {
    return this.ovh.request('POST', `/order/cartServiceOption/domain/${serviceName}`, body);
  };

  /** List available services */
  listCartServiceOptionEmailpro = (): Promise<string[]> => {
    return this.ovh.request('GET', '/order/cartServiceOption/emailpro');
  };

  /** Get informations about additional EmailPro offer for your service */
  getCartServiceOptionEmailproByServiceName = (
    serviceName: string
  ): Promise<OrderCartGenericOptionDefinition[]> => {
    return this.ovh.request('GET', `/order/cartServiceOption/emailpro/${serviceName}`);
  };

  /** Post an additional EmailPro option in your cart */
  postCartServiceOptionEmailproByServiceName = (
    serviceName: string,
    body: {
      cartId: string;
      duration: string;
      planCode: string;
      pricingMode: string;
      quantity: number;
    }
  ): Promise<OrderCartItem> => {
    return this.ovh.request('POST', `/order/cartServiceOption/emailpro/${serviceName}`, body);
  };

  /** List available services */
  listCartServiceOptionIpLoadbalancing = (): Promise<string[]> => {
    return this.ovh.request('GET', '/order/cartServiceOption/ipLoadbalancing');
  };

  /** Get informations about additional IP Load-Balancing offer for your service */
  getCartServiceOptionIpLoadbalancingByServiceName = (
    serviceName: string
  ): Promise<OrderCartGenericOptionDefinition[]> => {
    return this.ovh.request('GET', `/order/cartServiceOption/ipLoadbalancing/${serviceName}`);
  };

  /** Post an additional IP Load-Balancing option in your cart */
  postCartServiceOptionIpLoadbalancingByServiceName = (
    serviceName: string,
    body: {
      cartId: string;
      duration: string;
      planCode: string;
      pricingMode: string;
      quantity: number;
    }
  ): Promise<OrderCartItem> => {
    return this.ovh.request(
      'POST',
      `/order/cartServiceOption/ipLoadbalancing/${serviceName}`,
      body
    );
  };

  /** List available services */
  listCartServiceOptionLogs = (): Promise<string[]> => {
    return this.ovh.request('GET', '/order/cartServiceOption/logs');
  };

  /** Get informations about additional Logs offer for your service */
  getCartServiceOptionLogsByServiceName = (
    serviceName: string
  ): Promise<OrderCartGenericOptionDefinition[]> => {
    return this.ovh.request('GET', `/order/cartServiceOption/logs/${serviceName}`);
  };

  /** Post an additional Logs option in your cart */
  postCartServiceOptionLogsByServiceName = (
    serviceName: string,
    body: {
      cartId: string;
      duration: string;
      planCode: string;
      pricingMode: string;
      quantity: number;
    }
  ): Promise<OrderCartItem> => {
    return this.ovh.request('POST', `/order/cartServiceOption/logs/${serviceName}`, body);
  };

  /** List available services */
  listCartServiceOptionMicrosoft = (): Promise<string[]> => {
    return this.ovh.request('GET', '/order/cartServiceOption/microsoft');
  };

  /** Get informations about additional Microsoft offer for your service */
  getCartServiceOptionMicrosoftByServiceName = (
    serviceName: string
  ): Promise<OrderCartGenericOptionDefinition[]> => {
    return this.ovh.request('GET', `/order/cartServiceOption/microsoft/${serviceName}`);
  };

  /** Post an additional Microsoft option in your cart */
  postCartServiceOptionMicrosoftByServiceName = (
    serviceName: string,
    body: {
      cartId: string;
      duration: string;
      planCode: string;
      pricingMode: string;
      quantity: number;
    }
  ): Promise<OrderCartItem> => {
    return this.ovh.request('POST', `/order/cartServiceOption/microsoft/${serviceName}`, body);
  };

  /** List available services */
  listCartServiceOptionMicrosoftExchange = (): Promise<string[]> => {
    return this.ovh.request('GET', '/order/cartServiceOption/microsoftExchange');
  };

  /** Get informations about additional Microsoft offer for your service */
  getCartServiceOptionMicrosoftExchangeByServiceName = (
    serviceName: string
  ): Promise<OrderCartGenericOptionDefinition[]> => {
    return this.ovh.request('GET', `/order/cartServiceOption/microsoftExchange/${serviceName}`);
  };

  /** Post an additional Microsoft option in your cart */
  postCartServiceOptionMicrosoftExchangeByServiceName = (
    serviceName: string,
    body: {
      cartId: string;
      duration: string;
      planCode: string;
      pricingMode: string;
      quantity: number;
    }
  ): Promise<OrderCartItem> => {
    return this.ovh.request(
      'POST',
      `/order/cartServiceOption/microsoftExchange/${serviceName}`,
      body
    );
  };

  /** List available services */
  listCartServiceOptionOffice365Prepaid = (): Promise<string[]> => {
    return this.ovh.request('GET', '/order/cartServiceOption/office365Prepaid');
  };

  /** Get informations about additional Office offer for your service */
  getCartServiceOptionOffice365PrepaidByServiceName = (
    serviceName: string
  ): Promise<OrderCartGenericOptionDefinition[]> => {
    return this.ovh.request('GET', `/order/cartServiceOption/office365Prepaid/${serviceName}`);
  };

  /** Post an additional Office option in your cart */
  postCartServiceOptionOffice365PrepaidByServiceName = (
    serviceName: string,
    body: {
      cartId: string;
      duration: string;
      planCode: string;
      pricingMode: string;
      quantity: number;
    }
  ): Promise<OrderCartItem> => {
    return this.ovh.request(
      'POST',
      `/order/cartServiceOption/office365Prepaid/${serviceName}`,
      body
    );
  };

  /** List available services */
  listCartServiceOptionOfficePrepaid = (): Promise<string[]> => {
    return this.ovh.request('GET', '/order/cartServiceOption/officePrepaid');
  };

  /** Get informations about additional officePrepaid offer for your service */
  getCartServiceOptionOfficePrepaidByServiceName = (
    serviceName: string
  ): Promise<OrderCartGenericOptionDefinition[]> => {
    return this.ovh.request('GET', `/order/cartServiceOption/officePrepaid/${serviceName}`);
  };

  /** Post an additional officePrepaid option in your cart */
  postCartServiceOptionOfficePrepaidByServiceName = (
    serviceName: string,
    body: {
      cartId: string;
      duration: string;
      planCode: string;
      pricingMode: string;
      quantity: number;
    }
  ): Promise<OrderCartItem> => {
    return this.ovh.request('POST', `/order/cartServiceOption/officePrepaid/${serviceName}`, body);
  };

  /** List available services */
  listCartServiceOptionPrivateCloud = (): Promise<string[]> => {
    return this.ovh.request('GET', '/order/cartServiceOption/privateCloud');
  };

  /** Get informations about additional Dedicated Cloud offer for your service */
  getCartServiceOptionPrivateCloudByServiceName = (
    serviceName: string
  ): Promise<OrderCartGenericOptionDefinition[]> => {
    return this.ovh.request('GET', `/order/cartServiceOption/privateCloud/${serviceName}`);
  };

  /** Post an additional Dedicated Cloud option in your cart */
  postCartServiceOptionPrivateCloudByServiceName = (
    serviceName: string,
    body: {
      cartId: string;
      duration: string;
      planCode: string;
      pricingMode: string;
      quantity: number;
    }
  ): Promise<OrderCartItem> => {
    return this.ovh.request('POST', `/order/cartServiceOption/privateCloud/${serviceName}`, body);
  };

  /** List available services */
  listCartServiceOptionPrivateCloudEnterprise = (): Promise<string[]> => {
    return this.ovh.request('GET', '/order/cartServiceOption/privateCloudEnterprise');
  };

  /** Get informations about additional Dedicated Cloud offer for your service */
  getCartServiceOptionPrivateCloudEnterpriseByServiceName = (
    serviceName: string
  ): Promise<OrderCartGenericOptionDefinition[]> => {
    return this.ovh.request(
      'GET',
      `/order/cartServiceOption/privateCloudEnterprise/${serviceName}`
    );
  };

  /** Post an additional Dedicated Cloud option in your cart */
  postCartServiceOptionPrivateCloudEnterpriseByServiceName = (
    serviceName: string,
    body: {
      cartId: string;
      duration: string;
      planCode: string;
      pricingMode: string;
      quantity: number;
    }
  ): Promise<OrderCartItem> => {
    return this.ovh.request(
      'POST',
      `/order/cartServiceOption/privateCloudEnterprise/${serviceName}`,
      body
    );
  };

  /** List available services */
  listCartServiceOptionPrivateCloudReseller = (): Promise<string[]> => {
    return this.ovh.request('GET', '/order/cartServiceOption/privateCloudReseller');
  };

  /** Get informations about additional Dedicated Cloud offer for your service */
  getCartServiceOptionPrivateCloudResellerByServiceName = (
    serviceName: string
  ): Promise<OrderCartGenericOptionDefinition[]> => {
    return this.ovh.request('GET', `/order/cartServiceOption/privateCloudReseller/${serviceName}`);
  };

  /** Post an additional Dedicated Cloud option in your cart */
  postCartServiceOptionPrivateCloudResellerByServiceName = (
    serviceName: string,
    body: {
      cartId: string;
      duration: string;
      planCode: string;
      pricingMode: string;
      quantity: number;
    }
  ): Promise<OrderCartItem> => {
    return this.ovh.request(
      'POST',
      `/order/cartServiceOption/privateCloudReseller/${serviceName}`,
      body
    );
  };

  /** List available services */
  listCartServiceOptionPrivateCloudResellerEnterprise = (): Promise<string[]> => {
    return this.ovh.request('GET', '/order/cartServiceOption/privateCloudResellerEnterprise');
  };

  /** Get informations about additional Dedicated Cloud Enterprise offer for your service */
  getCartServiceOptionPrivateCloudResellerEnterpriseByServiceName = (
    serviceName: string
  ): Promise<OrderCartGenericOptionDefinition[]> => {
    return this.ovh.request(
      'GET',
      `/order/cartServiceOption/privateCloudResellerEnterprise/${serviceName}`
    );
  };

  /** Post an additional Dedicated Cloud Enterprise option in your cart */
  postCartServiceOptionPrivateCloudResellerEnterpriseByServiceName = (
    serviceName: string,
    body: {
      cartId: string;
      duration: string;
      planCode: string;
      pricingMode: string;
      quantity: number;
    }
  ): Promise<OrderCartItem> => {
    return this.ovh.request(
      'POST',
      `/order/cartServiceOption/privateCloudResellerEnterprise/${serviceName}`,
      body
    );
  };

  /** List available services */
  listCartServiceOptionSharepoint = (): Promise<string[]> => {
    return this.ovh.request('GET', '/order/cartServiceOption/sharepoint');
  };

  /** Get informations about additional Sharepoint offer for your service */
  getCartServiceOptionSharepointByServiceName = (
    serviceName: string
  ): Promise<OrderCartGenericOptionDefinition[]> => {
    return this.ovh.request('GET', `/order/cartServiceOption/sharepoint/${serviceName}`);
  };

  /** Post an additional Sharepoint option in your cart */
  postCartServiceOptionSharepointByServiceName = (
    serviceName: string,
    body: {
      cartId: string;
      duration: string;
      planCode: string;
      pricingMode: string;
      quantity: number;
    }
  ): Promise<OrderCartItem> => {
    return this.ovh.request('POST', `/order/cartServiceOption/sharepoint/${serviceName}`, body);
  };

  /** List available services */
  listCartServiceOptionSslGateway = (): Promise<string[]> => {
    return this.ovh.request('GET', '/order/cartServiceOption/sslGateway');
  };

  /** Get informations about additional SSL Gateway offer for your service */
  getCartServiceOptionSslGatewayByServiceName = (
    serviceName: string
  ): Promise<OrderCartGenericOptionDefinition[]> => {
    return this.ovh.request('GET', `/order/cartServiceOption/sslGateway/${serviceName}`);
  };

  /** Post an additional SSL Gateway option in your cart */
  postCartServiceOptionSslGatewayByServiceName = (
    serviceName: string,
    body: {
      cartId: string;
      duration: string;
      planCode: string;
      pricingMode: string;
      quantity: number;
    }
  ): Promise<OrderCartItem> => {
    return this.ovh.request('POST', `/order/cartServiceOption/sslGateway/${serviceName}`, body);
  };

  /** List available services */
  listCartServiceOptionVdi = (): Promise<string[]> => {
    return this.ovh.request('GET', '/order/cartServiceOption/vdi');
  };

  /** Get informations about additional Horizon View offer for your service */
  getCartServiceOptionVdiByServiceName = (
    serviceName: string
  ): Promise<OrderCartGenericOptionDefinition[]> => {
    return this.ovh.request('GET', `/order/cartServiceOption/vdi/${serviceName}`);
  };

  /** Post an additional Horizon View option in your cart */
  postCartServiceOptionVdiByServiceName = (
    serviceName: string,
    body: {
      cartId: string;
      duration: string;
      planCode: string;
      pricingMode: string;
      quantity: number;
    }
  ): Promise<OrderCartItem> => {
    return this.ovh.request('POST', `/order/cartServiceOption/vdi/${serviceName}`, body);
  };

  /** List available services */
  listCartServiceOptionVps = (): Promise<string[]> => {
    return this.ovh.request('GET', '/order/cartServiceOption/vps');
  };

  /** Get informations about additional VPS offer for your service */
  getCartServiceOptionVpsByServiceName = (
    serviceName: string
  ): Promise<OrderCartGenericOptionDefinition[]> => {
    return this.ovh.request('GET', `/order/cartServiceOption/vps/${serviceName}`);
  };

  /** Post an additional VPS option in your cart */
  postCartServiceOptionVpsByServiceName = (
    serviceName: string,
    body: {
      cartId: string;
      duration: string;
      planCode: string;
      pricingMode: string;
      quantity: number;
    }
  ): Promise<OrderCartItem> => {
    return this.ovh.request('POST', `/order/cartServiceOption/vps/${serviceName}`, body);
  };

  /** List available services */
  listCartServiceOptionWebHosting = (): Promise<string[]> => {
    return this.ovh.request('GET', '/order/cartServiceOption/webHosting');
  };

  /** Get informations about additional Web Hosting offer for your service */
  getCartServiceOptionWebHostingByServiceName = (
    serviceName: string
  ): Promise<OrderCartGenericOptionDefinition[]> => {
    return this.ovh.request('GET', `/order/cartServiceOption/webHosting/${serviceName}`);
  };

  /** Post an additional Web Hosting option in your cart */
  postCartServiceOptionWebHostingByServiceName = (
    serviceName: string,
    body: {
      cartId: string;
      duration: string;
      planCode: string;
      pricingMode: string;
      quantity: number;
    }
  ): Promise<OrderCartItem> => {
    return this.ovh.request('POST', `/order/cartServiceOption/webHosting/${serviceName}`, body);
  };

  /** List available services */
  listCartServiceOptionWebPaaS = (): Promise<string[]> => {
    return this.ovh.request('GET', '/order/cartServiceOption/webPaaS');
  };

  /** Get informations about additional Web PaaS offer for your service */
  getCartServiceOptionWebPaaSByServiceName = (
    serviceName: string
  ): Promise<OrderCartGenericOptionDefinition[]> => {
    return this.ovh.request('GET', `/order/cartServiceOption/webPaaS/${serviceName}`);
  };

  /** Post an additional Web PaaS option in your cart */
  postCartServiceOptionWebPaaSByServiceName = (
    serviceName: string,
    body: {
      cartId: string;
      duration: string;
      planCode: string;
      pricingMode: string;
      quantity: number;
    }
  ): Promise<OrderCartItem> => {
    return this.ovh.request('POST', `/order/cartServiceOption/webPaaS/${serviceName}`, body);
  };

  /** Retrieve list of catalog name */
  getCatalogFormatted = (): Promise<string[]> => {
    return this.ovh.request('GET', '/order/catalog/formatted');
  };

  /** Retrieve information of bring your own IP addresses catalog */
  getCatalogFormattedBringYourOwnIp = (): Promise<OrderCatalogCatalog> => {
    return this.ovh.request('GET', '/order/catalog/formatted/bringYourOwnIp');
  };

  /** Retrieve information of Public Cloud catalog */
  getCatalogFormattedCloud = (): Promise<OrderCatalogCatalog> => {
    return this.ovh.request('GET', '/order/catalog/formatted/cloud');
  };

  /** Retrieve information of dedicated server catalog */
  getCatalogFormattedDedicated = (): Promise<OrderCatalogDedicatedCatalog> => {
    return this.ovh.request('GET', '/order/catalog/formatted/dedicated');
  };

  /** Retrieve information of Desk as a service catalog */
  getCatalogFormattedDeskaas = (): Promise<OrderCatalogCatalog> => {
    return this.ovh.request('GET', '/order/catalog/formatted/deskaas');
  };

  /** Retrieve information of dedicated discover offer server catalog */
  getCatalogFormattedDiscover = (): Promise<OrderCatalogDedicatedCatalog> => {
    return this.ovh.request('GET', '/order/catalog/formatted/discover');
  };

  /** Retrieve information of IP addresses catalog */
  getCatalogFormattedIp = (): Promise<OrderCatalogCatalog> => {
    return this.ovh.request('GET', '/order/catalog/formatted/ip');
  };

  /** Retrieve information of CloudLinux licenses catalog */
  getCatalogFormattedLicenseCloudLinux = (): Promise<OrderCatalogCatalog> => {
    return this.ovh.request('GET', '/order/catalog/formatted/licenseCloudLinux');
  };

  /** Retrieve information of Directadmin licenses offers catalog */
  getCatalogFormattedLicenseDirectadmin = (): Promise<OrderCatalogCatalog> => {
    return this.ovh.request('GET', '/order/catalog/formatted/licenseDirectadmin');
  };

  /** Retrieve information of Plesk licenses catalog */
  getCatalogFormattedLicensePlesk = (): Promise<OrderCatalogCatalog> => {
    return this.ovh.request('GET', '/order/catalog/formatted/licensePlesk');
  };

  /** Retrieve information of SqlServer licenses catalog */
  getCatalogFormattedLicenseSqlServer = (): Promise<OrderCatalogCatalog> => {
    return this.ovh.request('GET', '/order/catalog/formatted/licenseSqlServer');
  };

  /** Retrieve information of Virtuozzo licenses catalog */
  getCatalogFormattedLicenseVirtuozzo = (): Promise<OrderCatalogCatalog> => {
    return this.ovh.request('GET', '/order/catalog/formatted/licenseVirtuozzo');
  };

  /** Retrieve information of Windows licenses catalog */
  getCatalogFormattedLicenseWindows = (): Promise<OrderCatalogCatalog> => {
    return this.ovh.request('GET', '/order/catalog/formatted/licenseWindows');
  };

  /** Retrieve information of Worklight licenses catalog */
  getCatalogFormattedLicenseWorklight = (): Promise<OrderCatalogCatalog> => {
    return this.ovh.request('GET', '/order/catalog/formatted/licenseWorklight');
  };

  /** Retrieve information of cPanel licenses catalog */
  getCatalogFormattedLicensecPanel = (): Promise<OrderCatalogCatalog> => {
    return this.ovh.request('GET', '/order/catalog/formatted/licensecPanel');
  };

  /** Retrieve information of Logs Data Platform catalog */
  getCatalogFormattedLogs = (): Promise<OrderCatalogCatalog> => {
    return this.ovh.request('GET', '/order/catalog/formatted/logs');
  };

  /** Retrieve information of Dedicated Cloud catalog */
  getCatalogFormattedPrivateCloud = (): Promise<OrderCatalogPccCatalog> => {
    return this.ovh.request('GET', '/order/catalog/formatted/privateCloud');
  };

  /** Retrieve information of Dedicated Cloud CDI catalog */
  getCatalogFormattedPrivateCloudCDI = (): Promise<OrderCatalogPrivateCloudCatalog> => {
    return this.ovh.request('GET', '/order/catalog/formatted/privateCloudCDI');
  };

  /** Retrieve information of Dedicated Cloud catalog */
  getCatalogFormattedPrivateCloudDC = (): Promise<OrderCatalogPrivateCloudCatalog> => {
    return this.ovh.request('GET', '/order/catalog/formatted/privateCloudDC');
  };

  /** Retrieve information of Hosted Dedicated Cloud Enterprise catalog */
  getCatalogFormattedPrivateCloudEnterprise = (): Promise<OrderCatalogPccCatalog> => {
    return this.ovh.request('GET', '/order/catalog/formatted/privateCloudEnterprise');
  };

  /** Retrieve information of Dedicated Cloud Reseller catalog */
  getCatalogFormattedPrivateCloudReseller = (): Promise<OrderCatalogPccCatalog> => {
    return this.ovh.request('GET', '/order/catalog/formatted/privateCloudReseller');
  };

  /** Retrieve information of Dedicated Cloud Reseller Enterprise catalog */
  getCatalogFormattedPrivateCloudResellerEnterprise = (): Promise<OrderCatalogPccCatalog> => {
    return this.ovh.request('GET', '/order/catalog/formatted/privateCloudResellerEnterprise');
  };

  /** Retrieve information of Dedicated Cloud SDDC catalog */
  getCatalogFormattedPrivateCloudSDDC = (): Promise<OrderCatalogPrivateCloudCatalog> => {
    return this.ovh.request('GET', '/order/catalog/formatted/privateCloudSDDC');
  };

  /** Retrieve information of Reseller catalog */
  getCatalogFormattedReseller = (): Promise<OrderCatalogCatalog> => {
    return this.ovh.request('GET', '/order/catalog/formatted/reseller');
  };

  /** Retrieve information of VPS catalog */
  getCatalogFormattedVps = (): Promise<OrderCatalogCatalog> => {
    return this.ovh.request('GET', '/order/catalog/formatted/vps');
  };

  /** Retrieve information of catalog */
  getCatalogPrivatePrivateCloud = (): Promise<OrderCatalogPccCatalog> => {
    return this.ovh.request('GET', '/order/catalog/private/privateCloud');
  };

  /** Retrieve Anthos catalog */
  getCatalogPublicAnthos = (): Promise<OrderCatalogPublicCatalog> => {
    return this.ovh.request('GET', '/order/catalog/public/anthos');
  };

  /** Retrieve bare-metal servers catalog */
  getCatalogPublicBaremetalServers = (): Promise<OrderCatalogPublicDedicatedServerCatalog> => {
    return this.ovh.request('GET', '/order/catalog/public/baremetalServers');
  };

  /** Retrieve Public Cloud catalog */
  getCatalogPublicCloud = (): Promise<OrderCatalogPublicCatalog> => {
    return this.ovh.request('GET', '/order/catalog/public/cloud');
  };

  /** Retrieve Cloud DB catalog */
  getCatalogPublicCloudDB = (): Promise<OrderCatalogPublicCatalog> => {
    return this.ovh.request('GET', '/order/catalog/public/cloudDB');
  };

  /** Retrieve DNS catalog */
  getCatalogPublicDns = (): Promise<OrderCatalogPublicCatalog> => {
    return this.ovh.request('GET', '/order/catalog/public/dns');
  };

  /** Retrieve domain catalog */
  getCatalogPublicDomain = (): Promise<OrderCatalogPublicCatalog> => {
    return this.ovh.request('GET', '/order/catalog/public/domain');
  };

  /** Retrieve Eco catalog */
  getCatalogPublicEco = (): Promise<OrderCatalogPublicCatalog> => {
    return this.ovh.request('GET', '/order/catalog/public/eco');
  };

  /** Retrieve Email Domain catalog */
  getCatalogPublicEmailDomain = (): Promise<OrderCatalogPublicCatalog> => {
    return this.ovh.request('GET', '/order/catalog/public/emailDomain');
  };

  /** Retrieve emailpro catalog */
  getCatalogPublicEmailpro = (): Promise<OrderCatalogPublicCatalog> => {
    return this.ovh.request('GET', '/order/catalog/public/emailpro');
  };

  /** Retrieve exchange catalog */
  getCatalogPublicExchange = (): Promise<OrderCatalogPublicCatalog> => {
    return this.ovh.request('GET', '/order/catalog/public/exchange');
  };

  /** Retrieve IP Load Balancing catalog */
  getCatalogPublicIpLoadbalancing = (): Promise<OrderCatalogPublicCatalog> => {
    return this.ovh.request('GET', '/order/catalog/public/ipLoadbalancing');
  };

  /** Retrieve License cPanel catalog */
  getCatalogPublicLicensecPanel = (): Promise<OrderCatalogPublicCatalog> => {
    return this.ovh.request('GET', '/order/catalog/public/licensecPanel');
  };

  /** Retrieve Logs catalog */
  getCatalogPublicLogs = (): Promise<OrderCatalogPublicCatalog> => {
    return this.ovh.request('GET', '/order/catalog/public/logs');
  };

  /** Retrieve nasha catalog */
  getCatalogPublicNasha = (): Promise<OrderCatalogPublicCatalog> => {
    return this.ovh.request('GET', '/order/catalog/public/nasha');
  };

  /** Retrieve Netapp catalog */
  getCatalogPublicNetapp = (): Promise<OrderCatalogPublicCatalog> => {
    return this.ovh.request('GET', '/order/catalog/public/netapp');
  };

  /** Retrieve Nutanix clusters catalog */
  getCatalogPublicNutanix = (): Promise<OrderCatalogPublicCatalog> => {
    return this.ovh.request('GET', '/order/catalog/public/nutanix');
  };

  /** Retrieve office365Prepaid catalog */
  getCatalogPublicOffice365Prepaid = (): Promise<OrderCatalogPublicCatalog> => {
    return this.ovh.request('GET', '/order/catalog/public/office365Prepaid');
  };

  /** Retrieve Office Prepaid catalog */
  getCatalogPublicOfficePrepaid = (): Promise<OrderCatalogPublicCatalog> => {
    return this.ovh.request('GET', '/order/catalog/public/officePrepaid');
  };

  /** Retrieve OVH Cloud Connect catalog */
  getCatalogPublicOvhCloudConnect = (): Promise<OrderCatalogPublicCatalog> => {
    return this.ovh.request('GET', '/order/catalog/public/ovhCloudConnect');
  };

  /** Retrieve packs_professional_services catalog */
  getCatalogPublicPacksProfessionalServices = (): Promise<OrderCatalogPublicCatalog> => {
    return this.ovh.request('GET', '/order/catalog/public/packsProfessionalServices');
  };

  /** Retrieve Dedicated Cloud catalog */
  getCatalogPublicPrivateCloud = (): Promise<OrderCatalogPublicCatalog> => {
    return this.ovh.request('GET', '/order/catalog/public/privateCloud');
  };

  /** Retrieve Private Cloud Enterprise catalog */
  getCatalogPublicPrivateCloudEnterprise = (): Promise<OrderCatalogPublicCatalog> => {
    return this.ovh.request('GET', '/order/catalog/public/privateCloudEnterprise');
  };

  /** Retrieve Private SQL catalog */
  getCatalogPublicPrivateSQL = (): Promise<OrderCatalogPublicCatalog> => {
    return this.ovh.request('GET', '/order/catalog/public/privateSQL');
  };

  /** Retrieve Telephony catalog */
  getCatalogPublicTelephony = (): Promise<OrderCatalogPublicCatalog> => {
    return this.ovh.request('GET', '/order/catalog/public/telephony');
  };

  /** Retrieve VPS catalog */
  getCatalogPublicVps = (): Promise<OrderCatalogPublicCatalog> => {
    return this.ovh.request('GET', '/order/catalog/public/vps');
  };

  /** Retrieve Web Hosting catalog */
  getCatalogPublicWebHosting = (): Promise<OrderCatalogPublicCatalog> => {
    return this.ovh.request('GET', '/order/catalog/public/webHosting');
  };

  /** Retrieve Web PaaS catalog */
  getCatalogPublicWebPaaS = (): Promise<OrderCatalogPublicCatalog> => {
    return this.ovh.request('GET', '/order/catalog/public/webPaaS');
  };

  /** List available services */
  listCdnDedicated = (): Promise<string[]> => {
    return this.ovh.request('GET', '/order/cdn/dedicated');
  };

  /** Get allowed durations for 'new' option */
  getCdnDedicatedNew = (): Promise<string[]> => {
    return this.ovh.request('GET', '/order/cdn/dedicated/new');
  };

  /** Get prices and contracts information */
  getCdnDedicatedNewByDuration = (duration: string): Promise<OrderOrder> => {
    return this.ovh.request('GET', `/order/cdn/dedicated/new/${duration}`);
  };

  /** Create order */
  createCdnDedicatedNewByDuration = (duration: string): Promise<OrderOrder> => {
    return this.ovh.request('POST', `/order/cdn/dedicated/new/${duration}`);
  };

  /** Get allowed options */
  getCdnDedicatedByServiceName = (serviceName: string): Promise<string[]> => {
    return this.ovh.request('GET', `/order/cdn/dedicated/${serviceName}`);
  };

  /** Get allowed durations for 'backend' option */
  getCdnDedicatedBackendByServiceName = (serviceName: string): Promise<string[]> => {
    return this.ovh.request('GET', `/order/cdn/dedicated/${serviceName}/backend`);
  };

  /** Get prices and contracts information */
  getCdnDedicatedBackendByServiceNameAndDuration = (
    duration: string,
    serviceName: string
  ): Promise<OrderOrder> => {
    return this.ovh.request('GET', `/order/cdn/dedicated/${serviceName}/backend/${duration}`);
  };

  /** Create order */
  createCdnDedicatedBackendByServiceNameAndDuration = (
    duration: string,
    serviceName: string,
    body: { backend: number }
  ): Promise<OrderOrder> => {
    return this.ovh.request(
      'POST',
      `/order/cdn/dedicated/${serviceName}/backend/${duration}`,
      body
    );
  };

  /** Get allowed durations for 'cacheRule' option */
  getCdnDedicatedCacheRuleByServiceName = (serviceName: string): Promise<string[]> => {
    return this.ovh.request('GET', `/order/cdn/dedicated/${serviceName}/cacheRule`);
  };

  /** Get prices and contracts information */
  getCdnDedicatedCacheRuleByServiceNameAndDuration = (
    duration: string,
    serviceName: string
  ): Promise<OrderOrder> => {
    return this.ovh.request('GET', `/order/cdn/dedicated/${serviceName}/cacheRule/${duration}`);
  };

  /** Create order */
  createCdnDedicatedCacheRuleByServiceNameAndDuration = (
    duration: string,
    serviceName: string,
    body: { cacheRule: CdnanycastOrderCacheRuleEnum }
  ): Promise<OrderOrder> => {
    return this.ovh.request(
      'POST',
      `/order/cdn/dedicated/${serviceName}/cacheRule/${duration}`,
      body
    );
  };

  /** Get allowed durations for 'quota' option */
  getCdnDedicatedQuotaByServiceName = (serviceName: string): Promise<string[]> => {
    return this.ovh.request('GET', `/order/cdn/dedicated/${serviceName}/quota`);
  };

  /** Get prices and contracts information */
  getCdnDedicatedQuotaByServiceNameAndDuration = (
    duration: string,
    serviceName: string
  ): Promise<OrderOrder> => {
    return this.ovh.request('GET', `/order/cdn/dedicated/${serviceName}/quota/${duration}`);
  };

  /** Create order */
  createCdnDedicatedQuotaByServiceNameAndDuration = (
    duration: string,
    serviceName: string,
    body: { quota: CdnanycastOrderQuotaEnum }
  ): Promise<OrderOrder> => {
    return this.ovh.request('POST', `/order/cdn/dedicated/${serviceName}/quota/${duration}`, body);
  };

  /** List available services */
  listCloudProject = (): Promise<string[]> => {
    return this.ovh.request('GET', '/order/cloud/project');
  };

  /** Get allowed options */
  getCloudProjectByServiceName = (serviceName: string): Promise<string[]> => {
    return this.ovh.request('GET', `/order/cloud/project/${serviceName}`);
  };

  /** Get prices and contracts information */
  getCloudProjectCreditByServiceName = (serviceName: string): Promise<OrderOrder> => {
    return this.ovh.request('GET', `/order/cloud/project/${serviceName}/credit`);
  };

  /** Create order */
  createCloudProjectCreditByServiceName = (
    serviceName: string,
    body: { amount: number }
  ): Promise<OrderOrder> => {
    return this.ovh.request('POST', `/order/cloud/project/${serviceName}/credit`, body);
  };

  /** List available services */
  listDedicatedHousing = (): Promise<string[]> => {
    return this.ovh.request('GET', '/order/dedicated/housing');
  };

  /** Get allowed options */
  getDedicatedHousingByServiceName = (serviceName: string): Promise<string[]> => {
    return this.ovh.request('GET', `/order/dedicated/housing/${serviceName}`);
  };

  /** Get allowed durations for 'APC' option */
  getDedicatedHousingAPCByServiceName = (serviceName: string): Promise<string[]> => {
    return this.ovh.request('GET', `/order/dedicated/housing/${serviceName}/APC`);
  };

  /** Get prices and contracts information */
  getDedicatedHousingAPCByServiceNameAndDuration = (
    duration: string,
    serviceName: string
  ): Promise<OrderOrder> => {
    return this.ovh.request('GET', `/order/dedicated/housing/${serviceName}/APC/${duration}`);
  };

  /** Create order */
  createDedicatedHousingAPCByServiceNameAndDuration = (
    duration: string,
    serviceName: string
  ): Promise<OrderOrder> => {
    return this.ovh.request('POST', `/order/dedicated/housing/${serviceName}/APC/${duration}`);
  };

  /** List available services */
  listDedicatedServer = (): Promise<string[]> => {
    return this.ovh.request('GET', '/order/dedicated/server');
  };

  /** Get allowed options */
  getDedicatedServerByServiceName = (serviceName: string): Promise<string[]> => {
    return this.ovh.request('GET', `/order/dedicated/server/${serviceName}`);
  };

  /** Get allowed durations for 'backupStorage' option */
  getDedicatedServerBackupStorageByServiceName = (serviceName: string): Promise<string[]> => {
    return this.ovh.request('GET', `/order/dedicated/server/${serviceName}/backupStorage`);
  };

  /** Get prices and contracts information */
  getDedicatedServerBackupStorageByServiceNameAndDuration = (
    duration: string,
    serviceName: string
  ): Promise<OrderOrder> => {
    return this.ovh.request(
      'GET',
      `/order/dedicated/server/${serviceName}/backupStorage/${duration}`
    );
  };

  /** Create order */
  createDedicatedServerBackupStorageByServiceNameAndDuration = (
    duration: string,
    serviceName: string,
    body: { capacity: DedicatedServerBackupStorageCapacityEnum }
  ): Promise<OrderOrder> => {
    return this.ovh.request(
      'POST',
      `/order/dedicated/server/${serviceName}/backupStorage/${duration}`,
      body
    );
  };

  /** Get allowed durations for 'bandwidth' option */
  getDedicatedServerBandwidthByServiceName = (serviceName: string): Promise<string[]> => {
    return this.ovh.request('GET', `/order/dedicated/server/${serviceName}/bandwidth`);
  };

  /** Get prices and contracts information */
  getDedicatedServerBandwidthByServiceNameAndDuration = (
    duration: string,
    serviceName: string
  ): Promise<OrderOrder> => {
    return this.ovh.request('GET', `/order/dedicated/server/${serviceName}/bandwidth/${duration}`);
  };

  /** Create order */
  createDedicatedServerBandwidthByServiceNameAndDuration = (
    duration: string,
    serviceName: string,
    body: {
      bandwidth: DedicatedServerBandwidthOrderEnum;
      type: DedicatedServerBandwidthOrderTypeEnum;
    }
  ): Promise<OrderOrder> => {
    return this.ovh.request(
      'POST',
      `/order/dedicated/server/${serviceName}/bandwidth/${duration}`,
      body
    );
  };

  /** Get allowed durations for 'bandwidthvRack' option */
  getDedicatedServerBandwidthvRackByServiceName = (serviceName: string): Promise<string[]> => {
    return this.ovh.request('GET', `/order/dedicated/server/${serviceName}/bandwidthvRack`);
  };

  /** Get prices and contracts information */
  getDedicatedServerBandwidthvRackByServiceNameAndDuration = (
    duration: string,
    serviceName: string
  ): Promise<OrderOrder> => {
    return this.ovh.request(
      'GET',
      `/order/dedicated/server/${serviceName}/bandwidthvRack/${duration}`
    );
  };

  /** Create order */
  createDedicatedServerBandwidthvRackByServiceNameAndDuration = (
    duration: string,
    serviceName: string,
    body: { bandwidth: DedicatedServerBandwidthvRackOrderEnum }
  ): Promise<OrderOrder> => {
    return this.ovh.request(
      'POST',
      `/order/dedicated/server/${serviceName}/bandwidthvRack/${duration}`,
      body
    );
  };

  /** Get allowed durations for 'feature' option */
  getDedicatedServerFeatureByServiceName = (serviceName: string): Promise<string[]> => {
    return this.ovh.request('GET', `/order/dedicated/server/${serviceName}/feature`);
  };

  /** Get prices and contracts information */
  getDedicatedServerFeatureByServiceNameAndDuration = (
    duration: string,
    serviceName: string
  ): Promise<OrderOrder> => {
    return this.ovh.request('GET', `/order/dedicated/server/${serviceName}/feature/${duration}`);
  };

  /** Create order */
  createDedicatedServerFeatureByServiceNameAndDuration = (
    duration: string,
    serviceName: string,
    body: { feature: DedicatedServerOrderableSysFeatureEnum }
  ): Promise<OrderOrder> => {
    return this.ovh.request(
      'POST',
      `/order/dedicated/server/${serviceName}/feature/${duration}`,
      body
    );
  };

  /** Get allowed durations for 'firewall' option */
  getDedicatedServerFirewallByServiceName = (serviceName: string): Promise<string[]> => {
    return this.ovh.request('GET', `/order/dedicated/server/${serviceName}/firewall`);
  };

  /** Get prices and contracts information */
  getDedicatedServerFirewallByServiceNameAndDuration = (
    duration: string,
    serviceName: string
  ): Promise<OrderOrder> => {
    return this.ovh.request('GET', `/order/dedicated/server/${serviceName}/firewall/${duration}`);
  };

  /** Create order */
  createDedicatedServerFirewallByServiceNameAndDuration = (
    duration: string,
    serviceName: string,
    body: { firewallModel: DedicatedServerFirewallModelEnum }
  ): Promise<OrderOrder> => {
    return this.ovh.request(
      'POST',
      `/order/dedicated/server/${serviceName}/firewall/${duration}`,
      body
    );
  };

  /** Get allowed durations for 'ipMigration' option */
  getDedicatedServerIpMigrationByServiceName = (serviceName: string): Promise<string[]> => {
    return this.ovh.request('GET', `/order/dedicated/server/${serviceName}/ipMigration`);
  };

  /** Get prices and contracts information */
  getDedicatedServerIpMigrationByServiceNameAndDuration = (
    duration: string,
    serviceName: string
  ): Promise<OrderOrder> => {
    return this.ovh.request(
      'GET',
      `/order/dedicated/server/${serviceName}/ipMigration/${duration}`
    );
  };

  /** Create order */
  createDedicatedServerIpMigrationByServiceNameAndDuration = (
    duration: string,
    serviceName: string,
    body: { ip: string; token: string }
  ): Promise<OrderOrder> => {
    return this.ovh.request(
      'POST',
      `/order/dedicated/server/${serviceName}/ipMigration/${duration}`,
      body
    );
  };

  /** Get allowed durations for 'kvm' option */
  getDedicatedServerKvmByServiceName = (serviceName: string): Promise<string[]> => {
    return this.ovh.request('GET', `/order/dedicated/server/${serviceName}/kvm`);
  };

  /** Get prices and contracts information */
  getDedicatedServerKvmByServiceNameAndDuration = (
    duration: string,
    serviceName: string
  ): Promise<OrderOrder> => {
    return this.ovh.request('GET', `/order/dedicated/server/${serviceName}/kvm/${duration}`);
  };

  /** Create order */
  createDedicatedServerKvmByServiceNameAndDuration = (
    duration: string,
    serviceName: string
  ): Promise<OrderOrder> => {
    return this.ovh.request('POST', `/order/dedicated/server/${serviceName}/kvm/${duration}`);
  };

  /** Get allowed durations for 'kvmExpress' option */
  getDedicatedServerKvmExpressByServiceName = (serviceName: string): Promise<string[]> => {
    return this.ovh.request('GET', `/order/dedicated/server/${serviceName}/kvmExpress`);
  };

  /** Get prices and contracts information */
  getDedicatedServerKvmExpressByServiceNameAndDuration = (
    duration: string,
    serviceName: string
  ): Promise<OrderOrder> => {
    return this.ovh.request('GET', `/order/dedicated/server/${serviceName}/kvmExpress/${duration}`);
  };

  /** Create order */
  createDedicatedServerKvmExpressByServiceNameAndDuration = (
    duration: string,
    serviceName: string
  ): Promise<OrderOrder> => {
    return this.ovh.request(
      'POST',
      `/order/dedicated/server/${serviceName}/kvmExpress/${duration}`
    );
  };

  /** Get allowed durations for 'professionalUse' option */
  getDedicatedServerProfessionalUseByServiceName = (serviceName: string): Promise<string[]> => {
    return this.ovh.request('GET', `/order/dedicated/server/${serviceName}/professionalUse`);
  };

  /** Get prices and contracts information */
  getDedicatedServerProfessionalUseByServiceNameAndDuration = (
    duration: string,
    serviceName: string
  ): Promise<OrderOrder> => {
    return this.ovh.request(
      'GET',
      `/order/dedicated/server/${serviceName}/professionalUse/${duration}`
    );
  };

  /** Create order */
  createDedicatedServerProfessionalUseByServiceNameAndDuration = (
    duration: string,
    serviceName: string
  ): Promise<OrderOrder> => {
    return this.ovh.request(
      'POST',
      `/order/dedicated/server/${serviceName}/professionalUse/${duration}`
    );
  };

  /** Get allowed durations for 'traffic' option */
  getDedicatedServerTrafficByServiceName = (serviceName: string): Promise<string[]> => {
    return this.ovh.request('GET', `/order/dedicated/server/${serviceName}/traffic`);
  };

  /** Get prices and contracts information */
  getDedicatedServerTrafficByServiceNameAndDuration = (
    duration: string,
    serviceName: string
  ): Promise<OrderOrder> => {
    return this.ovh.request('GET', `/order/dedicated/server/${serviceName}/traffic/${duration}`);
  };

  /** Create order */
  createDedicatedServerTrafficByServiceNameAndDuration = (
    duration: string,
    serviceName: string,
    body: { traffic: DedicatedServerTrafficOrderEnum }
  ): Promise<OrderOrder> => {
    return this.ovh.request(
      'POST',
      `/order/dedicated/server/${serviceName}/traffic/${duration}`,
      body
    );
  };

  /** Get allowed durations for 'usbKey' option */
  getDedicatedServerUsbKeyByServiceName = (serviceName: string): Promise<string[]> => {
    return this.ovh.request('GET', `/order/dedicated/server/${serviceName}/usbKey`);
  };

  /** Get prices and contracts information */
  getDedicatedServerUsbKeyByServiceNameAndDuration = (
    duration: string,
    serviceName: string
  ): Promise<OrderOrder> => {
    return this.ovh.request('GET', `/order/dedicated/server/${serviceName}/usbKey/${duration}`);
  };

  /** Create order */
  createDedicatedServerUsbKeyByServiceNameAndDuration = (
    duration: string,
    serviceName: string,
    body: { capacity: DedicatedServerUsbKeyCapacityEnum }
  ): Promise<OrderOrder> => {
    return this.ovh.request(
      'POST',
      `/order/dedicated/server/${serviceName}/usbKey/${duration}`,
      body
    );
  };

  /** List available services */
  listDedicatedCloud = (): Promise<string[]> => {
    return this.ovh.request('GET', '/order/dedicatedCloud');
  };

  /** Get allowed options */
  getDedicatedCloudByServiceName = (serviceName: string): Promise<string[]> => {
    return this.ovh.request('GET', `/order/dedicatedCloud/${serviceName}`);
  };

  /** Get allowed durations for 'additionalBandwidth' option */
  getDedicatedCloudAdditionalBandwidthByServiceName = (serviceName: string): Promise<string[]> => {
    return this.ovh.request('GET', `/order/dedicatedCloud/${serviceName}/additionalBandwidth`);
  };

  /** Get prices and contracts information */
  getDedicatedCloudAdditionalBandwidthByServiceNameAndDuration = (
    duration: string,
    serviceName: string
  ): Promise<OrderOrder> => {
    return this.ovh.request(
      'GET',
      `/order/dedicatedCloud/${serviceName}/additionalBandwidth/${duration}`
    );
  };

  /** Create order */
  createDedicatedCloudAdditionalBandwidthByServiceNameAndDuration = (
    duration: string,
    serviceName: string,
    body: { bandwidth: DedicatedCloudAdditionalBandwidthEnum }
  ): Promise<OrderOrder> => {
    return this.ovh.request(
      'POST',
      `/order/dedicatedCloud/${serviceName}/additionalBandwidth/${duration}`,
      body
    );
  };

  /** Get allowed durations for 'filer' option */
  getDedicatedCloudFilerByServiceName = (serviceName: string): Promise<string[]> => {
    return this.ovh.request('GET', `/order/dedicatedCloud/${serviceName}/filer`);
  };

  /** Get prices and contracts information */
  getDedicatedCloudFilerByServiceNameAndDuration = (
    duration: string,
    serviceName: string
  ): Promise<OrderOrder> => {
    return this.ovh.request('GET', `/order/dedicatedCloud/${serviceName}/filer/${duration}`);
  };

  /** Create order */
  createDedicatedCloudFilerByServiceNameAndDuration = (
    duration: string,
    serviceName: string,
    body: { datacenterId?: number; name: string; quantity?: number }
  ): Promise<OrderOrder> => {
    return this.ovh.request('POST', `/order/dedicatedCloud/${serviceName}/filer/${duration}`, body);
  };

  /** Get allowed durations for 'host' option */
  getDedicatedCloudHostByServiceName = (serviceName: string): Promise<string[]> => {
    return this.ovh.request('GET', `/order/dedicatedCloud/${serviceName}/host`);
  };

  /** Get prices and contracts information */
  getDedicatedCloudHostByServiceNameAndDuration = (
    duration: string,
    serviceName: string
  ): Promise<OrderOrder> => {
    return this.ovh.request('GET', `/order/dedicatedCloud/${serviceName}/host/${duration}`);
  };

  /** Create order */
  createDedicatedCloudHostByServiceNameAndDuration = (
    duration: string,
    serviceName: string,
    body: { datacenterId: number; name: string; quantity?: number }
  ): Promise<OrderOrder> => {
    return this.ovh.request('POST', `/order/dedicatedCloud/${serviceName}/host/${duration}`, body);
  };

  /** Get allowed durations for 'ip' option */
  getDedicatedCloudIpByServiceName = (serviceName: string): Promise<string[]> => {
    return this.ovh.request('GET', `/order/dedicatedCloud/${serviceName}/ip`);
  };

  /** Get prices and contracts information */
  getDedicatedCloudIpByServiceNameAndDuration = (
    duration: string,
    serviceName: string
  ): Promise<OrderOrder> => {
    return this.ovh.request('GET', `/order/dedicatedCloud/${serviceName}/ip/${duration}`);
  };

  /** Create order */
  createDedicatedCloudIpByServiceNameAndDuration = (
    duration: string,
    serviceName: string,
    body: {
      country: DedicatedCloudIpCountriesEnum;
      description: string;
      estimatedClientsNumber: number;
      networkName: string;
      size: DedicatedCloudOrderableIpBlockRangeEnum;
      usage: string;
    }
  ): Promise<OrderOrder> => {
    return this.ovh.request('POST', `/order/dedicatedCloud/${serviceName}/ip/${duration}`, body);
  };

  /** Get prices and contracts information */
  getDedicatedCloudSplaByServiceName = (serviceName: string): Promise<OrderOrder> => {
    return this.ovh.request('GET', `/order/dedicatedCloud/${serviceName}/spla`);
  };

  /** Create order */
  createDedicatedCloudSplaByServiceName = (serviceName: string): Promise<OrderOrder> => {
    return this.ovh.request('POST', `/order/dedicatedCloud/${serviceName}/spla`);
  };

  /** Get allowed durations for 'upgradeRessource' option */
  getDedicatedCloudUpgradeRessourceByServiceName = (serviceName: string): Promise<string[]> => {
    return this.ovh.request('GET', `/order/dedicatedCloud/${serviceName}/upgradeRessource`);
  };

  /** Get prices and contracts information */
  getDedicatedCloudUpgradeRessourceByServiceNameAndDuration = (
    duration: string,
    serviceName: string
  ): Promise<OrderOrder> => {
    return this.ovh.request(
      'GET',
      `/order/dedicatedCloud/${serviceName}/upgradeRessource/${duration}`
    );
  };

  /** Create order */
  createDedicatedCloudUpgradeRessourceByServiceNameAndDuration = (
    duration: string,
    serviceName: string,
    body: {
      upgradeType: DedicatedCloudRessourcesUpgradeTypeEnum;
      upgradedRessourceId?: number;
      upgradedRessourceType: DedicatedCloudRessourcesUpgradeRessourceTypeEnum;
    }
  ): Promise<OrderOrder> => {
    return this.ovh.request(
      'POST',
      `/order/dedicatedCloud/${serviceName}/upgradeRessource/${duration}`,
      body
    );
  };

  /** Get prices and contracts information */
  getDedicatedCloudVdiByServiceName = (serviceName: string): Promise<OrderOrder> => {
    return this.ovh.request('GET', `/order/dedicatedCloud/${serviceName}/vdi`);
  };

  /** Create order */
  createDedicatedCloudVdiByServiceName = (
    serviceName: string,
    body: { datacenterId: number; firstPublicIpAddress: string; secondPublicIpAddress: string }
  ): Promise<OrderOrder> => {
    return this.ovh.request('POST', `/order/dedicatedCloud/${serviceName}/vdi`, body);
  };

  /** List available services */
  listDomainZone = (): Promise<string[]> => {
    return this.ovh.request('GET', '/order/domain/zone');
  };

  /** Get prices and contracts information */
  getDomainZoneNew = (): Promise<OrderOrder> => {
    return this.ovh.request('GET', '/order/domain/zone/new');
  };

  /** Create order */
  createDomainZoneNew = (body: { minimized?: boolean; zoneName: string }): Promise<OrderOrder> => {
    return this.ovh.request('POST', '/order/domain/zone/new', body);
  };

  /** Get allowed options */
  getDomainZoneByZoneName = (zoneName: string): Promise<string[]> => {
    return this.ovh.request('GET', `/order/domain/zone/${zoneName}`);
  };

  /** Get allowed durations for 'dnsAnycast' option */
  getDomainZoneDnsAnycastByZoneName = (zoneName: string): Promise<string[]> => {
    return this.ovh.request('GET', `/order/domain/zone/${zoneName}/dnsAnycast`);
  };

  /** Get prices and contracts information */
  getDomainZoneDnsAnycastByZoneNameAndDuration = (
    duration: string,
    zoneName: string
  ): Promise<OrderOrder> => {
    return this.ovh.request('GET', `/order/domain/zone/${zoneName}/dnsAnycast/${duration}`);
  };

  /** Create order */
  createDomainZoneDnsAnycastByZoneNameAndDuration = (
    duration: string,
    zoneName: string
  ): Promise<OrderOrder> => {
    return this.ovh.request('POST', `/order/domain/zone/${zoneName}/dnsAnycast/${duration}`);
  };

  /** List available services */
  listEmailDomain = (): Promise<string[]> => {
    return this.ovh.request('GET', '/order/email/domain');
  };

  /** Get allowed durations for 'new' option */
  getEmailDomainNew = (): Promise<string[]> => {
    return this.ovh.request('GET', '/order/email/domain/new');
  };

  /** Get prices and contracts information */
  getEmailDomainNewByDuration = (duration: string): Promise<OrderOrder> => {
    return this.ovh.request('GET', `/order/email/domain/new/${duration}`);
  };

  /** Create order */
  createEmailDomainNewByDuration = (
    duration: string,
    body: { domain: string; offer: EmailDomainOfferEnum }
  ): Promise<OrderOrder> => {
    return this.ovh.request('POST', `/order/email/domain/new/${duration}`, body);
  };

  /** Get allowed options */
  getEmailDomainByDomain = (domain: string): Promise<string[]> => {
    return this.ovh.request('GET', `/order/email/domain/${domain}`);
  };

  /** Get allowed durations for 'upgrade' option */
  getEmailDomainUpgradeByDomain = (domain: string): Promise<string[]> => {
    return this.ovh.request('GET', `/order/email/domain/${domain}/upgrade`);
  };

  /** Get prices and contracts information */
  getEmailDomainUpgradeByDomainAndDuration = (
    domain: string,
    duration: string
  ): Promise<OrderOrder> => {
    return this.ovh.request('GET', `/order/email/domain/${domain}/upgrade/${duration}`);
  };

  /** Create order */
  createEmailDomainUpgradeByDomainAndDuration = (
    domain: string,
    duration: string,
    body: { offer: EmailDomainOfferEnum }
  ): Promise<OrderOrder> => {
    return this.ovh.request('POST', `/order/email/domain/${domain}/upgrade/${duration}`, body);
  };

  /** List available services */
  listEmailExchange = (): Promise<string[]> => {
    return this.ovh.request('GET', '/order/email/exchange');
  };

  /** List available services */
  listEmailExchangeServiceByOrganizationName = (organizationName: string): Promise<string[]> => {
    return this.ovh.request('GET', `/order/email/exchange/${organizationName}/service`);
  };

  /** Get allowed options */
  getEmailExchangeServiceByOrganizationNameAndExchangeService = (
    exchangeService: string,
    organizationName: string
  ): Promise<string[]> => {
    return this.ovh.request(
      'GET',
      `/order/email/exchange/${organizationName}/service/${exchangeService}`
    );
  };

  /** Get allowed durations for 'account' option */
  getEmailExchangeServiceAccountByOrganizationNameAndExchangeService = (
    exchangeService: string,
    organizationName: string
  ): Promise<string[]> => {
    return this.ovh.request(
      'GET',
      `/order/email/exchange/${organizationName}/service/${exchangeService}/account`
    );
  };

  /** Get prices and contracts information */
  getEmailExchangeServiceAccountByOrganizationNameAndExchangeServiceAndDuration = (
    duration: string,
    exchangeService: string,
    organizationName: string
  ): Promise<OrderOrder> => {
    return this.ovh.request(
      'GET',
      `/order/email/exchange/${organizationName}/service/${exchangeService}/account/${duration}`
    );
  };

  /** Create order */
  createEmailExchangeServiceAccountByOrganizationNameAndExchangeServiceAndDuration = (
    duration: string,
    exchangeService: string,
    organizationName: string,
    body: {
      licence: EmailExchangeOvhLicenceEnum;
      number: number;
      storageQuota?: EmailExchangeAccountQuotaEnum;
    }
  ): Promise<OrderOrder> => {
    return this.ovh.request(
      'POST',
      `/order/email/exchange/${organizationName}/service/${exchangeService}/account/${duration}`,
      body
    );
  };

  /** Get allowed durations for 'accountUpgrade' option */
  getEmailExchangeServiceAccountUpgradeByOrganizationNameAndExchangeService = (
    exchangeService: string,
    organizationName: string
  ): Promise<string[]> => {
    return this.ovh.request(
      'GET',
      `/order/email/exchange/${organizationName}/service/${exchangeService}/accountUpgrade`
    );
  };

  /** Get prices and contracts information */
  getEmailExchangeServiceAccountUpgradeByOrganizationNameAndExchangeServiceAndDuration = (
    duration: string,
    exchangeService: string,
    organizationName: string
  ): Promise<OrderOrder> => {
    return this.ovh.request(
      'GET',
      `/order/email/exchange/${organizationName}/service/${exchangeService}/accountUpgrade/${duration}`
    );
  };

  /** Create order */
  createEmailExchangeServiceAccountUpgradeByOrganizationNameAndExchangeServiceAndDuration = (
    duration: string,
    exchangeService: string,
    organizationName: string,
    body: { newQuota: EmailExchangeAccountQuotaEnum; primaryEmailAddress: string }
  ): Promise<OrderOrder> => {
    return this.ovh.request(
      'POST',
      `/order/email/exchange/${organizationName}/service/${exchangeService}/accountUpgrade/${duration}`,
      body
    );
  };

  /** Get prices and contracts information */
  getEmailExchangeServiceDiskSpaceByOrganizationNameAndExchangeService = (
    exchangeService: string,
    organizationName: string
  ): Promise<OrderOrder> => {
    return this.ovh.request(
      'GET',
      `/order/email/exchange/${organizationName}/service/${exchangeService}/diskSpace`
    );
  };

  /** Create order */
  createEmailExchangeServiceDiskSpaceByOrganizationNameAndExchangeService = (
    exchangeService: string,
    organizationName: string
  ): Promise<OrderOrder> => {
    return this.ovh.request(
      'POST',
      `/order/email/exchange/${organizationName}/service/${exchangeService}/diskSpace`
    );
  };

  /** Get allowed durations for 'outlook' option */
  getEmailExchangeServiceOutlookByOrganizationNameAndExchangeService = (
    exchangeService: string,
    organizationName: string
  ): Promise<string[]> => {
    return this.ovh.request(
      'GET',
      `/order/email/exchange/${organizationName}/service/${exchangeService}/outlook`
    );
  };

  /** Get prices and contracts information */
  getEmailExchangeServiceOutlookByOrganizationNameAndExchangeServiceAndDuration = (
    duration: string,
    exchangeService: string,
    organizationName: string
  ): Promise<OrderOrder> => {
    return this.ovh.request(
      'GET',
      `/order/email/exchange/${organizationName}/service/${exchangeService}/outlook/${duration}`
    );
  };

  /** Create order */
  createEmailExchangeServiceOutlookByOrganizationNameAndExchangeServiceAndDuration = (
    duration: string,
    exchangeService: string,
    organizationName: string,
    body: { licence: EmailExchangeOutlookVersionEnum; primaryEmailAddress: string }
  ): Promise<OrderOrder> => {
    return this.ovh.request(
      'POST',
      `/order/email/exchange/${organizationName}/service/${exchangeService}/outlook/${duration}`,
      body
    );
  };

  /** Get prices and contracts information */
  getEmailExchangeServiceUpgradeByOrganizationNameAndExchangeService = (
    exchangeService: string,
    organizationName: string
  ): Promise<OrderOrder> => {
    return this.ovh.request(
      'GET',
      `/order/email/exchange/${organizationName}/service/${exchangeService}/upgrade`
    );
  };

  /** Create order */
  createEmailExchangeServiceUpgradeByOrganizationNameAndExchangeService = (
    exchangeService: string,
    organizationName: string
  ): Promise<OrderOrder> => {
    return this.ovh.request(
      'POST',
      `/order/email/exchange/${organizationName}/service/${exchangeService}/upgrade`
    );
  };

  /** List available services */
  listEmailPro = (): Promise<string[]> => {
    return this.ovh.request('GET', '/order/email/pro');
  };

  /** Get allowed options */
  getEmailProByService = (service: string): Promise<string[]> => {
    return this.ovh.request('GET', `/order/email/pro/${service}`);
  };

  /** Get allowed durations for 'account' option */
  getEmailProAccountByService = (service: string): Promise<string[]> => {
    return this.ovh.request('GET', `/order/email/pro/${service}/account`);
  };

  /** Get prices and contracts information */
  getEmailProAccountByServiceAndDuration = (
    duration: string,
    service: string
  ): Promise<OrderOrder> => {
    return this.ovh.request('GET', `/order/email/pro/${service}/account/${duration}`);
  };

  /** Create order */
  createEmailProAccountByServiceAndDuration = (
    duration: string,
    service: string,
    body: { number: number }
  ): Promise<OrderOrder> => {
    return this.ovh.request('POST', `/order/email/pro/${service}/account/${duration}`, body);
  };

  /** List available services */
  listFreefax = (): Promise<string[]> => {
    return this.ovh.request('GET', '/order/freefax');
  };

  /** Get prices and contracts information */
  getFreefaxNew = (): Promise<OrderOrder> => {
    return this.ovh.request('GET', '/order/freefax/new');
  };

  /** Create order */
  createFreefaxNew = (body: { quantity: FreefaxQuantityEnum }): Promise<OrderOrder> => {
    return this.ovh.request('POST', '/order/freefax/new', body);
  };

  /** Get allowed options */
  getFreefaxByServiceName = (serviceName: string): Promise<string[]> => {
    return this.ovh.request('GET', `/order/freefax/${serviceName}`);
  };

  /** Get prices and contracts information */
  getFreefaxConvertToVoicefaxByServiceName = (serviceName: string): Promise<OrderOrder> => {
    return this.ovh.request('GET', `/order/freefax/${serviceName}/convertToVoicefax`);
  };

  /** Create order */
  createFreefaxConvertToVoicefaxByServiceName = (
    serviceName: string,
    body: { billingAccount: string }
  ): Promise<OrderOrder> => {
    return this.ovh.request('POST', `/order/freefax/${serviceName}/convertToVoicefax`, body);
  };

  /** List available services */
  listHostingPrivateDatabase = (): Promise<string[]> => {
    return this.ovh.request('GET', '/order/hosting/privateDatabase');
  };

  /** Get allowed durations for 'new' option */
  getHostingPrivateDatabaseNew = (): Promise<string[]> => {
    return this.ovh.request('GET', '/order/hosting/privateDatabase/new');
  };

  /** Get prices and contracts information */
  getHostingPrivateDatabaseNewByDuration = (duration: string): Promise<OrderOrder> => {
    return this.ovh.request('GET', `/order/hosting/privateDatabase/new/${duration}`);
  };

  /** Create order */
  createHostingPrivateDatabaseNewByDuration = (
    duration: string,
    body: {
      datacenter?: HostingPrivateDatabaseDatacenterEnum;
      offer?: HostingPrivateDatabaseOfferEnum;
      ram: HostingPrivateDatabaseAvailableRamSizeEnum;
      version: HostingPrivateDatabaseOrderableVersionEnum;
    }
  ): Promise<OrderOrder> => {
    return this.ovh.request('POST', `/order/hosting/privateDatabase/new/${duration}`, body);
  };

  /** Get allowed options */
  getHostingPrivateDatabaseByServiceName = (serviceName: string): Promise<string[]> => {
    return this.ovh.request('GET', `/order/hosting/privateDatabase/${serviceName}`);
  };

  /** Get allowed durations for 'ram' option */
  getHostingPrivateDatabaseRamByServiceName = (serviceName: string): Promise<string[]> => {
    return this.ovh.request('GET', `/order/hosting/privateDatabase/${serviceName}/ram`);
  };

  /** Get prices and contracts information */
  getHostingPrivateDatabaseRamByServiceNameAndDuration = (
    duration: string,
    serviceName: string
  ): Promise<OrderOrder> => {
    return this.ovh.request('GET', `/order/hosting/privateDatabase/${serviceName}/ram/${duration}`);
  };

  /** Create order */
  createHostingPrivateDatabaseRamByServiceNameAndDuration = (
    duration: string,
    serviceName: string,
    body: { ram: HostingPrivateDatabaseAvailableRamSizeEnum }
  ): Promise<OrderOrder> => {
    return this.ovh.request(
      'POST',
      `/order/hosting/privateDatabase/${serviceName}/ram/${duration}`,
      body
    );
  };

  /** List available services */
  listHostingWeb = (): Promise<string[]> => {
    return this.ovh.request('GET', '/order/hosting/web');
  };

  /** Get allowed durations for 'new' option */
  getHostingWebNew = (): Promise<string[]> => {
    return this.ovh.request('GET', '/order/hosting/web/new');
  };

  /** Get prices and contracts information */
  getHostingWebNewByDuration = (duration: string): Promise<OrderOrder> => {
    return this.ovh.request('GET', `/order/hosting/web/new/${duration}`);
  };

  /** Create order */
  createHostingWebNewByDuration = (
    duration: string,
    body: {
      dnsZone?: HostingWebDnsZoneEnum;
      domain: string;
      module?: HostingWebModuleOrderableNameEnum;
      offer: HostingWebOfferEnum;
      waiveRetractationPeriod?: boolean;
    }
  ): Promise<OrderOrder> => {
    return this.ovh.request('POST', `/order/hosting/web/new/${duration}`, body);
  };

  /** Get allowed options */
  getHostingWebByServiceName = (serviceName: string): Promise<string[]> => {
    return this.ovh.request('GET', `/order/hosting/web/${serviceName}`);
  };

  /** Get allowed durations for 'bandwidth' option */
  getHostingWebBandwidthByServiceName = (serviceName: string): Promise<string[]> => {
    return this.ovh.request('GET', `/order/hosting/web/${serviceName}/bandwidth`);
  };

  /** Get prices and contracts information */
  getHostingWebBandwidthByServiceNameAndDuration = (
    duration: string,
    serviceName: string
  ): Promise<OrderOrder> => {
    return this.ovh.request('GET', `/order/hosting/web/${serviceName}/bandwidth/${duration}`);
  };

  /** Create order */
  createHostingWebBandwidthByServiceNameAndDuration = (
    duration: string,
    serviceName: string,
    body: { traffic: HostingWebBandwidthOfferEnum }
  ): Promise<OrderOrder> => {
    return this.ovh.request(
      'POST',
      `/order/hosting/web/${serviceName}/bandwidth/${duration}`,
      body
    );
  };

  /** Get allowed durations for 'cdn' option */
  getHostingWebCdnByServiceName = (serviceName: string): Promise<string[]> => {
    return this.ovh.request('GET', `/order/hosting/web/${serviceName}/cdn`);
  };

  /** Get prices and contracts information */
  getHostingWebCdnByServiceNameAndDuration = (
    duration: string,
    serviceName: string
  ): Promise<OrderOrder> => {
    return this.ovh.request('GET', `/order/hosting/web/${serviceName}/cdn/${duration}`);
  };

  /** Create order */
  createHostingWebCdnByServiceNameAndDuration = (
    duration: string,
    serviceName: string,
    body: { offer: HostingWebCdnOfferEnum }
  ): Promise<OrderOrder> => {
    return this.ovh.request('POST', `/order/hosting/web/${serviceName}/cdn/${duration}`, body);
  };

  /** Get allowed durations for 'changeMainDomain' option */
  getHostingWebChangeMainDomainByServiceName = (serviceName: string): Promise<string[]> => {
    return this.ovh.request('GET', `/order/hosting/web/${serviceName}/changeMainDomain`);
  };

  /** Get prices and contracts information */
  getHostingWebChangeMainDomainByServiceNameAndDuration = (
    duration: string,
    serviceName: string
  ): Promise<OrderOrder> => {
    return this.ovh.request(
      'GET',
      `/order/hosting/web/${serviceName}/changeMainDomain/${duration}`
    );
  };

  /** Create order */
  createHostingWebChangeMainDomainByServiceNameAndDuration = (
    duration: string,
    serviceName: string,
    body: { domain: string; mxplan: HostingWebOrderMxPlanEnum }
  ): Promise<OrderOrder> => {
    return this.ovh.request(
      'POST',
      `/order/hosting/web/${serviceName}/changeMainDomain/${duration}`,
      body
    );
  };

  /** Get allowed durations for 'extraSqlPerso' option */
  getHostingWebExtraSqlPersoByServiceName = (serviceName: string): Promise<string[]> => {
    return this.ovh.request('GET', `/order/hosting/web/${serviceName}/extraSqlPerso`);
  };

  /** Get prices and contracts information */
  getHostingWebExtraSqlPersoByServiceNameAndDuration = (
    duration: string,
    serviceName: string
  ): Promise<OrderOrder> => {
    return this.ovh.request('GET', `/order/hosting/web/${serviceName}/extraSqlPerso/${duration}`);
  };

  /** Create order */
  createHostingWebExtraSqlPersoByServiceNameAndDuration = (
    duration: string,
    serviceName: string,
    body: { offer: HostingWebDatabaseSqlPersoOfferEnum }
  ): Promise<OrderOrder> => {
    return this.ovh.request(
      'POST',
      `/order/hosting/web/${serviceName}/extraSqlPerso/${duration}`,
      body
    );
  };

  /** Get allowed durations for 'ssl' option */
  getHostingWebSslByServiceName = (serviceName: string): Promise<string[]> => {
    return this.ovh.request('GET', `/order/hosting/web/${serviceName}/ssl`);
  };

  /** Get prices and contracts information */
  getHostingWebSslByServiceNameAndDuration = (
    duration: string,
    serviceName: string
  ): Promise<OrderOrder> => {
    return this.ovh.request('GET', `/order/hosting/web/${serviceName}/ssl/${duration}`);
  };

  /** Create order */
  createHostingWebSslByServiceNameAndDuration = (
    duration: string,
    serviceName: string
  ): Promise<OrderOrder> => {
    return this.ovh.request('POST', `/order/hosting/web/${serviceName}/ssl/${duration}`);
  };

  /** Get allowed durations for 'upgrade' option */
  getHostingWebUpgradeByServiceName = (serviceName: string): Promise<string[]> => {
    return this.ovh.request('GET', `/order/hosting/web/${serviceName}/upgrade`);
  };

  /** Get prices and contracts information */
  getHostingWebUpgradeByServiceNameAndDuration = (
    duration: string,
    serviceName: string
  ): Promise<OrderOrder> => {
    return this.ovh.request('GET', `/order/hosting/web/${serviceName}/upgrade/${duration}`);
  };

  /** Create order */
  createHostingWebUpgradeByServiceNameAndDuration = (
    duration: string,
    serviceName: string,
    body: { offer: HostingWebOfferEnum; startTime?: Date; waiveRetractationPeriod?: boolean }
  ): Promise<OrderOrder> => {
    return this.ovh.request('POST', `/order/hosting/web/${serviceName}/upgrade/${duration}`, body);
  };

  /** Get allowed durations for 'new' option */
  getLicenseCloudLinuxNew = (): Promise<string[]> => {
    return this.ovh.request('GET', '/order/license/cloudLinux/new');
  };

  /** Get prices and contracts information */
  getLicenseCloudLinuxNewByDuration = (duration: string): Promise<OrderOrder> => {
    return this.ovh.request('GET', `/order/license/cloudLinux/new/${duration}`);
  };

  /** Create order */
  createLicenseCloudLinuxNewByDuration = (
    duration: string,
    body: { ip: string; version: LicenseCloudLinuxVersionEnum }
  ): Promise<OrderOrder> => {
    return this.ovh.request('POST', `/order/license/cloudLinux/new/${duration}`, body);
  };

  /** List available services */
  listLicenseCpanel = (): Promise<string[]> => {
    return this.ovh.request('GET', '/order/license/cpanel');
  };

  /** Get allowed durations for 'new' option */
  getLicenseCpanelNew = (): Promise<string[]> => {
    return this.ovh.request('GET', '/order/license/cpanel/new');
  };

  /** Get prices and contracts information */
  getLicenseCpanelNewByDuration = (duration: string): Promise<OrderOrder> => {
    return this.ovh.request('GET', `/order/license/cpanel/new/${duration}`);
  };

  /** Create order */
  createLicenseCpanelNewByDuration = (
    duration: string,
    body: {
      ip: string;
      serviceType?: LicenseLicenseTypeEnum;
      version: LicenseOrderableCpanelVersionEnum;
    }
  ): Promise<OrderOrder> => {
    return this.ovh.request('POST', `/order/license/cpanel/new/${duration}`, body);
  };

  /** Get allowed options */
  getLicenseCpanelByServiceName = (serviceName: string): Promise<string[]> => {
    return this.ovh.request('GET', `/order/license/cpanel/${serviceName}`);
  };

  /** Get allowed durations for 'upgrade' option */
  getLicenseCpanelUpgradeByServiceName = (serviceName: string): Promise<string[]> => {
    return this.ovh.request('GET', `/order/license/cpanel/${serviceName}/upgrade`);
  };

  /** Get prices and contracts information */
  getLicenseCpanelUpgradeByServiceNameAndDuration = (
    duration: string,
    serviceName: string
  ): Promise<OrderOrder> => {
    return this.ovh.request('GET', `/order/license/cpanel/${serviceName}/upgrade/${duration}`);
  };

  /** Create order */
  createLicenseCpanelUpgradeByServiceNameAndDuration = (
    duration: string,
    serviceName: string,
    body: { version: LicenseOrderableCpanelVersionEnum }
  ): Promise<OrderOrder> => {
    return this.ovh.request(
      'POST',
      `/order/license/cpanel/${serviceName}/upgrade/${duration}`,
      body
    );
  };

  /** Get allowed durations for 'new' option */
  getLicenseDirectadminNew = (): Promise<string[]> => {
    return this.ovh.request('GET', '/order/license/directadmin/new');
  };

  /** Get prices and contracts information */
  getLicenseDirectadminNewByDuration = (duration: string): Promise<OrderOrder> => {
    return this.ovh.request('GET', `/order/license/directadmin/new/${duration}`);
  };

  /** Create order */
  createLicenseDirectadminNewByDuration = (
    duration: string,
    body: {
      ip: string;
      serviceType?: LicenseLicenseTypeEnum;
      version: LicenseOrderableDirectAdminVersionEnum;
    }
  ): Promise<OrderOrder> => {
    return this.ovh.request('POST', `/order/license/directadmin/new/${duration}`, body);
  };

  /** Get allowed durations for 'new' option */
  getLicenseOfficeNew = (): Promise<string[]> => {
    return this.ovh.request('GET', '/order/license/office/new');
  };

  /** Get prices and contracts information */
  getLicenseOfficeNewByDuration = (duration: string): Promise<OrderOrder> => {
    return this.ovh.request('GET', `/order/license/office/new/${duration}`);
  };

  /** Create order */
  createLicenseOfficeNewByDuration = (
    duration: string,
    body: { giftCode?: string; officeBusinessQuantity?: number; officeProPlusQuantity?: number }
  ): Promise<OrderOrder> => {
    return this.ovh.request('POST', `/order/license/office/new/${duration}`, body);
  };

  /** List available services */
  listLicensePlesk = (): Promise<string[]> => {
    return this.ovh.request('GET', '/order/license/plesk');
  };

  /** Get allowed durations for 'new' option */
  getLicensePleskNew = (): Promise<string[]> => {
    return this.ovh.request('GET', '/order/license/plesk/new');
  };

  /** Get prices and contracts information */
  getLicensePleskNewByDuration = (duration: string): Promise<OrderOrder> => {
    return this.ovh.request('GET', `/order/license/plesk/new/${duration}`);
  };

  /** Create order */
  createLicensePleskNewByDuration = (
    duration: string,
    body: {
      antivirus?: LicenseOrderableAntivirusEnum;
      applicationSet?: LicensePleskApplicationSetEnum;
      domainNumber?: LicenseOrderablePleskDomainNumberEnum;
      ip: string;
      languagePackNumber?: LicenseOrderablePleskLanguagePackEnum;
      powerpack?: boolean;
      resellerManagement?: boolean;
      serviceType?: LicenseLicenseTypeEnum;
      version: LicensePleskVersionEnum;
      wordpressToolkit?: boolean;
    }
  ): Promise<OrderOrder> => {
    return this.ovh.request('POST', `/order/license/plesk/new/${duration}`, body);
  };

  /** Get allowed options */
  getLicensePleskByServiceName = (serviceName: string): Promise<string[]> => {
    return this.ovh.request('GET', `/order/license/plesk/${serviceName}`);
  };

  /** Get allowed durations for 'upgrade' option */
  getLicensePleskUpgradeByServiceName = (serviceName: string): Promise<string[]> => {
    return this.ovh.request('GET', `/order/license/plesk/${serviceName}/upgrade`);
  };

  /** Get prices and contracts information */
  getLicensePleskUpgradeByServiceNameAndDuration = (
    duration: string,
    serviceName: string
  ): Promise<OrderOrder> => {
    return this.ovh.request('GET', `/order/license/plesk/${serviceName}/upgrade/${duration}`);
  };

  /** Create order */
  createLicensePleskUpgradeByServiceNameAndDuration = (
    duration: string,
    serviceName: string,
    body: {
      antispam?: LicenseOrderableAntispamEnum;
      antivirus?: LicenseOrderableAntivirusEnum;
      applicationSet?: LicensePleskApplicationSetEnum;
      domainNumber?: LicenseOrderablePleskDomainNumberEnum;
      languagePackNumber?: LicenseOrderablePleskLanguagePackEnum;
      powerpack?: boolean;
      resellerManagement?: boolean;
      version?: LicensePleskVersionEnum;
      wordpressToolkit?: boolean;
    }
  ): Promise<OrderOrder> => {
    return this.ovh.request(
      'POST',
      `/order/license/plesk/${serviceName}/upgrade/${duration}`,
      body
    );
  };

  /** List available services */
  listLicenseSqlserver = (): Promise<string[]> => {
    return this.ovh.request('GET', '/order/license/sqlserver');
  };

  /** Get allowed durations for 'new' option */
  getLicenseSqlserverNew = (): Promise<string[]> => {
    return this.ovh.request('GET', '/order/license/sqlserver/new');
  };

  /** Get prices and contracts information */
  getLicenseSqlserverNewByDuration = (duration: string): Promise<OrderOrder> => {
    return this.ovh.request('GET', `/order/license/sqlserver/new/${duration}`);
  };

  /** Create order */
  createLicenseSqlserverNewByDuration = (
    duration: string,
    body: { ip: string; version: LicenseSqlServerVersionEnum }
  ): Promise<OrderOrder> => {
    return this.ovh.request('POST', `/order/license/sqlserver/new/${duration}`, body);
  };

  /** Get allowed options */
  getLicenseSqlserverByServiceName = (serviceName: string): Promise<string[]> => {
    return this.ovh.request('GET', `/order/license/sqlserver/${serviceName}`);
  };

  /** Get allowed durations for 'upgrade' option */
  getLicenseSqlserverUpgradeByServiceName = (serviceName: string): Promise<string[]> => {
    return this.ovh.request('GET', `/order/license/sqlserver/${serviceName}/upgrade`);
  };

  /** Get prices and contracts information */
  getLicenseSqlserverUpgradeByServiceNameAndDuration = (
    duration: string,
    serviceName: string
  ): Promise<OrderOrder> => {
    return this.ovh.request('GET', `/order/license/sqlserver/${serviceName}/upgrade/${duration}`);
  };

  /** Create order */
  createLicenseSqlserverUpgradeByServiceNameAndDuration = (
    duration: string,
    serviceName: string,
    body: { version: LicenseSqlServerVersionEnum }
  ): Promise<OrderOrder> => {
    return this.ovh.request(
      'POST',
      `/order/license/sqlserver/${serviceName}/upgrade/${duration}`,
      body
    );
  };

  /** List available services */
  listLicenseVirtuozzo = (): Promise<string[]> => {
    return this.ovh.request('GET', '/order/license/virtuozzo');
  };

  /** Get allowed durations for 'new' option */
  getLicenseVirtuozzoNew = (): Promise<string[]> => {
    return this.ovh.request('GET', '/order/license/virtuozzo/new');
  };

  /** Get prices and contracts information */
  getLicenseVirtuozzoNewByDuration = (duration: string): Promise<OrderOrder> => {
    return this.ovh.request('GET', `/order/license/virtuozzo/new/${duration}`);
  };

  /** Create order */
  createLicenseVirtuozzoNewByDuration = (
    duration: string,
    body: {
      containerNumber: LicenseOrderableVirtuozzoContainerNumberEnum;
      ip: string;
      serviceType?: LicenseLicenseTypeEnum;
      version: LicenseOrderableVirtuozzoVersionEnum;
    }
  ): Promise<OrderOrder> => {
    return this.ovh.request('POST', `/order/license/virtuozzo/new/${duration}`, body);
  };

  /** Get allowed options */
  getLicenseVirtuozzoByServiceName = (serviceName: string): Promise<string[]> => {
    return this.ovh.request('GET', `/order/license/virtuozzo/${serviceName}`);
  };

  /** Get allowed durations for 'upgrade' option */
  getLicenseVirtuozzoUpgradeByServiceName = (serviceName: string): Promise<string[]> => {
    return this.ovh.request('GET', `/order/license/virtuozzo/${serviceName}/upgrade`);
  };

  /** Get prices and contracts information */
  getLicenseVirtuozzoUpgradeByServiceNameAndDuration = (
    duration: string,
    serviceName: string
  ): Promise<OrderOrder> => {
    return this.ovh.request('GET', `/order/license/virtuozzo/${serviceName}/upgrade/${duration}`);
  };

  /** Create order */
  createLicenseVirtuozzoUpgradeByServiceNameAndDuration = (
    duration: string,
    serviceName: string,
    body: { containerNumber: LicenseOrderableVirtuozzoContainerNumberEnum }
  ): Promise<OrderOrder> => {
    return this.ovh.request(
      'POST',
      `/order/license/virtuozzo/${serviceName}/upgrade/${duration}`,
      body
    );
  };

  /** List available services */
  listLicenseWindows = (): Promise<string[]> => {
    return this.ovh.request('GET', '/order/license/windows');
  };

  /** Get allowed durations for 'new' option */
  getLicenseWindowsNew = (): Promise<string[]> => {
    return this.ovh.request('GET', '/order/license/windows/new');
  };

  /** Get prices and contracts information */
  getLicenseWindowsNewByDuration = (duration: string): Promise<OrderOrder> => {
    return this.ovh.request('GET', `/order/license/windows/new/${duration}`);
  };

  /** Create order */
  createLicenseWindowsNewByDuration = (
    duration: string,
    body: {
      ip: string;
      serviceType?: LicenseLicenseTypeEnum;
      sqlVersion?: LicenseWindowsSqlVersionEnum;
      version: LicenseWindowsOsVersionEnum;
    }
  ): Promise<OrderOrder> => {
    return this.ovh.request('POST', `/order/license/windows/new/${duration}`, body);
  };

  /** Get allowed options */
  getLicenseWindowsByServiceName = (serviceName: string): Promise<string[]> => {
    return this.ovh.request('GET', `/order/license/windows/${serviceName}`);
  };

  /** Get allowed durations for 'upgrade' option */
  getLicenseWindowsUpgradeByServiceName = (serviceName: string): Promise<string[]> => {
    return this.ovh.request('GET', `/order/license/windows/${serviceName}/upgrade`);
  };

  /** Get prices and contracts information */
  getLicenseWindowsUpgradeByServiceNameAndDuration = (
    duration: string,
    serviceName: string
  ): Promise<OrderOrder> => {
    return this.ovh.request('GET', `/order/license/windows/${serviceName}/upgrade/${duration}`);
  };

  /** Create order */
  createLicenseWindowsUpgradeByServiceNameAndDuration = (
    duration: string,
    serviceName: string,
    body: { sqlVersion?: LicenseWindowsSqlVersionEnum; version?: LicenseWindowsOsVersionEnum }
  ): Promise<OrderOrder> => {
    return this.ovh.request(
      'POST',
      `/order/license/windows/${serviceName}/upgrade/${duration}`,
      body
    );
  };

  /** List available services */
  listLicenseWorklight = (): Promise<string[]> => {
    return this.ovh.request('GET', '/order/license/worklight');
  };

  /** Get allowed durations for 'new' option */
  getLicenseWorklightNew = (): Promise<string[]> => {
    return this.ovh.request('GET', '/order/license/worklight/new');
  };

  /** Get prices and contracts information */
  getLicenseWorklightNewByDuration = (duration: string): Promise<OrderOrder> => {
    return this.ovh.request('GET', `/order/license/worklight/new/${duration}`);
  };

  /** Create order */
  createLicenseWorklightNewByDuration = (
    duration: string,
    body: { ip: string; lessThan1000Users: boolean; version: LicenseWorkLightVersionEnum }
  ): Promise<OrderOrder> => {
    return this.ovh.request('POST', `/order/license/worklight/new/${duration}`, body);
  };

  /** Get allowed options */
  getLicenseWorklightByServiceName = (serviceName: string): Promise<string[]> => {
    return this.ovh.request('GET', `/order/license/worklight/${serviceName}`);
  };

  /** Get allowed durations for 'upgrade' option */
  getLicenseWorklightUpgradeByServiceName = (serviceName: string): Promise<string[]> => {
    return this.ovh.request('GET', `/order/license/worklight/${serviceName}/upgrade`);
  };

  /** Get prices and contracts information */
  getLicenseWorklightUpgradeByServiceNameAndDuration = (
    duration: string,
    serviceName: string
  ): Promise<OrderOrder> => {
    return this.ovh.request('GET', `/order/license/worklight/${serviceName}/upgrade/${duration}`);
  };

  /** Create order */
  createLicenseWorklightUpgradeByServiceNameAndDuration = (
    duration: string,
    serviceName: string,
    body: { version: LicenseWorkLightVersionEnum }
  ): Promise<OrderOrder> => {
    return this.ovh.request(
      'POST',
      `/order/license/worklight/${serviceName}/upgrade/${duration}`,
      body
    );
  };

  /** List available services */
  listOverTheBox = (): Promise<string[]> => {
    return this.ovh.request('GET', '/order/overTheBox');
  };

  /** Get allowed durations for 'new' option */
  getOverTheBoxNew = (): Promise<string[]> => {
    return this.ovh.request('GET', '/order/overTheBox/new');
  };

  /** Get prices and contracts information */
  getOverTheBoxNewByDuration = (duration: string): Promise<OrderOrder> => {
    return this.ovh.request('GET', `/order/overTheBox/new/${duration}`);
  };

  /** Create order */
  createOverTheBoxNewByDuration = (
    duration: string,
    body: { deviceId?: string; offer: string; voucher?: string }
  ): Promise<OrderOrder> => {
    return this.ovh.request('POST', `/order/overTheBox/new/${duration}`, body);
  };

  /** Get allowed options */
  getOverTheBoxByServiceName = (serviceName: string): Promise<string[]> => {
    return this.ovh.request('GET', `/order/overTheBox/${serviceName}`);
  };

  /** Get prices and contracts information */
  getOverTheBoxMigrateByServiceName = (serviceName: string): Promise<OrderOrder> => {
    return this.ovh.request('GET', `/order/overTheBox/${serviceName}/migrate`);
  };

  /** Create order */
  createOverTheBoxMigrateByServiceName = (
    serviceName: string,
    body: {
      hardware: boolean;
      offer: string;
      shippingContactID?: string;
      shippingMethod?: OverTheBoxShippingMethodEnum;
      shippingRelayID?: number;
    }
  ): Promise<OrderOrder> => {
    return this.ovh.request('POST', `/order/overTheBox/${serviceName}/migrate`, body);
  };

  /** Get allowed durations for 'new' option */
  getSaasCsp2New = (): Promise<string[]> => {
    return this.ovh.request('GET', '/order/saas/csp2/new');
  };

  /** Get prices and contracts information */
  getSaasCsp2NewByDuration = (duration: string): Promise<OrderOrder> => {
    return this.ovh.request('GET', `/order/saas/csp2/new/${duration}`);
  };

  /** Create order */
  createSaasCsp2NewByDuration = (
    duration: string,
    body: { giftCode?: string; officeBusinessQuantity?: number; officeProPlusQuantity?: number }
  ): Promise<OrderOrder> => {
    return this.ovh.request('POST', `/order/saas/csp2/new/${duration}`, body);
  };

  /** List available services */
  listSms = (): Promise<string[]> => {
    return this.ovh.request('GET', '/order/sms');
  };

  /** Get prices and contracts information */
  getSmsNew = (): Promise<OrderOrder> => {
    return this.ovh.request('GET', '/order/sms/new');
  };

  /** Create order */
  createSmsNew = (body: {
    channel?: SmsChannelEnum;
    quantity: number;
    smpp?: boolean;
  }): Promise<OrderOrder> => {
    return this.ovh.request('POST', '/order/sms/new', body);
  };

  /** Get allowed options */
  getSmsByServiceName = (serviceName: string): Promise<string[]> => {
    return this.ovh.request('GET', `/order/sms/${serviceName}`);
  };

  /** Get prices and contracts information */
  getSmsCreditsByServiceName = (serviceName: string): Promise<OrderOrder> => {
    return this.ovh.request('GET', `/order/sms/${serviceName}/credits`);
  };

  /** Create order */
  createSmsCreditsByServiceName = (
    serviceName: string,
    body: { quantity: number }
  ): Promise<OrderOrder> => {
    return this.ovh.request('POST', `/order/sms/${serviceName}/credits`, body);
  };

  /** List available services */
  listTelephony = (): Promise<string[]> => {
    return this.ovh.request('GET', '/order/telephony');
  };

  /** List available services */
  listTelephonyLines = (): Promise<string[]> => {
    return this.ovh.request('GET', '/order/telephony/lines');
  };

  /** Get allowed options */
  getTelephonyLinesByServiceName = (serviceName: string): Promise<string[]> => {
    return this.ovh.request('GET', `/order/telephony/lines/${serviceName}`);
  };

  /** Get prices and contracts information */
  getTelephonyLinesAddSimultaneousLinesByServiceName = (
    serviceName: string
  ): Promise<OrderOrder> => {
    return this.ovh.request('GET', `/order/telephony/lines/${serviceName}/addSimultaneousLines`);
  };

  /** Create order */
  createTelephonyLinesAddSimultaneousLinesByServiceName = (
    serviceName: string,
    body: { billingAccount: string; quantity: number }
  ): Promise<OrderOrder> => {
    return this.ovh.request(
      'POST',
      `/order/telephony/lines/${serviceName}/addSimultaneousLines`,
      body
    );
  };

  /** Get prices and contracts information */
  getTelephonyLinesHardwareByServiceName = (serviceName: string): Promise<OrderOrder> => {
    return this.ovh.request('GET', `/order/telephony/lines/${serviceName}/hardware`);
  };

  /** Create order */
  createTelephonyLinesHardwareByServiceName = (
    serviceName: string,
    body: {
      hardware: string;
      mondialRelayId?: string;
      retractation: boolean;
      shippingContactId?: string;
    }
  ): Promise<OrderOrder> => {
    return this.ovh.request('POST', `/order/telephony/lines/${serviceName}/hardware`, body);
  };

  /** Get prices and contracts information */
  getTelephonyLinesUpdateSimultaneousChannelsByServiceName = (
    serviceName: string
  ): Promise<OrderOrder> => {
    return this.ovh.request(
      'GET',
      `/order/telephony/lines/${serviceName}/updateSimultaneousChannels`
    );
  };

  /** Create order */
  createTelephonyLinesUpdateSimultaneousChannelsByServiceName = (
    serviceName: string,
    body: { quantity: number }
  ): Promise<OrderOrder> => {
    return this.ovh.request(
      'POST',
      `/order/telephony/lines/${serviceName}/updateSimultaneousChannels`,
      body
    );
  };

  /** Get prices and contracts information */
  getTelephonyNew = (): Promise<OrderOrder> => {
    return this.ovh.request('GET', '/order/telephony/new');
  };

  /** Create order */
  createTelephonyNew = (): Promise<OrderOrder> => {
    return this.ovh.request('POST', '/order/telephony/new');
  };

  /** Get prices and contracts information */
  getTelephonySpareNew = (): Promise<OrderOrder> => {
    return this.ovh.request('GET', '/order/telephony/spare/new');
  };

  /** Create order */
  createTelephonySpareNew = (body: {
    brand: string;
    mondialRelayId?: string;
    quantity: number;
    shippingContactId: number;
  }): Promise<OrderOrder> => {
    return this.ovh.request('POST', '/order/telephony/spare/new', body);
  };

  /** List available services */
  listTelephonyTrunks = (): Promise<string[]> => {
    return this.ovh.request('GET', '/order/telephony/trunks');
  };

  /** Get allowed options */
  getTelephonyTrunksByServiceName = (serviceName: string): Promise<string[]> => {
    return this.ovh.request('GET', `/order/telephony/trunks/${serviceName}`);
  };

  /** Get prices and contracts information */
  getTelephonyTrunksAddSimultaneousLinesByServiceName = (
    serviceName: string
  ): Promise<OrderOrder> => {
    return this.ovh.request('GET', `/order/telephony/trunks/${serviceName}/addSimultaneousLines`);
  };

  /** Create order */
  createTelephonyTrunksAddSimultaneousLinesByServiceName = (
    serviceName: string,
    body: { billingAccount: string; quantity: number }
  ): Promise<OrderOrder> => {
    return this.ovh.request(
      'POST',
      `/order/telephony/trunks/${serviceName}/addSimultaneousLines`,
      body
    );
  };

  /** Get prices and contracts information */
  getTelephonyTrunksHardwareByServiceName = (serviceName: string): Promise<OrderOrder> => {
    return this.ovh.request('GET', `/order/telephony/trunks/${serviceName}/hardware`);
  };

  /** Create order */
  createTelephonyTrunksHardwareByServiceName = (
    serviceName: string,
    body: {
      hardware: string;
      mondialRelayId?: string;
      retractation: boolean;
      shippingContactId?: string;
    }
  ): Promise<OrderOrder> => {
    return this.ovh.request('POST', `/order/telephony/trunks/${serviceName}/hardware`, body);
  };

  /** Get prices and contracts information */
  getTelephonyTrunksUpdateSimultaneousChannelsByServiceName = (
    serviceName: string
  ): Promise<OrderOrder> => {
    return this.ovh.request(
      'GET',
      `/order/telephony/trunks/${serviceName}/updateSimultaneousChannels`
    );
  };

  /** Create order */
  createTelephonyTrunksUpdateSimultaneousChannelsByServiceName = (
    serviceName: string,
    body: { quantity: number }
  ): Promise<OrderOrder> => {
    return this.ovh.request(
      'POST',
      `/order/telephony/trunks/${serviceName}/updateSimultaneousChannels`,
      body
    );
  };

  /** Get allowed options */
  getTelephonyByBillingAccount = (billingAccount: string): Promise<string[]> => {
    return this.ovh.request('GET', `/order/telephony/${billingAccount}`);
  };

  /** Get prices and contracts information */
  getTelephonyAccessoriesByBillingAccount = (billingAccount: string): Promise<OrderOrder> => {
    return this.ovh.request('GET', `/order/telephony/${billingAccount}/accessories`);
  };

  /** Create order */
  createTelephonyAccessoriesByBillingAccount = (
    billingAccount: string,
    body: {
      accessories: string[];
      mondialRelayId?: string;
      retractation: boolean;
      shippingContactId: number;
    }
  ): Promise<OrderOrder> => {
    return this.ovh.request('POST', `/order/telephony/${billingAccount}/accessories`, body);
  };

  /** Get prices and contracts information */
  getTelephonyLineByBillingAccount = (billingAccount: string): Promise<OrderOrder> => {
    return this.ovh.request('GET', `/order/telephony/${billingAccount}/line`);
  };

  /** Create order */
  createTelephonyLineByBillingAccount = (
    billingAccount: string,
    body: {
      brand?: string;
      displayUniversalDirectories: boolean[];
      extraSimultaneousLines: number[];
      mondialRelayId?: string;
      offers: string[];
      ownerContactIds: number[];
      quantity: number;
      retractation: boolean;
      shippingContactId: number;
      types: TelephonyLineTypeEnum[];
      zones?: string[];
    }
  ): Promise<OrderOrder> => {
    return this.ovh.request('POST', `/order/telephony/${billingAccount}/line`, body);
  };

  /** Get prices and contracts information */
  getTelephonyNumberGeographicByBillingAccount = (billingAccount: string): Promise<OrderOrder> => {
    return this.ovh.request('GET', `/order/telephony/${billingAccount}/numberGeographic`);
  };

  /** Create order */
  createTelephonyNumberGeographicByBillingAccount = (
    billingAccount: string,
    body: {
      ape?: string;
      city: string;
      country: TelephonyNumberCountryEnum;
      displayUniversalDirectory: boolean;
      email?: string;
      firstname?: string;
      legalform: NichandleLegalFormEnum;
      name?: string;
      offer: TelephonyNumberOffer;
      organisation?: string;
      phone?: string;
      pool?: TelephonyNumberPoolEnum;
      retractation: boolean;
      siret?: string;
      socialNomination?: string;
      specificNumber?: string;
      streetName?: string;
      streetNumber?: string;
      zip?: string;
      zone: string;
    }
  ): Promise<OrderOrder> => {
    return this.ovh.request('POST', `/order/telephony/${billingAccount}/numberGeographic`, body);
  };

  /** Get prices and contracts information */
  getTelephonyNumberNogeographicByBillingAccount = (
    billingAccount: string
  ): Promise<OrderOrder> => {
    return this.ovh.request('GET', `/order/telephony/${billingAccount}/numberNogeographic`);
  };

  /** Create order */
  createTelephonyNumberNogeographicByBillingAccount = (
    billingAccount: string,
    body: {
      ape?: string;
      city?: string;
      country: TelephonyNumberCountryEnum;
      displayUniversalDirectory: boolean;
      email?: string;
      firstname?: string;
      legalform: NichandleLegalFormEnum;
      name?: string;
      offer: TelephonyNumberOffer;
      organisation?: string;
      phone?: string;
      pool?: TelephonyNumberPoolEnum;
      retractation: boolean;
      siret?: string;
      socialNomination?: string;
      specificNumber?: string;
      streetName?: string;
      streetNumber?: string;
      zip?: string;
    }
  ): Promise<OrderOrder> => {
    return this.ovh.request('POST', `/order/telephony/${billingAccount}/numberNogeographic`, body);
  };

  /** Get prices and contracts information */
  getTelephonyNumberSpecialByBillingAccount = (billingAccount: string): Promise<OrderOrder> => {
    return this.ovh.request('GET', `/order/telephony/${billingAccount}/numberSpecial`);
  };

  /** Create order */
  createTelephonyNumberSpecialByBillingAccount = (
    billingAccount: string,
    body: {
      addressExtra?: string;
      ape?: string;
      cedex?: string;
      city?: string;
      country: TelephonySpecialNumberCountryEnum;
      description?: string;
      displaySearchReverse?: boolean;
      displayUniversalDirectory: boolean;
      email?: string;
      firstname?: string;
      legalform: NichandleLegalFormEnum;
      name?: string;
      organisation?: string;
      phone?: string;
      pool?: TelephonyNumberPoolEnum;
      postBox?: string;
      range: string;
      retractation: boolean;
      siret: string;
      socialNomination: string;
      specificNumber?: string;
      streetName?: string;
      streetNumber?: string;
      streetNumberExtra?: string;
      streetType?: string;
      typology: TelephonyNumberSpecialTypologyEnum;
      urbanDistrict?: string;
      zip?: string;
    }
  ): Promise<OrderOrder> => {
    return this.ovh.request('POST', `/order/telephony/${billingAccount}/numberSpecial`, body);
  };

  /** Get prices and contracts information */
  getTelephonyPortabilityByBillingAccount = (billingAccount: string): Promise<OrderOrder> => {
    return this.ovh.request('GET', `/order/telephony/${billingAccount}/portability`);
  };

  /** Create order */
  createTelephonyPortabilityByBillingAccount = (
    billingAccount: string,
    body: {
      building?: string;
      callNumber: string;
      city: string;
      contactName?: string;
      contactNumber?: string;
      country: TelephonyPortabilityCountriesAvailable;
      desireDate?: Date;
      displayUniversalDirectory: boolean;
      door?: string;
      executeAsSoonAsPossible?: boolean;
      fiabilisation?: boolean;
      firstName?: string;
      floor?: number;
      lineToRedirectAliasTo?: string;
      listNumbers?: string;
      mobilePhone?: string;
      name: string;
      offer: TelephonyPortabilityOfferType;
      rio?: string;
      siret?: string;
      socialReason: TelephonyPortabilitySocialReason;
      specialNumberCategory?: TelephonyPortabilitySpecialNumberCategoryEnum;
      stair?: number;
      streetName: string;
      streetNumber: number;
      streetNumberExtra?: string;
      streetType?: string;
      type?: TelephonyPortabilityNumberType;
      zip: string;
    }
  ): Promise<OrderOrder> => {
    return this.ovh.request('POST', `/order/telephony/${billingAccount}/portability`, body);
  };

  /** Get prices and contracts information */
  getTelephonySecurityDepositByBillingAccount = (billingAccount: string): Promise<OrderOrder> => {
    return this.ovh.request('GET', `/order/telephony/${billingAccount}/securityDeposit`);
  };

  /** Create order */
  createTelephonySecurityDepositByBillingAccount = (
    billingAccount: string,
    body: { amount: TelephonySecurityDepositAmountsEnum }
  ): Promise<OrderOrder> => {
    return this.ovh.request('POST', `/order/telephony/${billingAccount}/securityDeposit`, body);
  };

  /** List available services */
  listUpgradeBaremetalPrivateBandwidth = (): Promise<string[]> => {
    return this.ovh.request('GET', '/order/upgrade/baremetalPrivateBandwidth');
  };

  /** Retrieve available offers to upgrade your service to */
  getUpgradeBaremetalPrivateBandwidthByServiceName = (
    serviceName: string
  ): Promise<OrderCartGenericProductDefinition[]> => {
    return this.ovh.request('GET', `/order/upgrade/baremetalPrivateBandwidth/${serviceName}`);
  };

  /** Get a provisional order for the selected upgrade of your service */
  getUpgradeBaremetalPrivateBandwidthByServiceNameAndPlanCode = (
    planCode: string,
    serviceName: string
  ): Promise<OrderUpgradeOperationAndOrder> => {
    return this.ovh.request(
      'GET',
      `/order/upgrade/baremetalPrivateBandwidth/${serviceName}/${planCode}`
    );
  };

  /** Perform the requested upgrade of your service */
  postUpgradeBaremetalPrivateBandwidthByServiceNameAndPlanCode = (
    planCode: string,
    serviceName: string,
    body: { autoPayWithPreferredPaymentMethod?: boolean; quantity: number }
  ): Promise<OrderUpgradeOperationAndOrder> => {
    return this.ovh.request(
      'POST',
      `/order/upgrade/baremetalPrivateBandwidth/${serviceName}/${planCode}`,
      body
    );
  };

  /** List available services */
  listUpgradeBaremetalPublicBandwidth = (): Promise<string[]> => {
    return this.ovh.request('GET', '/order/upgrade/baremetalPublicBandwidth');
  };

  /** Retrieve available offers to upgrade your service to */
  getUpgradeBaremetalPublicBandwidthByServiceName = (
    serviceName: string
  ): Promise<OrderCartGenericProductDefinition[]> => {
    return this.ovh.request('GET', `/order/upgrade/baremetalPublicBandwidth/${serviceName}`);
  };

  /** Get a provisional order for the selected upgrade of your service */
  getUpgradeBaremetalPublicBandwidthByServiceNameAndPlanCode = (
    planCode: string,
    serviceName: string
  ): Promise<OrderUpgradeOperationAndOrder> => {
    return this.ovh.request(
      'GET',
      `/order/upgrade/baremetalPublicBandwidth/${serviceName}/${planCode}`
    );
  };

  /** Perform the requested upgrade of your service */
  postUpgradeBaremetalPublicBandwidthByServiceNameAndPlanCode = (
    planCode: string,
    serviceName: string,
    body: { autoPayWithPreferredPaymentMethod?: boolean; quantity: number }
  ): Promise<OrderUpgradeOperationAndOrder> => {
    return this.ovh.request(
      'POST',
      `/order/upgrade/baremetalPublicBandwidth/${serviceName}/${planCode}`,
      body
    );
  };

  /** List available services */
  listUpgradeCephaas = (): Promise<string[]> => {
    return this.ovh.request('GET', '/order/upgrade/cephaas');
  };

  /** Retrieve available offers to upgrade your service to */
  getUpgradeCephaasByServiceName = (
    serviceName: string
  ): Promise<OrderCartGenericProductDefinition[]> => {
    return this.ovh.request('GET', `/order/upgrade/cephaas/${serviceName}`);
  };

  /** Get a provisional order for the selected upgrade of your service */
  getUpgradeCephaasByServiceNameAndPlanCode = (
    planCode: string,
    serviceName: string
  ): Promise<OrderUpgradeOperationAndOrder> => {
    return this.ovh.request('GET', `/order/upgrade/cephaas/${serviceName}/${planCode}`);
  };

  /** Perform the requested upgrade of your service */
  postUpgradeCephaasByServiceNameAndPlanCode = (
    planCode: string,
    serviceName: string,
    body: { autoPayWithPreferredPaymentMethod?: boolean; quantity: number }
  ): Promise<OrderUpgradeOperationAndOrder> => {
    return this.ovh.request('POST', `/order/upgrade/cephaas/${serviceName}/${planCode}`, body);
  };

  /** List available services */
  listUpgradeCloudDB = (): Promise<string[]> => {
    return this.ovh.request('GET', '/order/upgrade/cloudDB');
  };

  /** Retrieve available offers to upgrade your service to */
  getUpgradeCloudDBByDomain = (domain: string): Promise<OrderCartGenericProductDefinition[]> => {
    return this.ovh.request('GET', `/order/upgrade/cloudDB/${domain}`);
  };

  /** Get a provisional order for the selected upgrade of your service */
  getUpgradeCloudDBByDomainAndPlanCode = (
    domain: string,
    planCode: string
  ): Promise<OrderUpgradeOperationAndOrder> => {
    return this.ovh.request('GET', `/order/upgrade/cloudDB/${domain}/${planCode}`);
  };

  /** Perform the requested upgrade of your service */
  postUpgradeCloudDBByDomainAndPlanCode = (
    domain: string,
    planCode: string,
    body: { autoPayWithPreferredPaymentMethod?: boolean; quantity: number }
  ): Promise<OrderUpgradeOperationAndOrder> => {
    return this.ovh.request('POST', `/order/upgrade/cloudDB/${domain}/${planCode}`, body);
  };

  /** List available services */
  listUpgradeEmailDomain = (): Promise<string[]> => {
    return this.ovh.request('GET', '/order/upgrade/emailDomain');
  };

  /** Retrieve available offers to upgrade your service to */
  getUpgradeEmailDomainByServiceName = (
    serviceName: string
  ): Promise<OrderCartGenericProductDefinition[]> => {
    return this.ovh.request('GET', `/order/upgrade/emailDomain/${serviceName}`);
  };

  /** Get a provisional order for the selected upgrade of your service */
  getUpgradeEmailDomainByServiceNameAndPlanCode = (
    planCode: string,
    serviceName: string
  ): Promise<OrderUpgradeOperationAndOrder> => {
    return this.ovh.request('GET', `/order/upgrade/emailDomain/${serviceName}/${planCode}`);
  };

  /** Perform the requested upgrade of your service */
  postUpgradeEmailDomainByServiceNameAndPlanCode = (
    planCode: string,
    serviceName: string,
    body: { autoPayWithPreferredPaymentMethod?: boolean; quantity: number }
  ): Promise<OrderUpgradeOperationAndOrder> => {
    return this.ovh.request('POST', `/order/upgrade/emailDomain/${serviceName}/${planCode}`, body);
  };

  /** List available services */
  listUpgradeIpLoadbalancing = (): Promise<string[]> => {
    return this.ovh.request('GET', '/order/upgrade/ipLoadbalancing');
  };

  /** Retrieve available offers to upgrade your service to */
  getUpgradeIpLoadbalancingByServiceName = (
    serviceName: string
  ): Promise<OrderCartGenericProductDefinition[]> => {
    return this.ovh.request('GET', `/order/upgrade/ipLoadbalancing/${serviceName}`);
  };

  /** Get a provisional order for the selected upgrade of your service */
  getUpgradeIpLoadbalancingByServiceNameAndPlanCode = (
    planCode: string,
    serviceName: string
  ): Promise<OrderUpgradeOperationAndOrder> => {
    return this.ovh.request('GET', `/order/upgrade/ipLoadbalancing/${serviceName}/${planCode}`);
  };

  /** Perform the requested upgrade of your service */
  postUpgradeIpLoadbalancingByServiceNameAndPlanCode = (
    planCode: string,
    serviceName: string,
    body: { autoPayWithPreferredPaymentMethod?: boolean; quantity: number }
  ): Promise<OrderUpgradeOperationAndOrder> => {
    return this.ovh.request(
      'POST',
      `/order/upgrade/ipLoadbalancing/${serviceName}/${planCode}`,
      body
    );
  };

  /** List available services */
  listUpgradeLicensePlesk = (): Promise<string[]> => {
    return this.ovh.request('GET', '/order/upgrade/licensePlesk');
  };

  /** Retrieve available offers to upgrade your service to */
  getUpgradeLicensePleskByServiceName = (
    serviceName: string
  ): Promise<OrderCartGenericProductDefinition[]> => {
    return this.ovh.request('GET', `/order/upgrade/licensePlesk/${serviceName}`);
  };

  /** Get a provisional order for the selected upgrade of your service */
  getUpgradeLicensePleskByServiceNameAndPlanCode = (
    planCode: string,
    serviceName: string
  ): Promise<OrderUpgradeOperationAndOrder> => {
    return this.ovh.request('GET', `/order/upgrade/licensePlesk/${serviceName}/${planCode}`);
  };

  /** Perform the requested upgrade of your service */
  postUpgradeLicensePleskByServiceNameAndPlanCode = (
    planCode: string,
    serviceName: string,
    body: { autoPayWithPreferredPaymentMethod?: boolean; quantity: number }
  ): Promise<OrderUpgradeOperationAndOrder> => {
    return this.ovh.request('POST', `/order/upgrade/licensePlesk/${serviceName}/${planCode}`, body);
  };

  /** List available services */
  listUpgradeLicensecPanel = (): Promise<string[]> => {
    return this.ovh.request('GET', '/order/upgrade/licensecPanel');
  };

  /** Retrieve available offers to upgrade your service to */
  getUpgradeLicensecPanelByServiceName = (
    serviceName: string
  ): Promise<OrderCartGenericProductDefinition[]> => {
    return this.ovh.request('GET', `/order/upgrade/licensecPanel/${serviceName}`);
  };

  /** Get a provisional order for the selected upgrade of your service */
  getUpgradeLicensecPanelByServiceNameAndPlanCode = (
    planCode: string,
    serviceName: string
  ): Promise<OrderUpgradeOperationAndOrder> => {
    return this.ovh.request('GET', `/order/upgrade/licensecPanel/${serviceName}/${planCode}`);
  };

  /** Perform the requested upgrade of your service */
  postUpgradeLicensecPanelByServiceNameAndPlanCode = (
    planCode: string,
    serviceName: string,
    body: { autoPayWithPreferredPaymentMethod?: boolean; quantity: number }
  ): Promise<OrderUpgradeOperationAndOrder> => {
    return this.ovh.request(
      'POST',
      `/order/upgrade/licensecPanel/${serviceName}/${planCode}`,
      body
    );
  };

  /** List available services */
  listUpgradeLogs = (): Promise<string[]> => {
    return this.ovh.request('GET', '/order/upgrade/logs');
  };

  /** Retrieve available offers to upgrade your service to */
  getUpgradeLogsByServiceName = (
    serviceName: string
  ): Promise<OrderCartGenericProductDefinition[]> => {
    return this.ovh.request('GET', `/order/upgrade/logs/${serviceName}`);
  };

  /** Get a provisional order for the selected upgrade of your service */
  getUpgradeLogsByServiceNameAndPlanCode = (
    planCode: string,
    serviceName: string
  ): Promise<OrderUpgradeOperationAndOrder> => {
    return this.ovh.request('GET', `/order/upgrade/logs/${serviceName}/${planCode}`);
  };

  /** Perform the requested upgrade of your service */
  postUpgradeLogsByServiceNameAndPlanCode = (
    planCode: string,
    serviceName: string,
    body: { autoPayWithPreferredPaymentMethod?: boolean; quantity: number }
  ): Promise<OrderUpgradeOperationAndOrder> => {
    return this.ovh.request('POST', `/order/upgrade/logs/${serviceName}/${planCode}`, body);
  };

  /** List available services */
  listUpgradeMetrics = (): Promise<string[]> => {
    return this.ovh.request('GET', '/order/upgrade/metrics');
  };

  /** Retrieve available offers to upgrade your service to */
  getUpgradeMetricsByServiceName = (
    serviceName: string
  ): Promise<OrderCartGenericProductDefinition[]> => {
    return this.ovh.request('GET', `/order/upgrade/metrics/${serviceName}`);
  };

  /** Get a provisional order for the selected upgrade of your service */
  getUpgradeMetricsByServiceNameAndPlanCode = (
    planCode: string,
    serviceName: string
  ): Promise<OrderUpgradeOperationAndOrder> => {
    return this.ovh.request('GET', `/order/upgrade/metrics/${serviceName}/${planCode}`);
  };

  /** Perform the requested upgrade of your service */
  postUpgradeMetricsByServiceNameAndPlanCode = (
    planCode: string,
    serviceName: string,
    body: { autoPayWithPreferredPaymentMethod?: boolean; quantity: number }
  ): Promise<OrderUpgradeOperationAndOrder> => {
    return this.ovh.request('POST', `/order/upgrade/metrics/${serviceName}/${planCode}`, body);
  };

  /** List available services */
  listUpgradeMicrosoftExchange = (): Promise<string[]> => {
    return this.ovh.request('GET', '/order/upgrade/microsoftExchange');
  };

  /** Retrieve available offers to upgrade your service to */
  getUpgradeMicrosoftExchangeByServiceName = (
    serviceName: string
  ): Promise<OrderCartGenericProductDefinition[]> => {
    return this.ovh.request('GET', `/order/upgrade/microsoftExchange/${serviceName}`);
  };

  /** Get a provisional order for the selected upgrade of your service */
  getUpgradeMicrosoftExchangeByServiceNameAndPlanCode = (
    planCode: string,
    serviceName: string
  ): Promise<OrderUpgradeOperationAndOrder> => {
    return this.ovh.request('GET', `/order/upgrade/microsoftExchange/${serviceName}/${planCode}`);
  };

  /** Perform the requested upgrade of your service */
  postUpgradeMicrosoftExchangeByServiceNameAndPlanCode = (
    planCode: string,
    serviceName: string,
    body: { autoPayWithPreferredPaymentMethod?: boolean; quantity: number }
  ): Promise<OrderUpgradeOperationAndOrder> => {
    return this.ovh.request(
      'POST',
      `/order/upgrade/microsoftExchange/${serviceName}/${planCode}`,
      body
    );
  };

  /** List available services */
  listUpgradePrivateCloud = (): Promise<string[]> => {
    return this.ovh.request('GET', '/order/upgrade/privateCloud');
  };

  /** Retrieve available offers to upgrade your service to */
  getUpgradePrivateCloudByServiceName = (
    serviceName: string
  ): Promise<OrderCartGenericProductDefinition[]> => {
    return this.ovh.request('GET', `/order/upgrade/privateCloud/${serviceName}`);
  };

  /** Get a provisional order for the selected upgrade of your service */
  getUpgradePrivateCloudByServiceNameAndPlanCode = (
    planCode: string,
    serviceName: string
  ): Promise<OrderUpgradeOperationAndOrder> => {
    return this.ovh.request('GET', `/order/upgrade/privateCloud/${serviceName}/${planCode}`);
  };

  /** Perform the requested upgrade of your service */
  postUpgradePrivateCloudByServiceNameAndPlanCode = (
    planCode: string,
    serviceName: string,
    body: { autoPayWithPreferredPaymentMethod?: boolean; quantity: number }
  ): Promise<OrderUpgradeOperationAndOrder> => {
    return this.ovh.request('POST', `/order/upgrade/privateCloud/${serviceName}/${planCode}`, body);
  };

  /** List available services */
  listUpgradePrivateCloudManagementFee = (): Promise<string[]> => {
    return this.ovh.request('GET', '/order/upgrade/privateCloudManagementFee');
  };

  /** Retrieve available offers to upgrade your service to */
  getUpgradePrivateCloudManagementFeeByServiceName = (
    serviceName: string
  ): Promise<OrderCartGenericProductDefinition[]> => {
    return this.ovh.request('GET', `/order/upgrade/privateCloudManagementFee/${serviceName}`);
  };

  /** Get a provisional order for the selected upgrade of your service */
  getUpgradePrivateCloudManagementFeeByServiceNameAndPlanCode = (
    planCode: string,
    serviceName: string
  ): Promise<OrderUpgradeOperationAndOrder> => {
    return this.ovh.request(
      'GET',
      `/order/upgrade/privateCloudManagementFee/${serviceName}/${planCode}`
    );
  };

  /** Perform the requested upgrade of your service */
  postUpgradePrivateCloudManagementFeeByServiceNameAndPlanCode = (
    planCode: string,
    serviceName: string,
    body: { autoPayWithPreferredPaymentMethod?: boolean; quantity: number }
  ): Promise<OrderUpgradeOperationAndOrder> => {
    return this.ovh.request(
      'POST',
      `/order/upgrade/privateCloudManagementFee/${serviceName}/${planCode}`,
      body
    );
  };

  /** List available services */
  listUpgradePrivateSQL = (): Promise<string[]> => {
    return this.ovh.request('GET', '/order/upgrade/privateSQL');
  };

  /** Retrieve available offers to upgrade your service to */
  getUpgradePrivateSQLByDomain = (domain: string): Promise<OrderCartGenericProductDefinition[]> => {
    return this.ovh.request('GET', `/order/upgrade/privateSQL/${domain}`);
  };

  /** Get a provisional order for the selected upgrade of your service */
  getUpgradePrivateSQLByDomainAndPlanCode = (
    domain: string,
    planCode: string
  ): Promise<OrderUpgradeOperationAndOrder> => {
    return this.ovh.request('GET', `/order/upgrade/privateSQL/${domain}/${planCode}`);
  };

  /** Perform the requested upgrade of your service */
  postUpgradePrivateSQLByDomainAndPlanCode = (
    domain: string,
    planCode: string,
    body: { autoPayWithPreferredPaymentMethod?: boolean; quantity: number }
  ): Promise<OrderUpgradeOperationAndOrder> => {
    return this.ovh.request('POST', `/order/upgrade/privateSQL/${domain}/${planCode}`, body);
  };

  /** List available services */
  listUpgradeSslGateway = (): Promise<string[]> => {
    return this.ovh.request('GET', '/order/upgrade/sslGateway');
  };

  /** Retrieve available offers to upgrade your service to */
  getUpgradeSslGatewayByServiceName = (
    serviceName: string
  ): Promise<OrderCartGenericProductDefinition[]> => {
    return this.ovh.request('GET', `/order/upgrade/sslGateway/${serviceName}`);
  };

  /** Get a provisional order for the selected upgrade of your service */
  getUpgradeSslGatewayByServiceNameAndPlanCode = (
    planCode: string,
    serviceName: string
  ): Promise<OrderUpgradeOperationAndOrder> => {
    return this.ovh.request('GET', `/order/upgrade/sslGateway/${serviceName}/${planCode}`);
  };

  /** Perform the requested upgrade of your service */
  postUpgradeSslGatewayByServiceNameAndPlanCode = (
    planCode: string,
    serviceName: string,
    body: { autoPayWithPreferredPaymentMethod?: boolean; quantity: number }
  ): Promise<OrderUpgradeOperationAndOrder> => {
    return this.ovh.request('POST', `/order/upgrade/sslGateway/${serviceName}/${planCode}`, body);
  };

  /** List available services */
  listUpgradeVps = (): Promise<string[]> => {
    return this.ovh.request('GET', '/order/upgrade/vps');
  };

  /** Retrieve available offers to upgrade your service to */
  getUpgradeVpsByServiceName = (
    serviceName: string
  ): Promise<OrderCartGenericProductDefinition[]> => {
    return this.ovh.request('GET', `/order/upgrade/vps/${serviceName}`);
  };

  /** Get a provisional order for the selected upgrade of your service */
  getUpgradeVpsByServiceNameAndPlanCode = (
    planCode: string,
    serviceName: string
  ): Promise<OrderUpgradeOperationAndOrder> => {
    return this.ovh.request('GET', `/order/upgrade/vps/${serviceName}/${planCode}`);
  };

  /** Perform the requested upgrade of your service */
  postUpgradeVpsByServiceNameAndPlanCode = (
    planCode: string,
    serviceName: string,
    body: { autoPayWithPreferredPaymentMethod?: boolean; quantity: number }
  ): Promise<OrderUpgradeOperationAndOrder> => {
    return this.ovh.request('POST', `/order/upgrade/vps/${serviceName}/${planCode}`, body);
  };

  /** List available services */
  listUpgradeVpsAdditionalDisk = (): Promise<string[]> => {
    return this.ovh.request('GET', '/order/upgrade/vpsAdditionalDisk');
  };

  /** Retrieve available offers to upgrade your service to */
  getUpgradeVpsAdditionalDiskByServiceName = (
    serviceName: string
  ): Promise<OrderCartGenericProductDefinition[]> => {
    return this.ovh.request('GET', `/order/upgrade/vpsAdditionalDisk/${serviceName}`);
  };

  /** Get a provisional order for the selected upgrade of your service */
  getUpgradeVpsAdditionalDiskByServiceNameAndPlanCode = (
    planCode: string,
    serviceName: string
  ): Promise<OrderUpgradeOperationAndOrder> => {
    return this.ovh.request('GET', `/order/upgrade/vpsAdditionalDisk/${serviceName}/${planCode}`);
  };

  /** Perform the requested upgrade of your service */
  postUpgradeVpsAdditionalDiskByServiceNameAndPlanCode = (
    planCode: string,
    serviceName: string,
    body: { autoPayWithPreferredPaymentMethod?: boolean; quantity: number }
  ): Promise<OrderUpgradeOperationAndOrder> => {
    return this.ovh.request(
      'POST',
      `/order/upgrade/vpsAdditionalDisk/${serviceName}/${planCode}`,
      body
    );
  };

  /** List available services */
  listUpgradeWebHosting = (): Promise<string[]> => {
    return this.ovh.request('GET', '/order/upgrade/webHosting');
  };

  /** Retrieve available offers to upgrade your service to */
  getUpgradeWebHostingByServiceName = (
    serviceName: string
  ): Promise<OrderCartGenericProductDefinition[]> => {
    return this.ovh.request('GET', `/order/upgrade/webHosting/${serviceName}`);
  };

  /** Get a provisional order for the selected upgrade of your service */
  getUpgradeWebHostingByServiceNameAndPlanCode = (
    planCode: string,
    serviceName: string
  ): Promise<OrderUpgradeOperationAndOrder> => {
    return this.ovh.request('GET', `/order/upgrade/webHosting/${serviceName}/${planCode}`);
  };

  /** Perform the requested upgrade of your service */
  postUpgradeWebHostingByServiceNameAndPlanCode = (
    planCode: string,
    serviceName: string,
    body: { autoPayWithPreferredPaymentMethod?: boolean; quantity: number }
  ): Promise<OrderUpgradeOperationAndOrder> => {
    return this.ovh.request('POST', `/order/upgrade/webHosting/${serviceName}/${planCode}`, body);
  };

  /** List available services */
  listUpgradeWebPaaS = (): Promise<string[]> => {
    return this.ovh.request('GET', '/order/upgrade/webPaaS');
  };

  /** Retrieve available offers to upgrade your service to */
  getUpgradeWebPaaSByServiceName = (
    serviceName: string
  ): Promise<OrderCartGenericProductDefinition[]> => {
    return this.ovh.request('GET', `/order/upgrade/webPaaS/${serviceName}`);
  };

  /** Get a provisional order for the selected upgrade of your service */
  getUpgradeWebPaaSByServiceNameAndPlanCode = (
    planCode: string,
    serviceName: string
  ): Promise<OrderUpgradeOperationAndOrder> => {
    return this.ovh.request('GET', `/order/upgrade/webPaaS/${serviceName}/${planCode}`);
  };

  /** Perform the requested upgrade of your service */
  postUpgradeWebPaaSByServiceNameAndPlanCode = (
    planCode: string,
    serviceName: string,
    body: { autoPayWithPreferredPaymentMethod?: boolean; quantity: number }
  ): Promise<OrderUpgradeOperationAndOrder> => {
    return this.ovh.request('POST', `/order/upgrade/webPaaS/${serviceName}/${planCode}`, body);
  };

  /** List available services */
  listVeeamCloudConnect = (): Promise<string[]> => {
    return this.ovh.request('GET', '/order/veeamCloudConnect');
  };

  /** Get allowed options */
  getVeeamCloudConnectByServiceName = (serviceName: string): Promise<string[]> => {
    return this.ovh.request('GET', `/order/veeamCloudConnect/${serviceName}`);
  };

  /** Get allowed durations for 'upgrade' option */
  getVeeamCloudConnectUpgradeByServiceName = (serviceName: string): Promise<string[]> => {
    return this.ovh.request('GET', `/order/veeamCloudConnect/${serviceName}/upgrade`);
  };

  /** Get prices and contracts information */
  getVeeamCloudConnectUpgradeByServiceNameAndDuration = (
    duration: string,
    serviceName: string
  ): Promise<OrderOrder> => {
    return this.ovh.request('GET', `/order/veeamCloudConnect/${serviceName}/upgrade/${duration}`);
  };

  /** Create order */
  createVeeamCloudConnectUpgradeByServiceNameAndDuration = (
    duration: string,
    serviceName: string,
    body: { offer: VeeamCloudConnectOffer }
  ): Promise<OrderOrder> => {
    return this.ovh.request(
      'POST',
      `/order/veeamCloudConnect/${serviceName}/upgrade/${duration}`,
      body
    );
  };

  /** List available services */
  listVps = (): Promise<string[]> => {
    return this.ovh.request('GET', '/order/vps');
  };

  /** Get allowed options */
  getVpsByServiceName = (serviceName: string): Promise<string[]> => {
    return this.ovh.request('GET', `/order/vps/${serviceName}`);
  };

  /** Get allowed durations for 'additionalDisk' option */
  getVpsAdditionalDiskByServiceName = (serviceName: string): Promise<string[]> => {
    return this.ovh.request('GET', `/order/vps/${serviceName}/additionalDisk`);
  };

  /** Get prices and contracts information */
  getVpsAdditionalDiskByServiceNameAndDuration = (
    duration: string,
    serviceName: string
  ): Promise<OrderOrder> => {
    return this.ovh.request('GET', `/order/vps/${serviceName}/additionalDisk/${duration}`);
  };

  /** Create order */
  createVpsAdditionalDiskByServiceNameAndDuration = (
    duration: string,
    serviceName: string,
    body: { additionalDiskSize: VpsAdditionalDiskAdditionalDiskSizeEnum }
  ): Promise<OrderOrder> => {
    return this.ovh.request('POST', `/order/vps/${serviceName}/additionalDisk/${duration}`, body);
  };

  /** Get allowed durations for 'automatedBackup' option */
  getVpsAutomatedBackupByServiceName = (serviceName: string): Promise<string[]> => {
    return this.ovh.request('GET', `/order/vps/${serviceName}/automatedBackup`);
  };

  /** Get prices and contracts information */
  getVpsAutomatedBackupByServiceNameAndDuration = (
    duration: string,
    serviceName: string
  ): Promise<OrderOrder> => {
    return this.ovh.request('GET', `/order/vps/${serviceName}/automatedBackup/${duration}`);
  };

  /** Create order */
  createVpsAutomatedBackupByServiceNameAndDuration = (
    duration: string,
    serviceName: string
  ): Promise<OrderOrder> => {
    return this.ovh.request('POST', `/order/vps/${serviceName}/automatedBackup/${duration}`);
  };

  /** Get allowed durations for 'cpanel' option */
  getVpsCpanelByServiceName = (serviceName: string): Promise<string[]> => {
    return this.ovh.request('GET', `/order/vps/${serviceName}/cpanel`);
  };

  /** Get prices and contracts information */
  getVpsCpanelByServiceNameAndDuration = (
    duration: string,
    serviceName: string
  ): Promise<OrderOrder> => {
    return this.ovh.request('GET', `/order/vps/${serviceName}/cpanel/${duration}`);
  };

  /** Create order */
  createVpsCpanelByServiceNameAndDuration = (
    duration: string,
    serviceName: string
  ): Promise<OrderOrder> => {
    return this.ovh.request('POST', `/order/vps/${serviceName}/cpanel/${duration}`);
  };

  /** Get allowed durations for 'ftpbackup' option */
  getVpsFtpbackupByServiceName = (serviceName: string): Promise<string[]> => {
    return this.ovh.request('GET', `/order/vps/${serviceName}/ftpbackup`);
  };

  /** Get prices and contracts information */
  getVpsFtpbackupByServiceNameAndDuration = (
    duration: string,
    serviceName: string
  ): Promise<OrderOrder> => {
    return this.ovh.request('GET', `/order/vps/${serviceName}/ftpbackup/${duration}`);
  };

  /** Create order */
  createVpsFtpbackupByServiceNameAndDuration = (
    duration: string,
    serviceName: string
  ): Promise<OrderOrder> => {
    return this.ovh.request('POST', `/order/vps/${serviceName}/ftpbackup/${duration}`);
  };

  /** Get allowed durations for 'plesk' option */
  getVpsPleskByServiceName = (serviceName: string): Promise<string[]> => {
    return this.ovh.request('GET', `/order/vps/${serviceName}/plesk`);
  };

  /** Get prices and contracts information */
  getVpsPleskByServiceNameAndDuration = (
    duration: string,
    serviceName: string
  ): Promise<OrderOrder> => {
    return this.ovh.request('GET', `/order/vps/${serviceName}/plesk/${duration}`);
  };

  /** Create order */
  createVpsPleskByServiceNameAndDuration = (
    duration: string,
    serviceName: string,
    body: { domainNumber: VpsPleskLicenseDomainNumberEnum }
  ): Promise<OrderOrder> => {
    return this.ovh.request('POST', `/order/vps/${serviceName}/plesk/${duration}`, body);
  };

  /** Get allowed durations for 'snapshot' option */
  getVpsSnapshotByServiceName = (serviceName: string): Promise<string[]> => {
    return this.ovh.request('GET', `/order/vps/${serviceName}/snapshot`);
  };

  /** Get prices and contracts information */
  getVpsSnapshotByServiceNameAndDuration = (
    duration: string,
    serviceName: string
  ): Promise<OrderOrder> => {
    return this.ovh.request('GET', `/order/vps/${serviceName}/snapshot/${duration}`);
  };

  /** Create order */
  createVpsSnapshotByServiceNameAndDuration = (
    duration: string,
    serviceName: string
  ): Promise<OrderOrder> => {
    return this.ovh.request('POST', `/order/vps/${serviceName}/snapshot/${duration}`);
  };

  /** Get allowed durations for 'upgrade' option */
  getVpsUpgradeByServiceName = (serviceName: string): Promise<string[]> => {
    return this.ovh.request('GET', `/order/vps/${serviceName}/upgrade`);
  };

  /** Get prices and contracts information */
  getVpsUpgradeByServiceNameAndDuration = (
    duration: string,
    serviceName: string
  ): Promise<OrderOrder> => {
    return this.ovh.request('GET', `/order/vps/${serviceName}/upgrade/${duration}`);
  };

  /** Create order */
  createVpsUpgradeByServiceNameAndDuration = (
    duration: string,
    serviceName: string,
    body: { model: string }
  ): Promise<OrderOrder> => {
    return this.ovh.request('POST', `/order/vps/${serviceName}/upgrade/${duration}`, body);
  };

  /** Get allowed durations for 'veeam' option */
  getVpsVeeamByServiceName = (serviceName: string): Promise<string[]> => {
    return this.ovh.request('GET', `/order/vps/${serviceName}/veeam`);
  };

  /** Get prices and contracts information */
  getVpsVeeamByServiceNameAndDuration = (
    duration: string,
    serviceName: string
  ): Promise<OrderOrder> => {
    return this.ovh.request('GET', `/order/vps/${serviceName}/veeam/${duration}`);
  };

  /** Create order */
  createVpsVeeamByServiceNameAndDuration = (
    duration: string,
    serviceName: string
  ): Promise<OrderOrder> => {
    return this.ovh.request('POST', `/order/vps/${serviceName}/veeam/${duration}`);
  };

  /** Get allowed durations for 'windows' option */
  getVpsWindowsByServiceName = (serviceName: string): Promise<string[]> => {
    return this.ovh.request('GET', `/order/vps/${serviceName}/windows`);
  };

  /** Get prices and contracts information */
  getVpsWindowsByServiceNameAndDuration = (
    duration: string,
    serviceName: string
  ): Promise<OrderOrder> => {
    return this.ovh.request('GET', `/order/vps/${serviceName}/windows/${duration}`);
  };

  /** Create order */
  createVpsWindowsByServiceNameAndDuration = (
    duration: string,
    serviceName: string
  ): Promise<OrderOrder> => {
    return this.ovh.request('POST', `/order/vps/${serviceName}/windows/${duration}`);
  };

  /** List available services */
  listVrack = (): Promise<string[]> => {
    return this.ovh.request('GET', '/order/vrack');
  };

  /** Get prices and contracts information */
  getVrackNew = (): Promise<OrderOrder> => {
    return this.ovh.request('GET', '/order/vrack/new');
  };

  /** Create order */
  createVrackNew = (body: { quantity?: number }): Promise<OrderOrder> => {
    return this.ovh.request('POST', '/order/vrack/new', body);
  };

  /** Get allowed options */
  getVrackByServiceName = (serviceName: string): Promise<string[]> => {
    return this.ovh.request('GET', `/order/vrack/${serviceName}`);
  };

  /** Get prices and contracts information */
  getXdslSpareNew = (): Promise<OrderOrder> => {
    return this.ovh.request('GET', '/order/xdsl/spare/new');
  };

  /** Create order */
  createXdslSpareNew = (body: {
    brand: string;
    mondialRelayId?: string;
    quantity: number;
    shippingContactId: number;
  }): Promise<OrderOrder> => {
    return this.ovh.request('POST', '/order/xdsl/spare/new', body);
  };
}

export { OrderHandler };
